const themeData = {
  "metadata": {
    "colorSchemeName": "Light gray",
    "colorSchemeId": "hig-light-gray",
    "className": "hig--light-gray-theme",
    "densityId": "medium-density",
    "densityName": "Medium density",
    "name": "Light gray, Medium density",
    "fileName": "lightGrayMediumDensityTheme",
    "id": "hig-light-gray-medium-density",
    "__deprecated__": {
      "basics.colors.black": {
        "equivalent": "basics.colors.primary.black"
      },
      "basics.colors.white": {
        "equivalent": "basics.colors.primary.white"
      },
      "basics.colors.autodeskBlue100": {
        "equivalent": "basics.colors.primary.autodeskBlue.100"
      },
      "basics.colors.autodeskBlue200": {
        "equivalent": "basics.colors.primary.autodeskBlue.200"
      },
      "basics.colors.autodeskBlue300": {
        "equivalent": "basics.colors.primary.autodeskBlue.300"
      },
      "basics.colors.autodeskBlue400": {
        "equivalent": "basics.colors.primary.autodeskBlue.400"
      },
      "basics.colors.autodeskBlue500": {
        "equivalent": "basics.colors.primary.autodeskBlue.500"
      },
      "basics.colors.autodeskBlue600": {
        "equivalent": "basics.colors.primary.autodeskBlue.600"
      },
      "basics.colors.autodeskBlue700": {
        "equivalent": "basics.colors.primary.autodeskBlue.700"
      },
      "basics.colors.autodeskBlue800": {
        "equivalent": "basics.colors.primary.autodeskBlue.800"
      },
      "basics.colors.autodeskBlue900": {
        "equivalent": "basics.colors.primary.autodeskBlue.900"
      },
      "basics.colors.charcoal100": {
        "equivalent": "basics.colors.primary.charcoal.100"
      },
      "basics.colors.charcoal200": {
        "equivalent": "basics.colors.primary.charcoal.200"
      },
      "basics.colors.charcoal300": {
        "equivalent": "basics.colors.primary.charcoal.300"
      },
      "basics.colors.charcoal400": {
        "equivalent": "basics.colors.primary.charcoal.400"
      },
      "basics.colors.charcoal500": {
        "equivalent": "basics.colors.primary.charcoal.500"
      },
      "basics.colors.charcoal600": {
        "equivalent": "basics.colors.primary.charcoal.600"
      },
      "basics.colors.charcoal700": {
        "equivalent": "basics.colors.primary.charcoal.700"
      },
      "basics.colors.charcoal800": {
        "equivalent": "basics.colors.primary.charcoal.800"
      },
      "basics.colors.charcoal900": {
        "equivalent": "basics.colors.primary.charcoal.900"
      },
      "basics.colors.darkBlue100": {
        "equivalent": "basics.colors.secondary.darkBlue.100"
      },
      "basics.colors.darkBlue200": {
        "equivalent": "basics.colors.secondary.darkBlue.200"
      },
      "basics.colors.darkBlue300": {
        "equivalent": "basics.colors.secondary.darkBlue.300"
      },
      "basics.colors.darkBlue400": {
        "equivalent": "basics.colors.secondary.darkBlue.400"
      },
      "basics.colors.darkBlue500": {
        "equivalent": "basics.colors.secondary.darkBlue.500"
      },
      "basics.colors.darkBlue600": {
        "equivalent": "basics.colors.secondary.darkBlue.600"
      },
      "basics.colors.darkBlue700": {
        "equivalent": "basics.colors.secondary.darkBlue.700"
      },
      "basics.colors.darkBlue800": {
        "equivalent": "basics.colors.secondary.darkBlue.800"
      },
      "basics.colors.darkBlue900": {
        "equivalent": "basics.colors.secondary.darkBlue.900"
      },
      "basics.colors.green100": {
        "equivalent": "basics.colors.secondary.green.100"
      },
      "basics.colors.green200": {
        "equivalent": "basics.colors.secondary.green.200"
      },
      "basics.colors.green300": {
        "equivalent": "basics.colors.secondary.green.300"
      },
      "basics.colors.green400": {
        "equivalent": "basics.colors.secondary.green.400"
      },
      "basics.colors.green500": {
        "equivalent": "basics.colors.secondary.green.500"
      },
      "basics.colors.green600": {
        "equivalent": "basics.colors.secondary.green.600"
      },
      "basics.colors.green700": {
        "equivalent": "basics.colors.secondary.green.700"
      },
      "basics.colors.green800": {
        "equivalent": "basics.colors.secondary.green.800"
      },
      "basics.colors.green900": {
        "equivalent": "basics.colors.secondary.green.900"
      },
      "basics.colors.red100": {
        "equivalent": "basics.colors.secondary.red.100"
      },
      "basics.colors.red200": {
        "equivalent": "basics.colors.secondary.red.200"
      },
      "basics.colors.red300": {
        "equivalent": "basics.colors.secondary.red.300"
      },
      "basics.colors.red400": {
        "equivalent": "basics.colors.secondary.red.400"
      },
      "basics.colors.red500": {
        "equivalent": "basics.colors.secondary.red.500"
      },
      "basics.colors.red600": {
        "equivalent": "basics.colors.secondary.red.600"
      },
      "basics.colors.red700": {
        "equivalent": "basics.colors.secondary.red.700"
      },
      "basics.colors.red800": {
        "equivalent": "basics.colors.secondary.red.800"
      },
      "basics.colors.red900": {
        "equivalent": "basics.colors.secondary.red.900"
      },
      "basics.colors.turquoise100": {
        "equivalent": "basics.colors.secondary.turquoise.100"
      },
      "basics.colors.turquoise200": {
        "equivalent": "basics.colors.secondary.turquoise.200"
      },
      "basics.colors.turquoise300": {
        "equivalent": "basics.colors.secondary.turquoise.300"
      },
      "basics.colors.turquoise400": {
        "equivalent": "basics.colors.secondary.turquoise.400"
      },
      "basics.colors.turquoise500": {
        "equivalent": "basics.colors.secondary.turquoise.500"
      },
      "basics.colors.turquoise600": {
        "equivalent": "basics.colors.secondary.turquoise.600"
      },
      "basics.colors.turquoise700": {
        "equivalent": "basics.colors.secondary.turquoise.700"
      },
      "basics.colors.turquoise800": {
        "equivalent": "basics.colors.secondary.turquoise.800"
      },
      "basics.colors.turquoise900": {
        "equivalent": "basics.colors.secondary.turquoise.900"
      },
      "basics.colors.yellowOrange100": {
        "equivalent": "basics.colors.secondary.yellowOrange.100"
      },
      "basics.colors.yellowOrange200": {
        "equivalent": "basics.colors.secondary.yellowOrange.200"
      },
      "basics.colors.yellowOrange300": {
        "equivalent": "basics.colors.secondary.yellowOrange.300"
      },
      "basics.colors.yellowOrange400": {
        "equivalent": "basics.colors.secondary.yellowOrange.400"
      },
      "basics.colors.yellowOrange500": {
        "equivalent": "basics.colors.secondary.yellowOrange.500"
      },
      "basics.colors.yellowOrange600": {
        "equivalent": "basics.colors.secondary.yellowOrange.600"
      },
      "basics.colors.yellowOrange700": {
        "equivalent": "basics.colors.secondary.yellowOrange.700"
      },
      "basics.colors.yellowOrange800": {
        "equivalent": "basics.colors.secondary.yellowOrange.800"
      },
      "basics.colors.yellowOrange900": {
        "equivalent": "basics.colors.secondary.yellowOrange.900"
      },
      "basics.colors.pink100": {
        "equivalent": "basics.colors.tertiary.pink.100"
      },
      "basics.colors.pink200": {
        "equivalent": "basics.colors.tertiary.pink.200"
      },
      "basics.colors.pink300": {
        "equivalent": "basics.colors.tertiary.pink.300"
      },
      "basics.colors.pink400": {
        "equivalent": "basics.colors.tertiary.pink.400"
      },
      "basics.colors.pink500": {
        "equivalent": "basics.colors.tertiary.pink.500"
      },
      "basics.colors.pink600": {
        "equivalent": "basics.colors.tertiary.pink.600"
      },
      "basics.colors.pink700": {
        "equivalent": "basics.colors.tertiary.pink.700"
      },
      "basics.colors.pink800": {
        "equivalent": "basics.colors.tertiary.pink.800"
      },
      "basics.colors.pink900": {
        "equivalent": "basics.colors.tertiary.pink.900"
      },
      "basics.colors.purple100": {
        "equivalent": "basics.colors.tertiary.purple.100"
      },
      "basics.colors.purple200": {
        "equivalent": "basics.colors.tertiary.purple.200"
      },
      "basics.colors.purple300": {
        "equivalent": "basics.colors.tertiary.purple.300"
      },
      "basics.colors.purple400": {
        "equivalent": "basics.colors.tertiary.purple.400"
      },
      "basics.colors.purple500": {
        "equivalent": "basics.colors.tertiary.purple.500"
      },
      "basics.colors.purple600": {
        "equivalent": "basics.colors.tertiary.purple.600"
      },
      "basics.colors.purple700": {
        "equivalent": "basics.colors.tertiary.purple.700"
      },
      "basics.colors.purple800": {
        "equivalent": "basics.colors.tertiary.purple.800"
      },
      "basics.colors.purple900": {
        "equivalent": "basics.colors.tertiary.purple.900"
      },
      "basics.colors.salmon100": {
        "equivalent": "basics.colors.tertiary.salmon.100"
      },
      "basics.colors.salmon200": {
        "equivalent": "basics.colors.tertiary.salmon.200"
      },
      "basics.colors.salmon300": {
        "equivalent": "basics.colors.tertiary.salmon.300"
      },
      "basics.colors.salmon400": {
        "equivalent": "basics.colors.tertiary.salmon.400"
      },
      "basics.colors.salmon500": {
        "equivalent": "basics.colors.tertiary.salmon.500"
      },
      "basics.colors.salmon600": {
        "equivalent": "basics.colors.tertiary.salmon.600"
      },
      "basics.colors.salmon700": {
        "equivalent": "basics.colors.tertiary.salmon.700"
      },
      "basics.colors.salmon800": {
        "equivalent": "basics.colors.tertiary.salmon.800"
      },
      "basics.colors.salmon900": {
        "equivalent": "basics.colors.tertiary.salmon.900"
      },
      "basics.colors.slate100": {
        "equivalent": "basics.colors.tertiary.slate.100"
      },
      "basics.colors.slate200": {
        "equivalent": "basics.colors.tertiary.slate.200"
      },
      "basics.colors.slate300": {
        "equivalent": "basics.colors.tertiary.slate.300"
      },
      "basics.colors.slate400": {
        "equivalent": "basics.colors.tertiary.slate.400"
      },
      "basics.colors.slate500": {
        "equivalent": "basics.colors.tertiary.slate.500"
      },
      "basics.colors.slate600": {
        "equivalent": "basics.colors.tertiary.slate.600"
      },
      "basics.colors.slate700": {
        "equivalent": "basics.colors.tertiary.slate.700"
      },
      "basics.colors.slate800": {
        "equivalent": "basics.colors.tertiary.slate.800"
      },
      "basics.colors.slate900": {
        "equivalent": "basics.colors.tertiary.slate.900"
      },
      "basics.colors.surfaceLightGrayLevel100": {
        "equivalent": "basics.colors.surface.lightGray.100"
      },
      "basics.colors.surfaceLightGrayLevel200": {
        "equivalent": "basics.colors.surface.lightGray.200"
      },
      "basics.colors.surfaceLightGrayLevel250": {
        "equivalent": "basics.colors.surface.lightGray.250"
      },
      "basics.colors.surfaceLightGrayLevel300": {
        "equivalent": "basics.colors.surface.lightGray.300"
      },
      "basics.colors.surfaceLightGrayLevel350": {
        "equivalent": "basics.colors.surface.lightGray.350"
      },
      "basics.colors.surfaceDarkBlueLevel100": {
        "equivalent": "basics.colors.surface.darkBlue.100"
      },
      "basics.colors.surfaceDarkBlueLevel200": {
        "equivalent": "basics.colors.surface.darkBlue.200"
      },
      "basics.colors.surfaceDarkBlueLevel250": {
        "equivalent": "basics.colors.surface.darkBlue.250"
      },
      "basics.colors.surfaceDarkBlueLevel300": {
        "equivalent": "basics.colors.surface.darkBlue.300"
      },
      "basics.colors.surfaceDarkBlueLevel350": {
        "equivalent": "basics.colors.surface.darkBlue.350"
      },
      "basics.colors.surfaceDarkGrayLevel100": {
        "equivalent": "basics.colors.surface.darkGray.100"
      },
      "basics.colors.surfaceDarkGrayLevel200": {
        "equivalent": "basics.colors.surface.darkGray.200"
      },
      "basics.colors.surfaceDarkGrayLevel250": {
        "equivalent": "basics.colors.surface.darkGray.250"
      },
      "basics.colors.surfaceDarkGrayLevel300": {
        "equivalent": "basics.colors.surface.darkGray.300"
      },
      "basics.colors.surfaceDarkGrayLevel350": {
        "equivalent": "basics.colors.surface.darkGray.350"
      },
      "basics.colors.surfaceDarkBlueShadow": {
        "equivalent": "basics.colors.shadow.darkBlue"
      },
      "basics.colors.surfaceDarkGrayShadow": {
        "equivalent": "basics.colors.shadow.darkGray"
      },
      "basics.colors.surfaceLightGrayShadow": {
        "equivalent": "basics.colors.shadow.lightGray"
      },
      "basics.colors.textAgainstDark": {
        "equivalent": "basics.colors.text.againstDark"
      },
      "basics.colors.textAgainstLight": {
        "equivalent": "basics.colors.text.againstLight"
      },
      "basics.colors.iconLightGrayColor": {
        "equivalent": "basics.colors.icon.lightGray"
      },
      "basics.colors.iconDarkBlueColor": {
        "equivalent": "basics.colors.icon.darkBlue"
      },
      "basics.colors.iconDarkGrayColor": {
        "equivalent": "basics.colors.icon.darkGray"
      },
      "basics.colors.textLinkAgainstLight": {
        "equivalent": "basics.colors.textLink.primary.againstLight"
      },
      "basics.colors.textLinkAgainstDark": {
        "equivalent": "basics.colors.textLink.primary.againstDark"
      },
      "basics.colors.error": {
        "equivalent": "colorScheme.status.error"
      },
      "basics.colors.success": {
        "equivalent": "colorScheme.status.success"
      },
      "basics.colors.warning": {
        "equivalent": "colorScheme.status.warning"
      },
      "colorScheme.accentColor": {
        "equivalent": "colorScheme.reference.accent"
      },
      "colorScheme.baseColor": {
        "equivalent": "colorScheme.reference.base"
      },
      "colorScheme.surfaceLevel100Color": {
        "equivalent": "colorScheme.surface.level100"
      },
      "colorScheme.surfaceLevel200Color": {
        "equivalent": "colorScheme.surface.level200"
      },
      "colorScheme.surfaceLevel250Color": {
        "equivalent": "colorScheme.surface.level250"
      },
      "colorScheme.surfaceLevel300Color": {
        "equivalent": "colorScheme.surface.level300"
      },
      "colorScheme.surfaceLevel350Color": {
        "equivalent": "colorScheme.surface.level350"
      },
      "colorScheme.highShadowColor": {
        "equivalent": "colorScheme.shadow.high"
      },
      "colorScheme.lowShadowColor": {
        "equivalent": "colorScheme.shadow.low"
      },
      "colorScheme.textColor": {
        "equivalent": "colorScheme.text.default"
      },
      "colorScheme.textColorDim": {
        "equivalent": "colorScheme.text.dim"
      },
      "colorScheme.iconColor": {
        "equivalent": "colorScheme.icon.default"
      },
      "colorScheme.errorColor": {
        "equivalent": "colorScheme.status.error"
      },
      "colorScheme.successColor": {
        "equivalent": "colorScheme.status.success"
      },
      "colorScheme.warningColor": {
        "equivalent": "colorScheme.status.warning"
      },
      "colorScheme.infoColor": {
        "equivalent": "colorScheme.status.info"
      },
      "colorScheme.component.backgroundColor": {
        "equivalent": "colorScheme.surface.level"
      },
      "accordion.header.indicatorColor": {
        "equivalent": "accordion.header.default.indicatorColor"
      },
      "avatar.darkBackground.fontColor": {
        "equivalent": "basics.colors.primary.white"
      },
      "avatar.lightBackground.fontColor": {
        "equivalent": "basics.colors.text.againstLight"
      },
      "avatar.color1.backgroundColor": {
        "equivalent": "basics.colors.primary.autodeskBlue.300"
      },
      "avatar.color2.backgroundColor": {
        "equivalent": "basics.colors.secondary.darkBlue.600"
      },
      "avatar.color3.backgroundColor": {
        "equivalent": "basics.colors.secondary.green.700"
      },
      "avatar.color4.backgroundColor": {
        "equivalent": "basics.colors.tertiary.salmon.400"
      },
      "avatar.color5.backgroundColor": {
        "equivalent": "basics.colors.tertiary.slate.700"
      },
      "avatar.color6.backgroundColor": {
        "equivalent": "basics.colors.secondary.turquoise.400"
      },
      "avatar.color7.backgroundColor": {
        "equivalent": "basics.colors.secondary.yellowOrange.500"
      },
      "avatar.color1.fontColor": {
        "equivalent": "basics.colors.text.againstLight"
      },
      "avatar.color2.fontColor": {
        "equivalent": "avatar.fontColor"
      },
      "avatar.color3.fontColor": {
        "equivalent": "avatar.fontColor"
      },
      "avatar.color4.fontColor": {
        "equivalent": "basics.colors.text.againstLight"
      },
      "avatar.color5.fontColor": {
        "equivalent": "avatar.fontColor"
      },
      "avatar.color6.fontColor": {
        "equivalent": "basics.colors.text.againstLight"
      },
      "avatar.color7.fontColor": {
        "equivalent": "basics.colors.text.againstLight"
      },
      "avatar.fontColorOnDark": {
        "equivalent": "avatar.fontColor"
      },
      "avatar.fontColorOnLight": {
        "equivalent": "basics.colors.text.againstLight"
      },
      "banner.info.iconBackground": {
        "equivalent": "banner.info.iconField.backgroundColor"
      },
      "banner.success.iconBackground": {
        "equivalent": "banner.success.iconField.backgroundColor"
      },
      "banner.warning.iconBackground": {
        "equivalent": "banner.warning.iconField.backgroundColor"
      },
      "banner.error.iconBackground": {
        "equivalent": "banner.error.iconField.backgroundColor"
      },
      "button.fontWeight": {
        "equivalent": "button.label.fontWeight"
      },
      "button.lineHeight": {
        "equivalent": "button.label.lineHeight"
      },
      "button.fontFamily": {
        "equivalent": "button.label.fontFamily"
      },
      "button.fontSize": {
        "equivalent": "button.label.fontSize"
      },
      "button.gutter": {
        "equivalent": "button.gutterWidth"
      },
      "button.horizontalPadding": {
        "equivalent": "button.paddingHorizontal"
      },
      "button.minimumWidth": {
        "equivalent": "button.minWidth"
      },
      "button.verticalPadding": {
        "equivalent": "button.paddingVertical"
      },
      "button.halo.width": {
        "equivalent": "button.haloWidth"
      },
      "button.halo.color": {
        "equivalent": "colorScheme.halo"
      },
      "button.hover.halo.width": {
        "equivalent": "button.hover.haloWidth"
      },
      "button.focus.halo.width": {
        "equivalent": "button.haloWidth"
      },
      "button.pressed.halo.width": {
        "equivalent": "button.pressed.haloWidth"
      },
      "button.focus.halo.color": {
        "equivalent": "button.focus.haloColor"
      },
      "button.pressed.halo.color": {
        "equivalent": "button.pressed.haloColor"
      },
      "button.outline.backgroundColor": {
        "equivalent": "button.outline.default.backgroundColor"
      },
      "button.outline.borderColor": {
        "equivalent": "button.outline.default.borderColor"
      },
      "button.outline.focus.halo.color": {
        "equivalent": "button.focus.haloColor"
      },
      "button.outline.focus.icon.color": {
        "equivalent": "button.outline.iconColor"
      },
      "button.outline.focus.textColor": {
        "equivalent": "button.outline.label.fontColor"
      },
      "button.outline.halo.color": {
        "equivalent": "colorScheme.halo"
      },
      "button.outline.hover.halo.color": {
        "equivalent": "button.hover.haloColor"
      },
      "button.outline.hover.icon.color": {
        "equivalent": "button.outline.iconColor"
      },
      "button.outline.hover.textColor": {
        "equivalent": "button.outline.label.fontColor"
      },
      "button.outline.icon.color": {
        "equivalent": "button.outline.iconColor"
      },
      "button.outline.pressed.halo.color": {
        "equivalent": "button.pressed.haloColor"
      },
      "button.outline.pressed.haloWidth": {
        "equivalent": "button.pressed.haloWidth"
      },
      "button.outline.pressed.icon.color": {
        "equivalent": "button.outline.iconColor"
      },
      "button.outline.pressed.textColor": {
        "equivalent": "button.outline.label.fontColor"
      },
      "button.outline.textColor": {
        "equivalent": "button.outline.label.fontColor"
      },
      "button.solid.backgroundColor": {
        "equivalent": "button.solid.default.backgroundColor"
      },
      "button.solid.borderColor": {
        "equivalent": "button.solid.default.borderColor"
      },
      "button.solid.halo.color": {
        "equivalent": "colorScheme.halo"
      },
      "button.solid.textColor": {
        "equivalent": "button.solid.label.fontColor"
      },
      "button.solid.icon.color": {
        "equivalent": "button.solid.iconColor"
      },
      "button.solid.hover.halo.color": {
        "equivalent": "button.hover.haloColor"
      },
      "button.solid.hover.textColor": {
        "equivalent": "button.solid.label.fontColor"
      },
      "button.solid.hover.icon.color": {
        "equivalent": "button.solid.iconColor"
      },
      "button.solid.focus.halo.color": {
        "equivalent": "button.focus.haloColor"
      },
      "button.solid.focus.textColor": {
        "equivalent": "button.solid.label.fontColor"
      },
      "button.solid.focus.icon.color": {
        "equivalent": "button.solid.iconColor"
      },
      "button.solid.pressed.haloWidth": {
        "equivalent": "button.pressed.haloWidth"
      },
      "button.solid.pressed.halo.color": {
        "equivalent": "button.pressed.haloColor"
      },
      "button.solid.pressed.textColor": {
        "equivalent": "button.solid.label.fontColor"
      },
      "button.solid.pressed.icon.color": {
        "equivalent": "button.solid.iconColor"
      },
      "button.flat.backgroundColor": {
        "equivalent": "button.flat.default.backgroundColor"
      },
      "button.flat.borderColor": {
        "equivalent": "button.flat.default.borderColor"
      },
      "button.flat.halo.color": {
        "equivalent": "colorScheme.halo"
      },
      "button.flat.textColor": {
        "equivalent": "button.flat.label.fontColor"
      },
      "button.flat.icon.color": {
        "equivalent": "button.flat.iconColor"
      },
      "button.flat.hover.halo.color": {
        "equivalent": "button.hover.haloColor"
      },
      "button.flat.hover.textColor": {
        "equivalent": "button.flat.label.fontColor"
      },
      "button.flat.hover.icon.color": {
        "equivalent": "button.flat.iconColor"
      },
      "button.flat.focus.halo.color": {
        "equivalent": "button.focus.haloColor"
      },
      "button.flat.focus.textColor": {
        "equivalent": "button.flat.label.fontColor"
      },
      "button.flat.focus.icon.color": {
        "equivalent": "button.flat.iconColor"
      },
      "button.flat.pressed.haloWidth": {
        "equivalent": "button.pressed.haloWidth"
      },
      "button.flat.pressed.halo.color": {
        "equivalent": "button.pressed.haloColor"
      },
      "button.flat.pressed.textColor": {
        "equivalent": "button.flat.label.fontColor"
      },
      "button.flat.pressed.icon.color": {
        "equivalent": "button.flat.iconColor"
      },
      "checkbox.halo.color": {
        "equivalent": "checkbox.hover.haloColor"
      },
      "checkbox.halo.width": {
        "equivalent": "checkbox.hover.haloWidth"
      },
      "checkbox.height": {
        "equivalent": "checkbox.minHeight"
      },
      "checkbox.iconColor": {
        "equivalent": "checkbox.indicatorColor"
      },
      "checkbox.width": {
        "equivalent": "checkbox.minWidth"
      },
      "checkbox.backgroundColor": {
        "equivalent": "checkbox.unchecked.default.backgroundColor"
      },
      "checkbox.borderColor": {
        "equivalent": "checkbox.unchecked.default.borderColor"
      },
      "checkbox.hover.borderColor": {
        "equivalent": "checkbox.unchecked.hover.borderColor"
      },
      "checkbox.hover.halo.width": {
        "equivalent": "checkbox.hover.haloWidth"
      },
      "checkbox.hover.halo.color": {
        "equivalent": "checkbox.hover.haloColor"
      },
      "checkbox.focus.borderColor": {
        "equivalent": "checkbox.unchecked.focus.borderColor"
      },
      "checkbox.focus.halo.color": {
        "equivalent": "checkbox.focus.haloColor"
      },
      "checkbox.focus.halo.width": {
        "equivalent": "checkbox.focus.haloWidth"
      },
      "checkbox.pressed.borderColor": {
        "equivalent": "checkbox.unchecked.pressed.borderColor"
      },
      "checkbox.pressed.halo.color": {
        "equivalent": "checkbox.pressed.haloColor"
      },
      "checkbox.pressed.halo.width": {
        "equivalent": "checkbox.pressed.haloWidth"
      },
      "checkbox.checked.borderColor": {
        "equivalent": "checkbox.checked.default.borderColor"
      },
      "checkbox.checked.iconColor": {
        "equivalent": "checkbox.indicatorColor"
      },
      "checkbox.checked.backgroundColor": {
        "equivalent": "checkbox.checked.default.backgroundColor"
      },
      "checkbox.indeterminate.borderColor": {
        "equivalent": "checkbox.checked.default.borderColor"
      },
      "checkbox.indeterminate.iconColor": {
        "equivalent": "checkbox.indicatorColor"
      },
      "checkbox.indeterminate.backgroundColor": {
        "equivalent": "checkbox.checked.default.backgroundColor"
      },
      "checkbox.focus.checked.backgroundColor": {
        "equivalent": "checkbox.checked.default.backgroundColor"
      },
      "checkbox.focus.checked.borderColor": {
        "equivalent": "checkbox.checked.default.borderColor"
      },
      "checkbox.focus.indeterminate.borderColor": {
        "equivalent": "checkbox.checked.default.borderColor"
      },
      "component.disabled.opacity": {
        "equivalent": "colorScheme.opacity.disabled"
      },
      "divider.width": {
        "equivalent": "divider.borderWidth"
      },
      "formField.instructionalText.fontSize": {
        "equivalent": "input.value.fontSize"
      },
      "formField.instructionalText.fontWeight": {
        "equivalent": "input.value.fontWeight"
      },
      "formField.instructionalText.fontFamily": {
        "equivalent": "input.value.fontFamily"
      },
      "formField.instructionalText.fontColor": {
        "equivalent": "input.value.placeholderFontColor"
      },
      "formField.instructionalText.lineHeight": {
        "equivalent": "basics.lineHeights.medium"
      },
      "formField.icon.width": {
        "equivalent": "basics.spacings"
      },
      "formField.icon.paddingRight": {
        "equivalent": "density.spacings.small"
      },
      "formField.icon.color": {
        "equivalent": "input.indicator.default"
      },
      "iconButton.focus.halo.color": {
        "equivalent": "iconButton.focus.haloColor"
      },
      "iconButton.focus.halo.width": {
        "equivalent": "iconButton.focus.haloWidth"
      },
      "iconButton.focus.iconColor": {
        "equivalent": "iconButton.dynamic.focus.iconColor"
      },
      "iconButton.focus.on.iconColor": {
        "equivalent": "iconButton.dynamic.on.focus.iconColor"
      },
      "iconButton.hover.iconColor": {
        "equivalent": "iconButton.dynamic.hover.iconColor"
      },
      "iconButton.hover.on.iconColor": {
        "equivalent": "iconButton.dynamic.on.hover.iconColor"
      },
      "iconButton.iconColor": {
        "equivalent": "iconButton.dynamic.default.iconColor"
      },
      "iconButton.on.iconColor": {
        "equivalent": "iconButton.dynamic.on.default.iconColor"
      },
      "iconButton.pressed.backgroundColor": {
        "equivalent": "iconButton.dynamic.pressed.100To250BackgroundColor"
      },
      "iconButton.pressed.iconColor": {
        "equivalent": "iconButton.dynamic.pressed.iconColor"
      },
      "iconButton.pressed.level100To250.backgroundColor": {
        "equivalent": "iconButton.dynamic.pressed.100To250BackgroundColor"
      },
      "iconButton.pressed.level300To350.backgroundColor": {
        "equivalent": "iconButton.dynamic.pressed.300To350BackgroundColor"
      },
      "iconButton.pressed.on.iconColor": {
        "equivalent": "iconButton.dynamic.on.pressed.iconColor"
      },
      "iconButton.static.hover.level100To250.backgroundColor": {
        "equivalent": "iconButton.static.hover.100To250BackgroundColor"
      },
      "iconButton.static.hover.level300To350.backgroundColor": {
        "equivalent": "iconButton.static.hover.300To350BackgroundColor"
      },
      "iconButton.static.on.backgroundColor": {
        "equivalent": "iconButton.static.on.default.backgroundColor"
      },
      "iconButton.static.on.borderColor": {
        "equivalent": "iconButton.static.on.default.borderColor"
      },
      "iconButton.static.on.hover.level100To250.backgroundColor": {
        "equivalent": "iconButton.static.on.hover.100To250BackgroundColor"
      },
      "iconButton.static.on.hover.level300To350.backgroundColor": {
        "equivalent": "iconButton.static.on.hover.300To350BackgroundColor"
      },
      "input.active.halo.color": {
        "equivalent": "input.focus.haloColor"
      },
      "input.borderBottomColor": {
        "equivalent": "input.line.default.borderBottomColor"
      },
      "input.active.halo.width": {
        "equivalent": "input.haloWidth"
      },
      "input.box.backgroundColor": {
        "equivalent": "input.box.default.backgroundColor"
      },
      "input.box.borderBottomColor": {
        "equivalent": "input.box.default.borderBottomColor"
      },
      "input.boxType.horizontalPadding": {
        "equivalent": "input.box.paddingHorizontal"
      },
      "input.focus.borderBottomColor": {
        "equivalent": "input.line.focus.borderBottomColor"
      },
      "input.focus.halo.color": {
        "equivalent": "input.focus.haloColor"
      },
      "input.focus.halo.width": {
        "equivalent": "input.haloWidth"
      },
      "input.fontColor": {
        "equivalent": "input.value.fontColor"
      },
      "input.fontFamily": {
        "equivalent": "input.value.fontFamily"
      },
      "input.fontSize": {
        "equivalent": "input.value.fontSize"
      },
      "input.fontWeight": {
        "equivalent": "input.value.fontWeight"
      },
      "input.halo.color": {
        "equivalent": "input.hover.haloColor"
      },
      "input.halo.width": {
        "equivalent": "input.haloWidth"
      },
      "input.height": {
        "equivalent": "input.minHeight"
      },
      "input.highlightColor": {
        "equivalent": "input.value.highlightColor"
      },
      "input.horizontalPadding": {
        "equivalent": "input.line.paddingHorizontal"
      },
      "input.hover.borderBottomColor": {
        "equivalent": "input.box.hover.borderBottomColor"
      },
      "input.hover.halo.width": {
        "equivalent": "input.haloWidth"
      },
      "input.lineHeight": {
        "equivalent": "input.value.lineHeight"
      },
      "input.placeholder.fontColor": {
        "equivalent": "input.value.placeholderFontColor"
      },
      "input.verticalPadding": {
        "equivalent": "input.paddingVertical"
      },
      "menu.item.backgroundColor": {
        "equivalent": "menu.item.default.backgroundColor"
      },
      "menu.item.active.backgroundColor": {
        "equivalent": "menu.item.pressed.backgroundColor"
      },
      "menu.item.horizontalPadding": {
        "equivalent": "menu.item.paddingHorizontal"
      },
      "menu.item.verticalPadding": {
        "equivalent": "menu.item.paddingVertical"
      },
      "modal.overlay.color": {
        "equivalent": "modal.overlayColor"
      },
      "modal.textColor": {
        "equivalent": "modal.fontColor"
      },
      "modal.body.height": {
        "equivalent": "modal.body.minHeight"
      },
      "modal.horizontalPadding": {
        "equivalent": "modal.paddingHorizontal"
      },
      "modal.header.borderColor": {
        "equivalent": "modal.header.borderBottomColor"
      },
      "modal.header.height": {
        "equivalent": "modal.header.minHeight"
      },
      "modal.window.backgroundColor": {
        "equivalent": "modal.shell.backgroundColor"
      },
      "modal.window.borderRadius": {
        "equivalent": "modal.shell.borderRadius"
      },
      "modal.window.height": {
        "equivalent": "modal.shell.minHeight"
      },
      "modal.window.width": {
        "equivalent": "modal.shell.minWidth"
      },
      "modal.window.shadowColor": {
        "equivalent": "modal.shell.shadowColor"
      },
      "progressBar.backgroundColor": {
        "equivalent": "progress.bar.backgroundColor"
      },
      "progressBar.highlightColor": {
        "equivalent": "progress.bar.highlightColor"
      },
      "progressBar.borderRadius": {
        "equivalent": "progress.bar.borderRadius"
      },
      "progressBar.height": {
        "equivalent": "progress.bar.minHeight"
      },
      "progressRing.backgroundColor": {
        "equivalent": "progress.ring.backgroundColor"
      },
      "progressRing.highlightColor1": {
        "equivalent": "progress.ring.highlightColor1"
      },
      "progressRing.highlightColor2": {
        "equivalent": "progress.ring.highlightColor2"
      },
      "skeletonItem.defaultHeight": {
        "equivalent": "skeletonItem.minHeight"
      },
      "slider.halo.width": {
        "equivalent": "slider.hover.haloWidth"
      },
      "slider.halo.color": {
        "equivalent": "slider.hover.haloColor"
      },
      "slider.thumb.width": {
        "equivalent": "slider.thumb.minWidth"
      },
      "slider.focused.halo.color": {
        "equivalent": "slider.focus.haloColor"
      },
      "slider.focused.halo.width": {
        "equivalent": "slider.focus.haloWidth"
      },
      "slider.focused.thumb.color": {
        "equivalent": "slider.thumb.backgroundColor"
      },
      "slider.hover.halo.color": {
        "equivalent": "slider.hover.haloColor"
      },
      "slider.hover.halo.width": {
        "equivalent": "slider.hover.haloWidth"
      },
      "slider.hover.thumb.color": {
        "equivalent": "slider.thumb.backgroundColor"
      },
      "slider.pressed.halo.color": {
        "equivalent": "slider.pressed.haloColor"
      },
      "slider.pressed.halo.width": {
        "equivalent": "slider.pressed.haloWidth"
      },
      "slider.pressed.thumb.color": {
        "equivalent": "slider.thumb.backgroundColor"
      },
      "slider.track.color": {
        "equivalent": "slider.track.backgroundColor"
      },
      "slider.track.width": {
        "equivalent": "slider.track.minHeight"
      },
      "slider.value.color": {
        "equivalent": "slider.value.backgroundColor"
      },
      "table.item.fontWeight": {
        "equivalent": "table.cell.fontWeight"
      },
      "table.row.hover.backgroundColor": {
        "equivalent": "table.row.unselected.hover.backgroundColor"
      },
      "table.row.pressed.backgroundColor": {
        "equivalent": "table.row.unselected.pressed.backgroundColor"
      },
      "table.row.selected.backgroundColor": {
        "equivalent": "table.row.selected.default.backgroundColor"
      },
      "table.header.borderTopColor": {
        "equivalent": "table.row.unselected.default.borderColor"
      },
      "table.header.borderBottomColor": {
        "equivalent": "table.row.unselected.default.borderColor"
      },
      "tabs.general.tab.fontFamily": {
        "equivalent": "tabs.label.fontFamily"
      },
      "tabs.general.tab.fontSize": {
        "equivalent": "tabs.label.fontSize"
      },
      "tabs.general.tab.fontWeight": {
        "equivalent": "tabs.label.inactive.fontWeight"
      },
      "tabs.general.tab.active.fontWeight": {
        "equivalent": "tabs.label.active.fontWeight"
      },
      "tabs.general.tab.color": {
        "equivalent": "tabs.label.fontColor"
      },
      "tabs.general.tab.lineHeight": {
        "equivalent": "tabs.label.active.lineHeight"
      },
      "tabs.general.halo.size": {
        "equivalent": "tabs.focus.haloWidth"
      },
      "tabs.general.halo.color": {
        "equivalent": "tabs.focus.haloColor"
      },
      "tabs.general.icon.size": {
        "equivalent": "tabs.iconSize"
      },
      "tabs.general.icon.color": {
        "equivalent": "tabs.iconColor"
      },
      "tabs.general.icon.gutter": {
        "equivalent": "tabs.iconGutter"
      },
      "tabs.general.closeButton.size": {
        "equivalent": "tabs.closeButton.minSize"
      },
      "tabs.general.closeButton.gutter": {
        "equivalent": "tabs.closeButton.gutter"
      },
      "tabs.general.closeButton.color": {
        "equivalent": "tabs.closeButton.default.iconColor"
      },
      "tabs.general.closeButton.hover.color": {
        "equivalent": "tabs.closeButton.hover.iconColor"
      },
      "tabs.general.closeButton.pressed.color": {
        "equivalent": "tabs.closeButton.pressed.iconColor"
      },
      "tabs.underline.halo.hover.color": {
        "equivalent": "tabs.underline.hover.haloColor"
      },
      "tabs.underline.halo.active.color": {
        "equivalent": "tabs.underline.active.haloColor"
      },
      "tabs.box.tab.horizontalPadding": {
        "equivalent": "tabs.box.tab.paddingHorizontal"
      },
      "tabs.box.tab.verticalPadding": {
        "equivalent": "tabs.box.tab.paddingVertical"
      },
      "tabs.box.divider.color": {
        "equivalent": "tabs.box.divider.borderColor"
      },
      "tabs.box.divider.width": {
        "equivalent": "tabs.box.dividerWidth"
      },
      "tabs.box.divider.height": {
        "equivalent": "tabs.box.dividerHeight"
      },
      "tabs.canvas.tab.horizontalPadding": {
        "equivalent": "tabs.canvas.tab.paddingHorizontal"
      },
      "tabs.canvas.tab.verticalPadding": {
        "equivalent": "tabs.canvas.tab.paddingVertical"
      },
      "tabs.canvas.divider.color": {
        "equivalent": "tabs.canvas.divider.borderColor"
      },
      "tabs.canvas.divider.width": {
        "equivalent": "tabs.canvas.dividerWidth"
      },
      "tabs.canvas.divider.height": {
        "equivalent": "tabs.canvas.dividerHeight"
      },
      "textLink.textColor": {
        "equivalent": "textLink.primary.default.fontColor"
      },
      "textLink.hover.textColor": {
        "equivalent": "textLink.primary.hover.fontColor"
      },
      "textLink.focus.textColor": {
        "equivalent": "textLink.primary.focus.fontColor"
      },
      "textLink.hover.underline.color": {
        "equivalent": "textLink.primary.hover.underlineColor"
      },
      "textLink.focus.halo.color": {
        "equivalent": "textLink.focus.haloColor"
      },
      "textLink.focus.halo.width": {
        "equivalent": "textLink.focus.haloWidth"
      },
      "tooltip.textColor": {
        "equivalent": "tooltip.title.fontColor"
      },
      "tooltip.borderColor": {
        "equivalent": "tooltip.backgroundColor"
      }
    }
  },
  "resolvedRoles": {
    "basics.borderRadii.none": "0",
    "basics.borderRadii.small": "0",
    "basics.borderRadii.medium": "2px",
    "basics.borderRadii.large": "4px",
    "basics.borderRadii.ellipse": "50%",
    "basics.borderRadii.pill": "1000em",
    "basics.borderWidths.none": "0",
    "basics.borderWidths.small": "1px",
    "basics.borderWidths.medium": "2px",
    "basics.borderWidths.large": "4px",
    "basics.colors.primary.black": "#000000",
    "basics.colors.primary.white": "#ffffff",
    "basics.colors.primary.autodeskBlue.100": "#cdeaf7",
    "basics.colors.primary.autodeskBlue.200": "#9bd5ef",
    "basics.colors.primary.autodeskBlue.300": "#6ac0e7",
    "basics.colors.primary.autodeskBlue.400": "#38abdf",
    "basics.colors.primary.autodeskBlue.500": "#0696d7",
    "basics.colors.primary.autodeskBlue.600": "#007fc6",
    "basics.colors.primary.autodeskBlue.700": "#006eaf",
    "basics.colors.primary.autodeskBlue.800": "#074b78",
    "basics.colors.primary.autodeskBlue.900": "#0a324d",
    "basics.colors.primary.charcoal.100": "#eeeeee",
    "basics.colors.primary.charcoal.200": "#dcdcdc",
    "basics.colors.primary.charcoal.300": "#cccccc",
    "basics.colors.primary.charcoal.400": "#bbbbbb",
    "basics.colors.primary.charcoal.500": "#999999",
    "basics.colors.primary.charcoal.600": "#808080",
    "basics.colors.primary.charcoal.700": "#666666",
    "basics.colors.primary.charcoal.800": "#4d4d4d",
    "basics.colors.primary.charcoal.900": "#3c3c3c",
    "basics.colors.secondary.darkBlue.100": "#e1ebf7",
    "basics.colors.secondary.darkBlue.200": "#bcd3ee",
    "basics.colors.secondary.darkBlue.300": "#8babdc",
    "basics.colors.secondary.darkBlue.400": "#5f8bcb",
    "basics.colors.secondary.darkBlue.500": "#3970b9",
    "basics.colors.secondary.darkBlue.600": "#1858a8",
    "basics.colors.secondary.darkBlue.700": "#064285",
    "basics.colors.secondary.darkBlue.800": "#003163",
    "basics.colors.secondary.darkBlue.900": "#0c2c54",
    "basics.colors.secondary.green.100": "#e7f2d9",
    "basics.colors.secondary.green.200": "#cfe4b3",
    "basics.colors.secondary.green.300": "#b7d78c",
    "basics.colors.secondary.green.400": "#9fc966",
    "basics.colors.secondary.green.500": "#87b340",
    "basics.colors.secondary.green.600": "#6a9728",
    "basics.colors.secondary.green.700": "#507b16",
    "basics.colors.secondary.green.800": "#385e08",
    "basics.colors.secondary.green.900": "#234200",
    "basics.colors.secondary.red.100": "#faeded",
    "basics.colors.secondary.red.200": "#f7d6d6",
    "basics.colors.secondary.red.300": "#f9b4b4",
    "basics.colors.secondary.red.400": "#f48686",
    "basics.colors.secondary.red.500": "#eb5555",
    "basics.colors.secondary.red.600": "#dd2222",
    "basics.colors.secondary.red.700": "#af1b1b",
    "basics.colors.secondary.red.800": "#800f0f",
    "basics.colors.secondary.red.900": "#520404",
    "basics.colors.secondary.turquoise.100": "#d6f2ef",
    "basics.colors.secondary.turquoise.200": "#ade4de",
    "basics.colors.secondary.turquoise.300": "#84d7ce",
    "basics.colors.secondary.turquoise.400": "#5bc9bd",
    "basics.colors.secondary.turquoise.500": "#32bcad",
    "basics.colors.secondary.turquoise.600": "#23a597",
    "basics.colors.secondary.turquoise.700": "#168576",
    "basics.colors.secondary.turquoise.800": "#0c665b",
    "basics.colors.secondary.turquoise.900": "#04403d",
    "basics.colors.secondary.yellowOrange.100": "#feecd1",
    "basics.colors.secondary.yellowOrange.200": "#fddaa4",
    "basics.colors.secondary.yellowOrange.300": "#fcc776",
    "basics.colors.secondary.yellowOrange.400": "#fbb549",
    "basics.colors.secondary.yellowOrange.500": "#faa21b",
    "basics.colors.secondary.yellowOrange.600": "#ed8d16",
    "basics.colors.secondary.yellowOrange.700": "#d9730b",
    "basics.colors.secondary.yellowOrange.800": "#bf5808",
    "basics.colors.secondary.yellowOrange.900": "#8c3401",
    "basics.colors.tertiary.pink.100": "#ffebf5",
    "basics.colors.tertiary.pink.200": "#ffd6eb",
    "basics.colors.tertiary.pink.300": "#ffb8db",
    "basics.colors.tertiary.pink.400": "#ff8cc6",
    "basics.colors.tertiary.pink.500": "#fc56a9",
    "basics.colors.tertiary.pink.600": "#e84396",
    "basics.colors.tertiary.pink.700": "#c72877",
    "basics.colors.tertiary.pink.800": "#991f5c",
    "basics.colors.tertiary.pink.900": "#781848",
    "basics.colors.tertiary.purple.100": "#f4edfd",
    "basics.colors.tertiary.purple.200": "#eadcfd",
    "basics.colors.tertiary.purple.300": "#d5bcf7",
    "basics.colors.tertiary.purple.400": "#c5a1f8",
    "basics.colors.tertiary.purple.500": "#b385f2",
    "basics.colors.tertiary.purple.600": "#a76ef5",
    "basics.colors.tertiary.purple.700": "#8558c5",
    "basics.colors.tertiary.purple.800": "#5f3e8e",
    "basics.colors.tertiary.purple.900": "#482f6b",
    "basics.colors.tertiary.salmon.100": "#ffefec",
    "basics.colors.tertiary.salmon.200": "#fcded9",
    "basics.colors.tertiary.salmon.300": "#ffbeb3",
    "basics.colors.tertiary.salmon.400": "#ff9582",
    "basics.colors.tertiary.salmon.500": "#f26a52",
    "basics.colors.tertiary.salmon.600": "#db5942",
    "basics.colors.tertiary.salmon.700": "#a84a39",
    "basics.colors.tertiary.salmon.800": "#853729",
    "basics.colors.tertiary.salmon.900": "#66251a",
    "basics.colors.tertiary.slate.100": "#e9f0f7",
    "basics.colors.tertiary.slate.200": "#dce7f3",
    "basics.colors.tertiary.slate.300": "#c1cedc",
    "basics.colors.tertiary.slate.400": "#a7bacf",
    "basics.colors.tertiary.slate.500": "#7993b0",
    "basics.colors.tertiary.slate.600": "#6784a6",
    "basics.colors.tertiary.slate.700": "#4b6b8f",
    "basics.colors.tertiary.slate.800": "#354d67",
    "basics.colors.tertiary.slate.900": "#2c3e53",
    "basics.colors.surface.lightGray.100": "#ffffff",
    "basics.colors.surface.lightGray.200": "#f5f5f5",
    "basics.colors.surface.lightGray.250": "#eeeeee",
    "basics.colors.surface.lightGray.300": "#d9d9d9",
    "basics.colors.surface.lightGray.350": "#cccccc",
    "basics.colors.surface.darkBlue.100": "#454f61",
    "basics.colors.surface.darkBlue.200": "#3b4453",
    "basics.colors.surface.darkBlue.250": "#2e3440",
    "basics.colors.surface.darkBlue.300": "#222933",
    "basics.colors.surface.darkBlue.350": "#1a1f25",
    "basics.colors.surface.darkGray.100": "#535353",
    "basics.colors.surface.darkGray.200": "#474747",
    "basics.colors.surface.darkGray.250": "#373737",
    "basics.colors.surface.darkGray.300": "#2a2a2a",
    "basics.colors.surface.darkGray.350": "#202020",
    "basics.colors.shadow.darkBlue": "rgba(26, 31, 38, 0.5)",
    "basics.colors.shadow.darkGray": "rgba(0, 0, 0, 0.3)",
    "basics.colors.shadow.lightGray": "rgba(0, 0, 0, 0.2)",
    "basics.colors.text.againstDark": "#f5f5f5",
    "basics.colors.text.againstLight": "#3c3c3c",
    "basics.colors.textLink.primary.againstLight": "#006eaf",
    "basics.colors.textLink.primary.againstDark": "#6dd2ff",
    "basics.colors.textLink.secondary.againstLight": "#3c3c3c",
    "basics.colors.textLink.secondary.againstDark": "#f5f5f5",
    "basics.colors.icon.lightGray": "#808080",
    "basics.colors.icon.darkBlue": "#a2a6b0",
    "basics.colors.icon.darkGray": "#999999",
    "basics.colors.black": "#000000",
    "basics.colors.white": "#ffffff",
    "basics.colors.autodeskBlue100": "#cdeaf7",
    "basics.colors.autodeskBlue200": "#9bd5ef",
    "basics.colors.autodeskBlue300": "#6ac0e7",
    "basics.colors.autodeskBlue400": "#38abdf",
    "basics.colors.autodeskBlue500": "#0696d7",
    "basics.colors.autodeskBlue600": "#007fc6",
    "basics.colors.autodeskBlue700": "#006eaf",
    "basics.colors.autodeskBlue800": "#074b78",
    "basics.colors.autodeskBlue900": "#0a324d",
    "basics.colors.charcoal100": "#eeeeee",
    "basics.colors.charcoal200": "#dcdcdc",
    "basics.colors.charcoal300": "#cccccc",
    "basics.colors.charcoal400": "#bbbbbb",
    "basics.colors.charcoal500": "#999999",
    "basics.colors.charcoal600": "#808080",
    "basics.colors.charcoal700": "#666666",
    "basics.colors.charcoal800": "#4d4d4d",
    "basics.colors.charcoal900": "#3c3c3c",
    "basics.colors.darkBlue100": "#e1ebf7",
    "basics.colors.darkBlue200": "#bcd3ee",
    "basics.colors.darkBlue300": "#8babdc",
    "basics.colors.darkBlue400": "#5f8bcb",
    "basics.colors.darkBlue500": "#3970b9",
    "basics.colors.darkBlue600": "#1858a8",
    "basics.colors.darkBlue700": "#064285",
    "basics.colors.darkBlue800": "#003163",
    "basics.colors.darkBlue900": "#0c2c54",
    "basics.colors.green100": "#e7f2d9",
    "basics.colors.green200": "#cfe4b3",
    "basics.colors.green300": "#b7d78c",
    "basics.colors.green400": "#9fc966",
    "basics.colors.green500": "#87b340",
    "basics.colors.green600": "#6a9728",
    "basics.colors.green700": "#507b16",
    "basics.colors.green800": "#385e08",
    "basics.colors.green900": "#234200",
    "basics.colors.red100": "#faeded",
    "basics.colors.red200": "#f7d6d6",
    "basics.colors.red300": "#f9b4b4",
    "basics.colors.red400": "#f48686",
    "basics.colors.red500": "#eb5555",
    "basics.colors.red600": "#dd2222",
    "basics.colors.red700": "#af1b1b",
    "basics.colors.red800": "#800f0f",
    "basics.colors.red900": "#520404",
    "basics.colors.turquoise100": "#d6f2ef",
    "basics.colors.turquoise200": "#ade4de",
    "basics.colors.turquoise300": "#84d7ce",
    "basics.colors.turquoise400": "#5bc9bd",
    "basics.colors.turquoise500": "#32bcad",
    "basics.colors.turquoise600": "#23a597",
    "basics.colors.turquoise700": "#168576",
    "basics.colors.turquoise800": "#0c665b",
    "basics.colors.turquoise900": "#04403d",
    "basics.colors.yellowOrange100": "#feecd1",
    "basics.colors.yellowOrange200": "#fddaa4",
    "basics.colors.yellowOrange300": "#fcc776",
    "basics.colors.yellowOrange400": "#fbb549",
    "basics.colors.yellowOrange500": "#faa21b",
    "basics.colors.yellowOrange600": "#ed8d16",
    "basics.colors.yellowOrange700": "#d9730b",
    "basics.colors.yellowOrange800": "#bf5808",
    "basics.colors.yellowOrange900": "#8c3401",
    "basics.colors.pink100": "#ffebf5",
    "basics.colors.pink200": "#ffd6eb",
    "basics.colors.pink300": "#ffb8db",
    "basics.colors.pink400": "#ff8cc6",
    "basics.colors.pink500": "#fc56a9",
    "basics.colors.pink600": "#e84396",
    "basics.colors.pink700": "#c72877",
    "basics.colors.pink800": "#991f5c",
    "basics.colors.pink900": "#781848",
    "basics.colors.purple100": "#f4edfd",
    "basics.colors.purple200": "#eadcfd",
    "basics.colors.purple300": "#d5bcf7",
    "basics.colors.purple400": "#c5a1f8",
    "basics.colors.purple500": "#b385f2",
    "basics.colors.purple600": "#a76ef5",
    "basics.colors.purple700": "#8558c5",
    "basics.colors.purple800": "#5f3e8e",
    "basics.colors.purple900": "#482f6b",
    "basics.colors.salmon100": "#ffefec",
    "basics.colors.salmon200": "#fcded9",
    "basics.colors.salmon300": "#ffbeb3",
    "basics.colors.salmon400": "#ff9582",
    "basics.colors.salmon500": "#f26a52",
    "basics.colors.salmon600": "#db5942",
    "basics.colors.salmon700": "#a84a39",
    "basics.colors.salmon800": "#853729",
    "basics.colors.salmon900": "#66251a",
    "basics.colors.slate100": "#e9f0f7",
    "basics.colors.slate200": "#dce7f3",
    "basics.colors.slate300": "#c1cedc",
    "basics.colors.slate400": "#a7bacf",
    "basics.colors.slate500": "#7993b0",
    "basics.colors.slate600": "#6784a6",
    "basics.colors.slate700": "#4b6b8f",
    "basics.colors.slate800": "#354d67",
    "basics.colors.slate900": "#2c3e53",
    "basics.colors.surfaceLightGrayLevel100": "#ffffff",
    "basics.colors.surfaceLightGrayLevel200": "#f5f5f5",
    "basics.colors.surfaceLightGrayLevel250": "#eeeeee",
    "basics.colors.surfaceLightGrayLevel300": "#d9d9d9",
    "basics.colors.surfaceLightGrayLevel350": "#cccccc",
    "basics.colors.surfaceDarkBlueLevel100": "#454f61",
    "basics.colors.surfaceDarkBlueLevel200": "#3b4453",
    "basics.colors.surfaceDarkBlueLevel250": "#2e3440",
    "basics.colors.surfaceDarkBlueLevel300": "#222933",
    "basics.colors.surfaceDarkBlueLevel350": "#1a1f25",
    "basics.colors.surfaceDarkGrayLevel100": "#535353",
    "basics.colors.surfaceDarkGrayLevel200": "#474747",
    "basics.colors.surfaceDarkGrayLevel250": "#373737",
    "basics.colors.surfaceDarkGrayLevel300": "#2a2a2a",
    "basics.colors.surfaceDarkGrayLevel350": "#202020",
    "basics.colors.surfaceDarkBlueShadow": "rgba(26, 31, 38, 0.5)",
    "basics.colors.surfaceDarkGrayShadow": "rgba(0, 0, 0, 0.3)",
    "basics.colors.surfaceLightGrayShadow": "rgba(0, 0, 0, 0.2)",
    "basics.colors.textAgainstDark": "#f5f5f5",
    "basics.colors.textAgainstLight": "#3c3c3c",
    "basics.colors.iconLightGrayColor": "#808080",
    "basics.colors.iconDarkBlueColor": "#a2a6b0",
    "basics.colors.iconDarkGrayColor": "#999999",
    "basics.colors.textLinkAgainstLight": "#006eaf",
    "basics.colors.textLinkAgainstDark": "#6dd2ff",
    "basics.colors.error": "#dd2222",
    "basics.colors.success": "#6a9728",
    "basics.colors.warning": "#faa21b",
    "basics.fontFamilies.main": "ArtifaktElement, sans-serif",
    "basics.fontFamilies.monospace": "'Source Code Pro', monospace",
    "basics.fontSizes.highSmall": "11px",
    "basics.fontSizes.highMedium": "12px",
    "basics.fontSizes.highLarge": "16px",
    "basics.fontSizes.highExtraLarge": "20px",
    "basics.fontSizes.highExtraExtraLarge": "24px",
    "basics.fontSizes.mediumSmall": "12px",
    "basics.fontSizes.mediumMedium": "14px",
    "basics.fontSizes.mediumLarge": "20px",
    "basics.fontSizes.mediumExtraLarge": "24px",
    "basics.fontSizes.mediumExtraExtraLarge": "28px",
    "basics.fontSizes.lowSmall": "14px",
    "basics.fontSizes.lowMedium": "16px",
    "basics.fontSizes.lowLarge": "22px",
    "basics.fontSizes.lowExtraLarge": "26px",
    "basics.fontSizes.lowExtraExtraLarge": "30px",
    "basics.fontWeights.regular": 400,
    "basics.fontWeights.medium": 600,
    "basics.fontWeights.bold": 700,
    "basics.lineHeights.small": "1.3",
    "basics.lineHeights.medium": "1.4",
    "basics.lineHeights.large": "1.5",
    "basics.lineHeights.highSmall": "1.25",
    "basics.lineHeights.highMedium": "1.272727273",
    "basics.lineHeights.highLarge": "1.3",
    "basics.lineHeights.highExtraLarge": "1.333333333",
    "basics.lineHeights.highExtraExtraLarge": "1.375",
    "basics.lineHeights.mediumSmall": "1.25",
    "basics.lineHeights.mediumMedium": "1.285714286",
    "basics.lineHeights.mediumLarge": "1.3",
    "basics.lineHeights.mediumExtraLarge": "1.428571429",
    "basics.lineHeights.mediumExtraExtraLarge": "1.5",
    "basics.shadows.lowBlur": "4px",
    "basics.shadows.highBlur": "16px",
    "basics.spacings.none": "0",
    "basics.spacings.highExtraExtraSmall": "2px",
    "basics.spacings.highExtraSmall": "4px",
    "basics.spacings.highSmall": "8px",
    "basics.spacings.highMedium": "12px",
    "basics.spacings.highLarge": "16px",
    "basics.spacings.highExtraLarge": "24px",
    "basics.spacings.highExtraExtraLarge": "32px",
    "basics.spacings.mediumExtraExtraSmall": "4px",
    "basics.spacings.mediumExtraSmall": "8px",
    "basics.spacings.mediumSmall": "12px",
    "basics.spacings.mediumMedium": "16px",
    "basics.spacings.mediumLarge": "24px",
    "basics.spacings.mediumExtraLarge": "32px",
    "basics.spacings.mediumExtraExtraLarge": "48px",
    "basics.spacings.lowExtraExtraSmall": "8px",
    "basics.spacings.lowExtraSmall": "12px",
    "basics.spacings.lowSmall": "16px",
    "basics.spacings.lowMedium": "24px",
    "basics.spacings.lowLarge": "32px",
    "basics.spacings.lowExtraLarge": "48px",
    "basics.spacings.lowExtraExtraLarge": "64px",
    "colorScheme.reference.accent": "#0696d7",
    "colorScheme.reference.base": "#808080",
    "colorScheme.surface.level100": "#ffffff",
    "colorScheme.surface.level200": "#f5f5f5",
    "colorScheme.surface.level250": "#eeeeee",
    "colorScheme.surface.level300": "#d9d9d9",
    "colorScheme.surface.level350": "#cccccc",
    "colorScheme.background.selected": "rgba(6, 150, 215, 0.15)",
    "colorScheme.background.on.default": "rgba(205, 234, 247, 0.6)",
    "colorScheme.background.on.hover": "rgba(155, 213, 239, 0.7)",
    "colorScheme.background.on.focus": "rgba(205, 234, 247, 0.6)",
    "colorScheme.background.on.pressed": "rgba(106, 192, 231, 0.7)",
    "colorScheme.background.empty.level100To250.hover": "rgba(128, 128, 128, 0.1)",
    "colorScheme.background.empty.level100To250.pressed": "rgba(128, 128, 128, 0.2)",
    "colorScheme.background.empty.level300To350.hover": "rgba(255, 255, 255, 0.25)",
    "colorScheme.background.empty.level300To350.pressed": "rgba(255, 255, 255, 0.35)",
    "colorScheme.background.filled.level100To250.default": "rgba(128, 128, 128, 0.15)",
    "colorScheme.background.filled.level100To250.hover": "rgba(128, 128, 128, 0.25)",
    "colorScheme.background.filled.level100To250.focus": "rgba(128, 128, 128, 0.15)",
    "colorScheme.background.filled.level100To250.pressed": "rgba(128, 128, 128, 0.35)",
    "colorScheme.background.filled.level300To350.default": "rgba(255, 255, 255, 0.5)",
    "colorScheme.background.filled.level300To350.hover": "rgba(255, 255, 255, 0.7)",
    "colorScheme.background.filled.level300To350.focus": "rgba(255, 255, 255, 0.5)",
    "colorScheme.background.filled.level300To350.pressed": "#ffffff",
    "colorScheme.background.transparent": "rgba(128, 128, 128, 0)",
    "colorScheme.border.base": "rgba(128, 128, 128, 0.5)",
    "colorScheme.border.accent": "#0696d7",
    "colorScheme.border.on": "rgba(6, 150, 215, 0.5)",
    "colorScheme.border.transparent": "rgba(128, 128, 128, 0)",
    "colorScheme.halo.hover": "rgba(128, 128, 128, 0.15)",
    "colorScheme.halo.focus": "rgba(6, 150, 215, 0.35)",
    "colorScheme.halo.pressed": "rgba(128, 128, 128, 0.25)",
    "colorScheme.shadow.high": "rgba(0, 0, 0, 0.2)",
    "colorScheme.shadow.low": "rgba(0, 0, 0, 0.2)",
    "colorScheme.text.default": "#3c3c3c",
    "colorScheme.text.dim": "rgba(60, 60, 60, 0.7)",
    "colorScheme.text.placeholder": "rgba(60, 60, 60, 0.4)",
    "colorScheme.text.active": "#0696d7",
    "colorScheme.icon.default": "#808080",
    "colorScheme.icon.hover": "#3c3c3c",
    "colorScheme.icon.focus": "#808080",
    "colorScheme.icon.pressed": "#3c3c3c",
    "colorScheme.icon.on.default": "#0696d7",
    "colorScheme.icon.on.hover": "#006eaf",
    "colorScheme.icon.on.focus": "#0696d7",
    "colorScheme.icon.on.pressed": "#006eaf",
    "colorScheme.indicator.default": "rgba(102, 102, 102, 0.7)",
    "colorScheme.indicator.hover": "#666666",
    "colorScheme.indicator.focus": "rgba(102, 102, 102, 0.7)",
    "colorScheme.indicator.pressed": "#3c3c3c",
    "colorScheme.indicator.on": "#0696d7",
    "colorScheme.status.error": "#dd2222",
    "colorScheme.status.success": "#6a9728",
    "colorScheme.status.warning": "#faa21b",
    "colorScheme.status.info": "#0696d7",
    "colorScheme.status.read": "rgba(128, 128, 128, 0.4)",
    "colorScheme.divider.lightweight": "rgba(60, 60, 60, 0.1)",
    "colorScheme.divider.heavyweight": "rgba(60, 60, 60, 0.25)",
    "colorScheme.opacity.mask": "#e84396",
    "colorScheme.opacity.disabled": 0.4,
    "colorScheme.accentColor": "#0696d7",
    "colorScheme.baseColor": "#808080",
    "colorScheme.surfaceLevel100Color": "#ffffff",
    "colorScheme.surfaceLevel200Color": "#f5f5f5",
    "colorScheme.surfaceLevel250Color": "#eeeeee",
    "colorScheme.surfaceLevel300Color": "#d9d9d9",
    "colorScheme.surfaceLevel350Color": "#cccccc",
    "colorScheme.highShadowColor": "rgba(0, 0, 0, 0.2)",
    "colorScheme.lowShadowColor": "rgba(0, 0, 0, 0.2)",
    "colorScheme.textColor": "#3c3c3c",
    "colorScheme.textColorDim": "rgba(60, 60, 60, 0.7)",
    "colorScheme.iconColor": "#808080",
    "colorScheme.errorColor": "#dd2222",
    "colorScheme.successColor": "#6a9728",
    "colorScheme.warningColor": "#faa21b",
    "colorScheme.infoColor": "#0696d7",
    "colorScheme.component.backgroundColor": "#ffffff",
    "density.spacings.extraExtraSmall": "4px",
    "density.spacings.extraSmall": "8px",
    "density.spacings.small": "12px",
    "density.spacings.medium": "16px",
    "density.spacings.large": "24px",
    "density.spacings.extraLarge": "32px",
    "density.spacings.extraExtraLarge": "48px",
    "density.fontSizes.small": "12px",
    "density.fontSizes.medium": "14px",
    "density.fontSizes.large": "20px",
    "density.fontSizes.extraLarge": "24px",
    "density.fontSizes.extraExtraLarge": "28px",
    "accordion.header.fontColor": "#3c3c3c",
    "accordion.header.fontFamily": "ArtifaktElement, sans-serif",
    "accordion.header.fontSize": "14px",
    "accordion.header.fontWeight": 700,
    "accordion.header.lineHeight": "1.428571429",
    "accordion.header.backgroundColor": "rgba(128, 128, 128, 0.1)",
    "accordion.header.paddingHorizontal": "8px",
    "accordion.header.paddingVertical": "8px",
    "accordion.header.indicatorGutter": "8px",
    "accordion.header.indicatorSize": "16px",
    "accordion.header.default.indicatorColor": "rgba(102, 102, 102, 0.7)",
    "accordion.header.hover.indicatorColor": "#666666",
    "accordion.header.indicatorRight.paddingLeft": "12px",
    "accordion.header.indicatorRight.paddingRight": "16px",
    "accordion.header.indicatorColor": "rgba(102, 102, 102, 0.7)",
    "avatar.fontWeight": 400,
    "avatar.fontColor": "#ffffff",
    "avatar.extraSmall.fontSize": "11px",
    "avatar.extraSmall.diameter": "16px",
    "avatar.small.fontSize": "12px",
    "avatar.small.diameter": "24px",
    "avatar.medium.fontSize": "14px",
    "avatar.medium.diameter": "32px",
    "avatar.large.fontSize": "24px",
    "avatar.large.diameter": "48px",
    "avatar.extraLarge.fontSize": "30px",
    "avatar.extraLarge.diameter": "64px",
    "avatar.backgroundColor1": "#bc2b2b",
    "avatar.backgroundColor2": "#871616",
    "avatar.backgroundColor3": "#ce6d3c",
    "avatar.backgroundColor4": "#527c29",
    "avatar.backgroundColor5": "#1d6328",
    "avatar.backgroundColor6": "#298080",
    "avatar.backgroundColor7": "#23688a",
    "avatar.backgroundColor8": "#3d6ac2",
    "avatar.backgroundColor9": "#163b84",
    "avatar.backgroundColor10": "#5b5bc2",
    "avatar.backgroundColor11": "#571698",
    "avatar.backgroundColor12": "#801d94",
    "avatar.backgroundColor13": "#be29be",
    "avatar.backgroundColor14": "#8f1d69",
    "avatar.backgroundColor15": "#c84b75",
    "avatar.darkBackground.fontColor": "#ffffff",
    "avatar.lightBackground.fontColor": "#3c3c3c",
    "avatar.color1.backgroundColor": "#6ac0e7",
    "avatar.color2.backgroundColor": "#1858a8",
    "avatar.color3.backgroundColor": "#507b16",
    "avatar.color4.backgroundColor": "#ff9582",
    "avatar.color5.backgroundColor": "#4b6b8f",
    "avatar.color6.backgroundColor": "#5bc9bd",
    "avatar.color7.backgroundColor": "#faa21b",
    "avatar.color1.fontColor": "#3c3c3c",
    "avatar.color2.fontColor": "#ffffff",
    "avatar.color3.fontColor": "#ffffff",
    "avatar.color4.fontColor": "#3c3c3c",
    "avatar.color5.fontColor": "#ffffff",
    "avatar.color6.fontColor": "#3c3c3c",
    "avatar.color7.fontColor": "#3c3c3c",
    "avatar.fontColorOnDark": "#ffffff",
    "avatar.fontColorOnLight": "#3c3c3c",
    "avatarBundle.fontColor": "#3c3c3c",
    "avatarBundle.default.backgroundColor": "#eeeeee",
    "avatarBundle.hover.backgroundColor": "#eeeeee",
    "avatarBundle.pressed.backgroundColor": "#eeeeee",
    "avatarBundle.hover.haloColor": "rgba(128, 128, 128, 0.15)",
    "avatarBundle.pressed.haloColor": "rgba(128, 128, 128, 0.25)",
    "avatarBundle.hover.haloWidth": "2px",
    "avatarBundle.pressed.haloWidth": "4px",
    "avatarBundle.extraSmall.default.spacing.secondItem": "16px",
    "avatarBundle.extraSmall.default.spacing.thirdItem": "32px",
    "avatarBundle.small.default.spacing.secondItem": "20px",
    "avatarBundle.small.default.spacing.thirdItem": "40px",
    "avatarBundle.medium.default.spacing.secondItem": "28px",
    "avatarBundle.medium.default.spacing.thirdItem": "56px",
    "avatarBundle.large.default.spacing.secondItem": "44px",
    "avatarBundle.large.default.spacing.thirdItem": "88px",
    "avatarBundle.extraLarge.default.spacing.secondItem": "60px",
    "avatarBundle.extraLarge.default.spacing.thirdItem": "120px",
    "avatarBundle.extraSmall.condensed.spacing.secondItem": "12px",
    "avatarBundle.extraSmall.condensed.spacing.thirdItem": "24px",
    "avatarBundle.small.condensed.spacing.secondItem": "16px",
    "avatarBundle.small.condensed.spacing.thirdItem": "32px",
    "avatarBundle.medium.condensed.spacing.secondItem": "20px",
    "avatarBundle.medium.condensed.spacing.thirdItem": "40px",
    "avatarBundle.large.condensed.spacing.secondItem": "28px",
    "avatarBundle.large.condensed.spacing.thirdItem": "56px",
    "avatarBundle.extraLarge.condensed.spacing.secondItem": "40px",
    "avatarBundle.extraLarge.condensed.spacing.thirdItem": "80px",
    "avatarBundle.extraSmall.superCondensed.spacing.secondItem": "4px",
    "avatarBundle.extraSmall.superCondensed.spacing.thirdItem": "8px",
    "avatarBundle.small.superCondensed.spacing.secondItem": "8px",
    "avatarBundle.small.superCondensed.spacing.thirdItem": "16px",
    "avatarBundle.medium.superCondensed.spacing.secondItem": "12px",
    "avatarBundle.medium.superCondensed.spacing.thirdItem": "24px",
    "avatarBundle.large.superCondensed.spacing.secondItem": "16px",
    "avatarBundle.large.superCondensed.spacing.thirdItem": "32px",
    "avatarBundle.extraLarge.superCondensed.spacing.secondItem": "24px",
    "avatarBundle.extraLarge.superCondensed.spacing.thirdItem": "48px",
    "avatarBundle.extraSmall.border": "1px",
    "avatarBundle.small.border": "1px",
    "avatarBundle.medium.border": "2px",
    "avatarBundle.large.border": "2px",
    "avatarBundle.extraLarge.border": "4px",
    "badge.text.fontFamily": "ArtifaktElement, sans-serif",
    "badge.text.fontSize": "11px",
    "badge.text.fontWeight": 700,
    "badge.text.lineHeight": "1.25",
    "badge.text.padding.horizontal": "8px",
    "badge.text.cornerRadius": "1000em",
    "badge.text.minHeight": "20px",
    "badge.icon.cornerRadius": "50%",
    "badge.icon.large.minHeight": "28px",
    "badge.icon.small.minHeight": "20px",
    "badge.dot.cornerRadius": "50%",
    "badge.dot.large.minHeight": "12px",
    "badge.dot.small.minHeight": "8px",
    "badge.outline.borderWidth": "2px",
    "badge.green.backgroundColor": "#6a9728",
    "badge.green.fontColor": "#ffffff",
    "badge.green.iconColor": "#ffffff",
    "badge.orange.backgroundColor": "#fe8d55",
    "badge.orange.fontColor": "#000000",
    "badge.red.backgroundColor": "#dd2222",
    "badge.red.fontColor": "#ffffff",
    "badge.red.iconColor": "#ffffff",
    "badge.yellow.backgroundColor": "#faa21b",
    "badge.yellow.fontColor": "#000000",
    "badge.yellow.iconColor": "#ffffff",
    "banner.error.backgroundColor": "#ffefec",
    "banner.error.borderColor": "#f9b4b4",
    "banner.error.iconField.backgroundColor": "#dd2222",
    "banner.info.backgroundColor": "#cdeaf7",
    "banner.info.borderColor": "#9bd5ef",
    "banner.info.iconField.backgroundColor": "#0696d7",
    "banner.success.backgroundColor": "#e7f2d9",
    "banner.success.borderColor": "#b7d78c",
    "banner.success.iconField.backgroundColor": "#6a9728",
    "banner.warning.backgroundColor": "#feecd1",
    "banner.warning.borderColor": "#fcc776",
    "banner.warning.iconField.backgroundColor": "#faa21b",
    "banner.info.iconBackground": "#0696d7",
    "banner.success.iconBackground": "#6a9728",
    "banner.warning.iconBackground": "#faa21b",
    "banner.error.iconBackground": "#dd2222",
    "breadcrumb.label.fontColor": "#3c3c3c",
    "breadcrumb.label.fontFamily": "ArtifaktElement, sans-serif",
    "breadcrumb.label.fontSize": "14px",
    "breadcrumb.label.default.fontWeight": 400,
    "breadcrumb.label.selected.fontWeight": 600,
    "breadcrumb.default.indicatorColor": "rgba(102, 102, 102, 0.7)",
    "breadcrumb.selected.indicatorColor": "#3c3c3c",
    "breadcrumb.divider.fontColor": "rgba(60, 60, 60, 0.4)",
    "breadcrumb.divider.fontWeight": 600,
    "button.borderRadius": "2px",
    "button.borderWidth": "1px",
    "button.minWidth": "10px",
    "button.paddingHorizontal": "16px",
    "button.paddingVertical": "8px",
    "button.gutterWidth": "4px",
    "button.label.fontFamily": "ArtifaktElement, sans-serif",
    "button.label.fontSize": "14px",
    "button.label.fontWeight": 600,
    "button.label.lineHeight": "18px",
    "button.haloWidth": "2px",
    "button.hover.haloWidth": "2px",
    "button.pressed.haloWidth": "4px",
    "button.hover.haloColor": "rgba(128, 128, 128, 0.15)",
    "button.focus.haloColor": "rgba(6, 150, 215, 0.35)",
    "button.pressed.haloColor": "rgba(128, 128, 128, 0.25)",
    "button.solid.label.fontColor": "#ffffff",
    "button.solid.iconColor": "#ffffff",
    "button.solid.indicatorColor": "#ffffff",
    "button.solid.default.backgroundColor": "#0696d7",
    "button.solid.hover.backgroundColor": "#0696d7",
    "button.solid.focus.backgroundColor": "#0696d7",
    "button.solid.pressed.backgroundColor": "#0696d7",
    "button.solid.default.borderColor": "#0696d7",
    "button.solid.hover.borderColor": "#0696d7",
    "button.solid.focus.borderColor": "#0696d7",
    "button.solid.pressed.borderColor": "#0696d7",
    "button.outline.label.fontColor": "#3c3c3c",
    "button.outline.indicatorColor": "rgba(102, 102, 102, 0.7)",
    "button.outline.iconColor": "#808080",
    "button.outline.default.backgroundColor": "rgba(128, 128, 128, 0)",
    "button.outline.hover.backgroundColor": "rgba(128, 128, 128, 0)",
    "button.outline.focus.backgroundColor": "rgba(128, 128, 128, 0)",
    "button.outline.pressed.backgroundColor": "rgba(128, 128, 128, 0)",
    "button.outline.default.borderColor": "rgba(128, 128, 128, 0.5)",
    "button.outline.hover.borderColor": "rgba(128, 128, 128, 0.5)",
    "button.outline.focus.borderColor": "#0696d7",
    "button.outline.pressed.borderColor": "rgba(128, 128, 128, 0.85)",
    "button.flat.label.fontColor": "#006eaf",
    "button.flat.iconColor": "#006eaf",
    "button.flat.indicatorColor": "#006eaf",
    "button.flat.default.backgroundColor": "rgba(128, 128, 128, 0)",
    "button.flat.hover.backgroundColor": "rgba(128, 128, 128, 0)",
    "button.flat.focus.backgroundColor": "rgba(128, 128, 128, 0)",
    "button.flat.pressed.backgroundColor": "rgba(128, 128, 128, 0)",
    "button.flat.default.borderColor": "rgba(128, 128, 128, 0)",
    "button.flat.hover.borderColor": "rgba(128, 128, 128, 0)",
    "button.flat.focus.borderColor": "rgba(128, 128, 128, 0)",
    "button.flat.pressed.borderColor": "rgba(128, 128, 128, 0)",
    "button.fontWeight": 600,
    "button.lineHeight": "18px",
    "button.fontFamily": "ArtifaktElement, sans-serif",
    "button.fontSize": "14px",
    "button.gutter": "4px",
    "button.horizontalPadding": "16px",
    "button.minimumWidth": "10px",
    "button.verticalPadding": "8px",
    "button.halo.width": "2px",
    "button.halo.color": "#808080",
    "button.hover.halo.width": "2px",
    "button.focus.halo.width": "2px",
    "button.pressed.halo.width": "4px",
    "button.focus.halo.color": "rgba(6, 150, 215, 0.35)",
    "button.pressed.halo.color": "rgba(128, 128, 128, 0.25)",
    "button.outline.backgroundColor": "rgba(128, 128, 128, 0)",
    "button.outline.borderColor": "rgba(128, 128, 128, 0.5)",
    "button.outline.focus.halo.color": "rgba(6, 150, 215, 0.35)",
    "button.outline.focus.icon.color": "#808080",
    "button.outline.focus.textColor": "#3c3c3c",
    "button.outline.halo.color": "#808080",
    "button.outline.hover.halo.color": "rgba(128, 128, 128, 0.15)",
    "button.outline.hover.icon.color": "#808080",
    "button.outline.hover.textColor": "#3c3c3c",
    "button.outline.icon.color": "#808080",
    "button.outline.pressed.halo.color": "rgba(128, 128, 128, 0.25)",
    "button.outline.pressed.haloWidth": "4px",
    "button.outline.pressed.icon.color": "#808080",
    "button.outline.pressed.textColor": "#3c3c3c",
    "button.outline.textColor": "#3c3c3c",
    "button.solid.backgroundColor": "#0696d7",
    "button.solid.borderColor": "#0696d7",
    "button.solid.halo.color": "#808080",
    "button.solid.textColor": "#ffffff",
    "button.solid.icon.color": "#ffffff",
    "button.solid.hover.halo.color": "rgba(128, 128, 128, 0.15)",
    "button.solid.hover.textColor": "#ffffff",
    "button.solid.hover.icon.color": "#ffffff",
    "button.solid.focus.halo.color": "rgba(6, 150, 215, 0.35)",
    "button.solid.focus.textColor": "#ffffff",
    "button.solid.focus.icon.color": "#ffffff",
    "button.solid.pressed.haloWidth": "4px",
    "button.solid.pressed.halo.color": "rgba(128, 128, 128, 0.25)",
    "button.solid.pressed.textColor": "#ffffff",
    "button.solid.pressed.icon.color": "#ffffff",
    "button.flat.backgroundColor": "rgba(128, 128, 128, 0)",
    "button.flat.borderColor": "rgba(128, 128, 128, 0)",
    "button.flat.halo.color": "#808080",
    "button.flat.textColor": "#006eaf",
    "button.flat.icon.color": "#006eaf",
    "button.flat.hover.halo.color": "rgba(128, 128, 128, 0.15)",
    "button.flat.hover.textColor": "#006eaf",
    "button.flat.hover.icon.color": "#006eaf",
    "button.flat.focus.halo.color": "rgba(6, 150, 215, 0.35)",
    "button.flat.focus.textColor": "#006eaf",
    "button.flat.focus.icon.color": "#006eaf",
    "button.flat.pressed.haloWidth": "4px",
    "button.flat.pressed.halo.color": "rgba(128, 128, 128, 0.25)",
    "button.flat.pressed.textColor": "#006eaf",
    "button.flat.pressed.icon.color": "#006eaf",
    "canvasFrame.label.fontColor": "#3c3c3c",
    "canvasFrame.label.fontFamily": "ArtifaktElement, sans-serif",
    "canvasFrame.label.fontSize": "14px",
    "canvasFrame.label.fontWeight": 600,
    "canvasFrame.label.marginLeft": "12px",
    "canvasFrame.border.borderColor": "#0696d7",
    "canvasFrame.border.borderWidth": "2px",
    "canvasFrame.controlPanel.backgroundColor": "#ffffff",
    "canvasFrame.controlPanel.paddingRight": "12px",
    "canvasFrame.controlPanel.paddingLeft": "8px",
    "canvasFrame.controlPanel.paddingVertical": "8px",
    "canvasFrame.closeIcon.marginLeft": "12px",
    "checkbox.borderWidth": "1px",
    "checkbox.borderRadius": "0",
    "checkbox.halo.color": "rgba(128, 128, 128, 0.15)",
    "checkbox.halo.width": "2px",
    "checkbox.minHeight": "16px",
    "checkbox.height": "16px",
    "checkbox.indicatorColor": "#ffffff",
    "checkbox.iconColor": "#ffffff",
    "checkbox.minWidth": "16px",
    "checkbox.width": "16px",
    "checkbox.unchecked.default.backgroundColor": "rgba(128, 128, 128, 0)",
    "checkbox.backgroundColor": "rgba(128, 128, 128, 0)",
    "checkbox.unchecked.default.borderColor": "rgba(128, 128, 128, 0.5)",
    "checkbox.borderColor": "rgba(128, 128, 128, 0.5)",
    "checkbox.unchecked.hover.borderColor": "rgba(128, 128, 128, 0.5)",
    "checkbox.hover.borderColor": "rgba(128, 128, 128, 0.5)",
    "checkbox.hover.halo.width": "2px",
    "checkbox.hover.halo.color": "rgba(128, 128, 128, 0.15)",
    "checkbox.unchecked.focus.borderColor": "#0696d7",
    "checkbox.focus.borderColor": "#0696d7",
    "checkbox.focus.halo.color": "rgba(6, 150, 215, 0.35)",
    "checkbox.focus.halo.width": "2px",
    "checkbox.unchecked.pressed.borderColor": "rgba(128, 128, 128, 0.5)",
    "checkbox.pressed.borderColor": "rgba(128, 128, 128, 0.5)",
    "checkbox.pressed.halo.color": "rgba(128, 128, 128, 0.25)",
    "checkbox.pressed.halo.width": "4px",
    "checkbox.checked.default.borderColor": "#808080",
    "checkbox.checked.borderColor": "#808080",
    "checkbox.checked.iconColor": "#ffffff",
    "checkbox.checked.default.backgroundColor": "#808080",
    "checkbox.checked.backgroundColor": "#808080",
    "checkbox.indeterminate.borderColor": "#808080",
    "checkbox.indeterminate.iconColor": "#ffffff",
    "checkbox.indeterminate.backgroundColor": "#808080",
    "checkbox.focus.checked.backgroundColor": "#808080",
    "checkbox.focus.checked.borderColor": "#808080",
    "checkbox.focus.indeterminate.borderColor": "#808080",
    "checkbox.focus.haloColor": "rgba(6, 150, 215, 0.35)",
    "checkbox.hover.haloColor": "rgba(128, 128, 128, 0.15)",
    "checkbox.pressed.haloColor": "rgba(128, 128, 128, 0.25)",
    "checkbox.focus.haloWidth": "2px",
    "checkbox.hover.haloWidth": "2px",
    "checkbox.pressed.haloWidth": "4px",
    "checkbox.unchecked.hover.backgroundColor": "rgba(128, 128, 128, 0)",
    "checkbox.unchecked.focus.backgroundColor": "rgba(128, 128, 128, 0)",
    "checkbox.unchecked.pressed.backgroundColor": "rgba(128, 128, 128, 0)",
    "checkbox.checked.hover.backgroundColor": "#808080",
    "checkbox.checked.hover.borderColor": "#808080",
    "checkbox.checked.pressed.backgroundColor": "#808080",
    "checkbox.checked.pressed.borderColor": "#808080",
    "component.disabled.opacity": "0.4",
    "dataVis.colors.red.a.10": "#e7b1ba",
    "dataVis.colors.red.a.20": "#e09da8",
    "dataVis.colors.red.a.30": "#da8997",
    "dataVis.colors.red.a.40": "#d47686",
    "dataVis.colors.red.a.50": "#ce6274",
    "dataVis.colors.red.a.60": "#c84f63",
    "dataVis.colors.red.a.70": "#c23b52",
    "dataVis.colors.red.a.80": "#bc2840",
    "dataVis.colors.red.a.90": "#a31d33",
    "dataVis.colors.red.a.100": "#801628",
    "dataVis.colors.red.b.10": "#e7b2b2",
    "dataVis.colors.red.b.20": "#e09f9f",
    "dataVis.colors.red.b.30": "#da8c8c",
    "dataVis.colors.red.b.40": "#d47878",
    "dataVis.colors.red.b.50": "#ce6565",
    "dataVis.colors.red.b.60": "#c85252",
    "dataVis.colors.red.b.70": "#c23f3f",
    "dataVis.colors.red.b.80": "#bc2b2b",
    "dataVis.colors.red.b.90": "#ab1d1d",
    "dataVis.colors.red.b.100": "#871616",
    "dataVis.colors.red.c.10": "#e7b4a9",
    "dataVis.colors.red.c.20": "#e0a194",
    "dataVis.colors.red.c.30": "#da8e7f",
    "dataVis.colors.red.c.40": "#d47b69",
    "dataVis.colors.red.c.50": "#ce6854",
    "dataVis.colors.red.c.60": "#c8553f",
    "dataVis.colors.red.c.70": "#c24329",
    "dataVis.colors.red.c.80": "#a53823",
    "dataVis.colors.red.c.90": "#882e1d",
    "dataVis.colors.red.c.100": "#6b2516",
    "dataVis.colors.orange.a.10": "#f3dace",
    "dataVis.colors.orange.a.20": "#edc8b6",
    "dataVis.colors.orange.a.30": "#e7b69e",
    "dataVis.colors.orange.a.40": "#e0a485",
    "dataVis.colors.orange.a.50": "#da916d",
    "dataVis.colors.orange.a.60": "#d47f54",
    "dataVis.colors.orange.a.70": "#ce6d3c",
    "dataVis.colors.orange.a.80": "#bd5e2f",
    "dataVis.colors.orange.a.90": "#a45229",
    "dataVis.colors.orange.a.100": "#8b4623",
    "dataVis.colors.orange.b.10": "#f3dcc5",
    "dataVis.colors.orange.b.20": "#edcba9",
    "dataVis.colors.orange.b.30": "#e7b98c",
    "dataVis.colors.orange.b.40": "#e0a86f",
    "dataVis.colors.orange.b.50": "#da9652",
    "dataVis.colors.orange.b.60": "#d0863b",
    "dataVis.colors.orange.b.70": "#bb7835",
    "dataVis.colors.orange.b.80": "#a56a2f",
    "dataVis.colors.orange.b.90": "#905c29",
    "dataVis.colors.orange.b.100": "#7a4e23",
    "dataVis.colors.orange.c.10": "#f3dfb7",
    "dataVis.colors.orange.c.20": "#edcf93",
    "dataVis.colors.orange.c.30": "#e7bf6f",
    "dataVis.colors.orange.c.40": "#e0af4b",
    "dataVis.colors.orange.c.50": "#ce9f41",
    "dataVis.colors.orange.c.60": "#bb903b",
    "dataVis.colors.orange.c.70": "#a88235",
    "dataVis.colors.orange.c.80": "#94732f",
    "dataVis.colors.orange.c.90": "#816429",
    "dataVis.colors.orange.c.100": "#6e5523",
    "dataVis.colors.yellow.a.10": "#f9f2cd",
    "dataVis.colors.yellow.a.20": "#f3e49b",
    "dataVis.colors.yellow.a.30": "#edd768",
    "dataVis.colors.yellow.a.40": "#e0c84e",
    "dataVis.colors.yellow.a.50": "#cfb847",
    "dataVis.colors.yellow.a.60": "#bda841",
    "dataVis.colors.yellow.a.70": "#ab993b",
    "dataVis.colors.yellow.a.80": "#9a8935",
    "dataVis.colors.yellow.a.90": "#88792f",
    "dataVis.colors.yellow.a.100": "#766929",
    "dataVis.colors.yellow.b.10": "#f9f9a5",
    "dataVis.colors.yellow.b.20": "#f1f15a",
    "dataVis.colors.yellow.b.30": "#e1e154",
    "dataVis.colors.yellow.b.40": "#d0d04e",
    "dataVis.colors.yellow.b.50": "#c0c047",
    "dataVis.colors.yellow.b.60": "#afaf41",
    "dataVis.colors.yellow.b.70": "#9f9f3b",
    "dataVis.colors.yellow.b.80": "#8e8e35",
    "dataVis.colors.yellow.b.90": "#7e7e2f",
    "dataVis.colors.yellow.b.100": "#6e6e29",
    "dataVis.colors.yellowGreen.a.10": "#e0f380",
    "dataVis.colors.yellowGreen.a.20": "#d0e954",
    "dataVis.colors.yellowGreen.a.30": "#c1d84e",
    "dataVis.colors.yellowGreen.a.40": "#b2c747",
    "dataVis.colors.yellowGreen.a.50": "#a2b641",
    "dataVis.colors.yellowGreen.a.60": "#93a53b",
    "dataVis.colors.yellowGreen.a.70": "#849435",
    "dataVis.colors.yellowGreen.a.80": "#75832f",
    "dataVis.colors.yellowGreen.a.90": "#667229",
    "dataVis.colors.yellowGreen.a.100": "#566123",
    "dataVis.colors.yellowGreen.b.10": "#d6f39b",
    "dataVis.colors.yellowGreen.b.20": "#c1ed6a",
    "dataVis.colors.yellowGreen.b.30": "#b0e14e",
    "dataVis.colors.yellowGreen.b.40": "#a2cf47",
    "dataVis.colors.yellowGreen.b.50": "#94bd41",
    "dataVis.colors.yellowGreen.b.60": "#86ab3b",
    "dataVis.colors.yellowGreen.b.70": "#789a35",
    "dataVis.colors.yellowGreen.b.80": "#6a882f",
    "dataVis.colors.yellowGreen.b.90": "#5c7629",
    "dataVis.colors.yellowGreen.b.100": "#4f6523",
    "dataVis.colors.yellowGreen.c.10": "#cff3ac",
    "dataVis.colors.yellowGreen.c.20": "#b8ed83",
    "dataVis.colors.yellowGreen.c.30": "#a0e759",
    "dataVis.colors.yellowGreen.c.40": "#90d847",
    "dataVis.colors.yellowGreen.c.50": "#83c641",
    "dataVis.colors.yellowGreen.c.60": "#77b33b",
    "dataVis.colors.yellowGreen.c.70": "#6ba135",
    "dataVis.colors.yellowGreen.c.80": "#5e8e2f",
    "dataVis.colors.yellowGreen.c.90": "#527c29",
    "dataVis.colors.yellowGreen.c.100": "#466923",
    "dataVis.colors.green.a.10": "#b1ed94",
    "dataVis.colors.green.a.20": "#98e770",
    "dataVis.colors.green.a.30": "#7ee04c",
    "dataVis.colors.green.a.40": "#71cf41",
    "dataVis.colors.green.a.50": "#66bc3b",
    "dataVis.colors.green.a.60": "#5ba835",
    "dataVis.colors.green.a.70": "#51952f",
    "dataVis.colors.green.a.80": "#468129",
    "dataVis.colors.green.a.90": "#3c6e23",
    "dataVis.colors.green.a.100": "#315b1d",
    "dataVis.colors.green.b.10": "#adeda0",
    "dataVis.colors.green.b.20": "#92e781",
    "dataVis.colors.green.b.30": "#76e061",
    "dataVis.colors.green.b.40": "#5bda41",
    "dataVis.colors.green.b.50": "#52c63b",
    "dataVis.colors.green.b.60": "#4ab135",
    "dataVis.colors.green.b.70": "#419d2f",
    "dataVis.colors.green.b.80": "#398829",
    "dataVis.colors.green.b.90": "#307423",
    "dataVis.colors.green.b.100": "#285f1d",
    "dataVis.colors.green.c.10": "#a9eda9",
    "dataVis.colors.green.c.20": "#8de78d",
    "dataVis.colors.green.c.30": "#70e070",
    "dataVis.colors.green.c.40": "#54da54",
    "dataVis.colors.green.c.50": "#3bd23b",
    "dataVis.colors.green.c.60": "#35bc35",
    "dataVis.colors.green.c.70": "#2fa62f",
    "dataVis.colors.green.c.80": "#299129",
    "dataVis.colors.green.c.90": "#237b23",
    "dataVis.colors.green.c.100": "#1d651d",
    "dataVis.colors.blueGreen.a.10": "#a6edb2",
    "dataVis.colors.blueGreen.a.20": "#89e798",
    "dataVis.colors.blueGreen.a.30": "#6be07f",
    "dataVis.colors.blueGreen.a.40": "#4eda65",
    "dataVis.colors.blueGreen.a.50": "#3bcd53",
    "dataVis.colors.blueGreen.a.60": "#35b84b",
    "dataVis.colors.blueGreen.a.70": "#2fa342",
    "dataVis.colors.blueGreen.a.80": "#298d3a",
    "dataVis.colors.blueGreen.a.90": "#237831",
    "dataVis.colors.blueGreen.a.100": "#1d6328",
    "dataVis.colors.blueGreen.b.10": "#a3edbb",
    "dataVis.colors.blueGreen.b.20": "#84e7a5",
    "dataVis.colors.blueGreen.b.30": "#65e08e",
    "dataVis.colors.blueGreen.b.40": "#47da78",
    "dataVis.colors.blueGreen.b.50": "#3bc96a",
    "dataVis.colors.blueGreen.b.60": "#35b45f",
    "dataVis.colors.blueGreen.b.70": "#2f9f54",
    "dataVis.colors.blueGreen.b.80": "#298a49",
    "dataVis.colors.blueGreen.b.90": "#23763e",
    "dataVis.colors.blueGreen.b.100": "#1d6133",
    "dataVis.colors.blueGreen.c.10": "#9fedc6",
    "dataVis.colors.blueGreen.c.20": "#7fe7b3",
    "dataVis.colors.blueGreen.c.30": "#5fe0a0",
    "dataVis.colors.blueGreen.c.40": "#41d98d",
    "dataVis.colors.blueGreen.c.50": "#3bc580",
    "dataVis.colors.blueGreen.c.60": "#35b073",
    "dataVis.colors.blueGreen.c.70": "#2f9c65",
    "dataVis.colors.blueGreen.c.80": "#298858",
    "dataVis.colors.blueGreen.c.90": "#23734b",
    "dataVis.colors.blueGreen.c.100": "#1d5f3e",
    "dataVis.colors.cyan.a.10": "#9bedd1",
    "dataVis.colors.cyan.a.20": "#79e7c2",
    "dataVis.colors.cyan.a.30": "#58e0b3",
    "dataVis.colors.cyan.a.40": "#41d5a4",
    "dataVis.colors.cyan.a.50": "#3bc194",
    "dataVis.colors.cyan.a.60": "#35ad85",
    "dataVis.colors.cyan.a.70": "#2f9976",
    "dataVis.colors.cyan.a.80": "#298566",
    "dataVis.colors.cyan.a.90": "#237157",
    "dataVis.colors.cyan.a.100": "#1d5d48",
    "dataVis.colors.cyan.b.10": "#96edde",
    "dataVis.colors.cyan.b.20": "#73e7d3",
    "dataVis.colors.cyan.b.30": "#50e0c8",
    "dataVis.colors.cyan.b.40": "#41d1b9",
    "dataVis.colors.cyan.b.50": "#3bbda8",
    "dataVis.colors.cyan.b.60": "#35aa96",
    "dataVis.colors.cyan.b.70": "#2f9685",
    "dataVis.colors.cyan.b.80": "#298374",
    "dataVis.colors.cyan.b.90": "#236f62",
    "dataVis.colors.cyan.b.100": "#1d5b51",
    "dataVis.colors.cyan.c.10": "#91eded",
    "dataVis.colors.cyan.c.20": "#6ce7e7",
    "dataVis.colors.cyan.c.30": "#47e0e0",
    "dataVis.colors.cyan.c.40": "#41cdcd",
    "dataVis.colors.cyan.c.50": "#3bbaba",
    "dataVis.colors.cyan.c.60": "#35a7a7",
    "dataVis.colors.cyan.c.70": "#2f9393",
    "dataVis.colors.cyan.c.80": "#298080",
    "dataVis.colors.cyan.c.90": "#236d6d",
    "dataVis.colors.cyan.c.100": "#1d5a5a",
    "dataVis.colors.blueCyan.a.10": "#a8e1ed",
    "dataVis.colors.blueCyan.a.20": "#8ad7e7",
    "dataVis.colors.blueCyan.a.30": "#6dcde0",
    "dataVis.colors.blueCyan.a.40": "#50c3da",
    "dataVis.colors.blueCyan.a.50": "#3bb6cf",
    "dataVis.colors.blueCyan.a.60": "#35a3b9",
    "dataVis.colors.blueCyan.a.70": "#2f90a4",
    "dataVis.colors.blueCyan.a.80": "#297e8f",
    "dataVis.colors.blueCyan.a.90": "#236b79",
    "dataVis.colors.blueCyan.a.100": "#1d5864",
    "dataVis.colors.blueCyan.b.10": "#b5daed",
    "dataVis.colors.blueCyan.b.20": "#9dcee7",
    "dataVis.colors.blueCyan.b.30": "#84c2e0",
    "dataVis.colors.blueCyan.b.40": "#6bb5da",
    "dataVis.colors.blueCyan.b.50": "#53a9d4",
    "dataVis.colors.blueCyan.b.60": "#3a9dce",
    "dataVis.colors.blueCyan.b.70": "#2f8cbb",
    "dataVis.colors.blueCyan.b.80": "#297aa2",
    "dataVis.colors.blueCyan.b.90": "#23688a",
    "dataVis.colors.blueCyan.b.100": "#1d5572",
    "dataVis.colors.blueCyan.c.10": "#bed5ed",
    "dataVis.colors.blueCyan.c.20": "#a9c8e7",
    "dataVis.colors.blueCyan.c.30": "#93bae0",
    "dataVis.colors.blueCyan.c.40": "#7eacda",
    "dataVis.colors.blueCyan.c.50": "#689ed4",
    "dataVis.colors.blueCyan.c.60": "#5390ce",
    "dataVis.colors.blueCyan.c.70": "#3d82c8",
    "dataVis.colors.blueCyan.c.80": "#2974c0",
    "dataVis.colors.blueCyan.c.90": "#2363a3",
    "dataVis.colors.blueCyan.c.100": "#1d5186",
    "dataVis.colors.blue.a.10": "#b2c3e7",
    "dataVis.colors.blue.a.20": "#9eb4e0",
    "dataVis.colors.blue.a.30": "#8ba5da",
    "dataVis.colors.blue.a.40": "#7796d4",
    "dataVis.colors.blue.a.50": "#6487ce",
    "dataVis.colors.blue.a.60": "#5178c8",
    "dataVis.colors.blue.a.70": "#3d6ac2",
    "dataVis.colors.blue.a.80": "#2a5bbc",
    "dataVis.colors.blue.a.90": "#1d4ba8",
    "dataVis.colors.blue.a.100": "#163b84",
    "dataVis.colors.blue.b.10": "#b8c0e7",
    "dataVis.colors.blue.b.20": "#a6b0e0",
    "dataVis.colors.blue.b.30": "#95a0da",
    "dataVis.colors.blue.b.40": "#8391d4",
    "dataVis.colors.blue.b.50": "#7181ce",
    "dataVis.colors.blue.b.60": "#6071c8",
    "dataVis.colors.blue.b.70": "#4e61c2",
    "dataVis.colors.blue.b.80": "#3c51bc",
    "dataVis.colors.blue.b.90": "#2a42b6",
    "dataVis.colors.blue.b.100": "#1932af",
    "dataVis.colors.blue.c.10": "#bdbde7",
    "dataVis.colors.blue.c.20": "#adade0",
    "dataVis.colors.blue.c.30": "#9c9cda",
    "dataVis.colors.blue.c.40": "#8c8cd4",
    "dataVis.colors.blue.c.50": "#7c7cce",
    "dataVis.colors.blue.c.60": "#6b6bc8",
    "dataVis.colors.blue.c.70": "#5b5bc2",
    "dataVis.colors.blue.c.80": "#4a4abc",
    "dataVis.colors.blue.c.90": "#3a3ab6",
    "dataVis.colors.blue.c.100": "#2929af",
    "dataVis.colors.purple.a.10": "#c2bbe7",
    "dataVis.colors.purple.a.20": "#b3aae0",
    "dataVis.colors.purple.a.30": "#a499da",
    "dataVis.colors.purple.a.40": "#9488d4",
    "dataVis.colors.purple.a.50": "#8577ce",
    "dataVis.colors.purple.a.60": "#7666c8",
    "dataVis.colors.purple.a.70": "#6755c2",
    "dataVis.colors.purple.a.80": "#5843bc",
    "dataVis.colors.purple.a.90": "#4832b6",
    "dataVis.colors.purple.a.100": "#3921af",
    "dataVis.colors.purple.b.10": "#c8b8e7",
    "dataVis.colors.purple.b.20": "#baa6e0",
    "dataVis.colors.purple.b.30": "#ac95da",
    "dataVis.colors.purple.b.40": "#9e83d4",
    "dataVis.colors.purple.b.50": "#9071ce",
    "dataVis.colors.purple.b.60": "#825fc8",
    "dataVis.colors.purple.b.70": "#744ec2",
    "dataVis.colors.purple.b.80": "#663cbc",
    "dataVis.colors.purple.b.90": "#592ab6",
    "dataVis.colors.purple.b.100": "#4b18af",
    "dataVis.colors.purple.c.10": "#ceb5e7",
    "dataVis.colors.purple.c.20": "#c1a2e0",
    "dataVis.colors.purple.c.30": "#b590da",
    "dataVis.colors.purple.c.40": "#a97dd4",
    "dataVis.colors.purple.c.50": "#9c6bce",
    "dataVis.colors.purple.c.60": "#9058c8",
    "dataVis.colors.purple.c.70": "#8446c2",
    "dataVis.colors.purple.c.80": "#7733bc",
    "dataVis.colors.purple.c.90": "#6b21b6",
    "dataVis.colors.purple.c.100": "#571698",
    "dataVis.colors.magenta.a.10": "#dfc5ed",
    "dataVis.colors.magenta.a.20": "#d5b1e7",
    "dataVis.colors.magenta.a.30": "#ca9ee0",
    "dataVis.colors.magenta.a.40": "#c08ada",
    "dataVis.colors.magenta.a.50": "#b577d4",
    "dataVis.colors.magenta.a.60": "#ab64ce",
    "dataVis.colors.magenta.a.70": "#a050c8",
    "dataVis.colors.magenta.a.80": "#953dc2",
    "dataVis.colors.magenta.a.90": "#8b29bc",
    "dataVis.colors.magenta.a.100": "#791da7",
    "dataVis.colors.magenta.b.10": "#e5c2ed",
    "dataVis.colors.magenta.b.20": "#ddade7",
    "dataVis.colors.magenta.b.30": "#d499e0",
    "dataVis.colors.magenta.b.40": "#cc84da",
    "dataVis.colors.magenta.b.50": "#c370d4",
    "dataVis.colors.magenta.b.60": "#bb5bce",
    "dataVis.colors.magenta.b.70": "#b247c8",
    "dataVis.colors.magenta.b.80": "#aa32c2",
    "dataVis.colors.magenta.b.90": "#9b23b3",
    "dataVis.colors.magenta.b.100": "#801d94",
    "dataVis.colors.magenta.c.10": "#edbeed",
    "dataVis.colors.magenta.c.20": "#e7a8e7",
    "dataVis.colors.magenta.c.30": "#e093e0",
    "dataVis.colors.magenta.c.40": "#da7dda",
    "dataVis.colors.magenta.c.50": "#d467d4",
    "dataVis.colors.magenta.c.60": "#ce52ce",
    "dataVis.colors.magenta.c.70": "#c83cc8",
    "dataVis.colors.magenta.c.80": "#be29be",
    "dataVis.colors.magenta.c.90": "#a223a2",
    "dataVis.colors.magenta.c.100": "#851d85",
    "dataVis.colors.rose.a.10": "#edbfe5",
    "dataVis.colors.rose.a.20": "#e7aadc",
    "dataVis.colors.rose.a.30": "#e095d4",
    "dataVis.colors.rose.a.40": "#da80cb",
    "dataVis.colors.rose.a.50": "#d46bc3",
    "dataVis.colors.rose.a.60": "#ce55ba",
    "dataVis.colors.rose.a.70": "#c840b1",
    "dataVis.colors.rose.a.80": "#c22ba9",
    "dataVis.colors.rose.a.90": "#a72391",
    "dataVis.colors.rose.a.100": "#8a1d78",
    "dataVis.colors.rose.b.10": "#edc1de",
    "dataVis.colors.rose.b.20": "#e7acd3",
    "dataVis.colors.rose.b.30": "#e097c8",
    "dataVis.colors.rose.b.40": "#da82bd",
    "dataVis.colors.rose.b.50": "#d46eb2",
    "dataVis.colors.rose.b.60": "#ce59a7",
    "dataVis.colors.rose.b.70": "#c8449c",
    "dataVis.colors.rose.b.80": "#c22f91",
    "dataVis.colors.rose.b.90": "#ae2380",
    "dataVis.colors.rose.b.100": "#8f1d69",
    "dataVis.colors.rose.c.10": "#edc2d7",
    "dataVis.colors.rose.c.20": "#e7aeca",
    "dataVis.colors.rose.c.30": "#e099bd",
    "dataVis.colors.rose.c.40": "#da85b0",
    "dataVis.colors.rose.c.50": "#d471a2",
    "dataVis.colors.rose.c.60": "#ce5c95",
    "dataVis.colors.rose.c.70": "#c84888",
    "dataVis.colors.rose.c.80": "#c2337b",
    "dataVis.colors.rose.c.90": "#b5236c",
    "dataVis.colors.rose.c.100": "#951d59",
    "dataVis.colors.rose.d.10": "#edc3d1",
    "dataVis.colors.rose.d.20": "#e7afc2",
    "dataVis.colors.rose.d.30": "#e09bb2",
    "dataVis.colors.rose.d.40": "#da87a3",
    "dataVis.colors.rose.d.50": "#d47394",
    "dataVis.colors.rose.d.60": "#ce5f84",
    "dataVis.colors.rose.d.70": "#c84b75",
    "dataVis.colors.rose.d.80": "#c23766",
    "dataVis.colors.rose.d.90": "#bc2356",
    "dataVis.colors.rose.d.100": "#9c1d47",
    "dataVis.colors.gray.a.10": "#e1e1dc",
    "dataVis.colors.gray.a.20": "#d2d2cd",
    "dataVis.colors.gray.a.30": "#c2c2be",
    "dataVis.colors.gray.a.40": "#b3b3af",
    "dataVis.colors.gray.a.50": "#a4a4a0",
    "dataVis.colors.gray.a.60": "#949491",
    "dataVis.colors.gray.a.70": "#858582",
    "dataVis.colors.gray.a.80": "#767673",
    "dataVis.colors.gray.a.90": "#666664",
    "dataVis.colors.gray.a.100": "#575755",
    "dataVis.colors.gray.b.10": "#e0e0e1",
    "dataVis.colors.gray.b.20": "#d1d1d3",
    "dataVis.colors.gray.b.30": "#c2c2c4",
    "dataVis.colors.gray.b.40": "#b2b2b5",
    "dataVis.colors.gray.b.50": "#a3a3a6",
    "dataVis.colors.gray.b.60": "#939397",
    "dataVis.colors.gray.b.70": "#848488",
    "dataVis.colors.gray.b.80": "#75757a",
    "dataVis.colors.gray.b.90": "#65656b",
    "dataVis.colors.gray.b.100": "#56565c",
    "dataVis.colors.gray.c.10": "#e0e0e0",
    "dataVis.colors.gray.c.20": "#d1d1d1",
    "dataVis.colors.gray.c.30": "#c2c2c2",
    "dataVis.colors.gray.c.40": "#b2b2b2",
    "dataVis.colors.gray.c.50": "#a3a3a3",
    "dataVis.colors.gray.c.60": "#949494",
    "dataVis.colors.gray.c.70": "#858585",
    "dataVis.colors.gray.c.80": "#757575",
    "dataVis.colors.gray.c.90": "#666666",
    "dataVis.colors.gray.c.100": "#575757",
    "datePicker.fontFamily": "ArtifaktElement, sans-serif",
    "datePicker.container.paddingHorizontal": "16px",
    "datePicker.container.paddingVertical": "24px",
    "datePicker.cell.minHeight": "36px",
    "datePicker.cell.minWidth": "36px",
    "datePicker.standardDate.fontColor": "#3c3c3c",
    "datePicker.standardDate.fontSize": "14px",
    "datePicker.standardDate.fontWeight": 400,
    "datePicker.selectedDate.fontWeight": 600,
    "datePicker.selectedDate.fontColor": "#ffffff",
    "datePicker.selectedDate.fontSize": "14px",
    "datePicker.notableDate.fontWeight": 400,
    "datePicker.notableDate.fontColor": "#0696d7",
    "datePicker.notableDate.fontSize": "14px",
    "datePicker.restrictedDate.fontWeight": 400,
    "datePicker.restrictedDate.fontColor": "rgba(60, 60, 60, 0.4)",
    "datePicker.restrictedDate.fontSize": "14px",
    "datePicker.day.fontWeight": 400,
    "datePicker.day.fontColor": "#3c3c3c",
    "datePicker.day.fontSize": "14px",
    "datePicker.header.fontWeight": 600,
    "datePicker.header.fontColor": "#3c3c3c",
    "datePicker.header.fontSize": "20px",
    "datePicker.header.paddingBottom": "24px",
    "datePicker.cell.borderColor": "#eeeeee",
    "datePicker.cell.borderWidth": "1px",
    "datePicker.standardDateCell.default.backgroundColor": "#ffffff",
    "datePicker.standardDateCell.hover.backgroundColor": "rgba(128, 128, 128, 0.1)",
    "datePicker.standardDateCell.focus.backgroundColor": "#ffffff",
    "datePicker.standardDateCell.focus.borderColor": "#0696d7",
    "datePicker.standardDateCell.focus.borderWidth": "1px",
    "datePicker.standardDateCell.focus.haloColor": "rgba(6, 150, 215, 0.35)",
    "datePicker.standardDateCell.focus.haloWidth": "2px",
    "datePicker.standardDateCell.pressed.backgroundColor": "rgba(128, 128, 128, 0.2)",
    "datePicker.selectedDateCell.default.backgroundColor": "#0696d7",
    "datePicker.selectedDateCell.focus.backgroundColor": "#0696d7",
    "datePicker.selectedDateCell.focus.haloColor": "rgba(60, 60, 60, 0.25)",
    "datePicker.selectedDateCell.focus.haloWidth": "2px",
    "datePicker.rangeDateCell.default.backgroundColor": "rgba(205, 234, 247, 0.6)",
    "datePicker.rangeDateCell.hover.backgroundColor": "rgba(155, 213, 239, 0.7)",
    "datePicker.rangeDateCell.focus.backgroundColor": "rgba(205, 234, 247, 0.6)",
    "datePicker.rangeDateCell.focus.haloColor": "rgba(6, 150, 215, 0.35)",
    "datePicker.rangeDateCell.focus.haloWidth": "2px",
    "datePicker.rangeDateCell.pressed.backgroundColor": "rgba(128, 128, 128, 0.2)",
    "datePicker.currentDateCell.default.backgroundColor": "#ffffff",
    "datePicker.currentDateCell.default.borderColor": "#0696d7",
    "datePicker.currentDateCell.default.borderWidth": "1px",
    "datePicker.currentDateCell.hover.backgroundColor": "rgba(128, 128, 128, 0.1)",
    "datePicker.currentDateCell.hover.borderColor": "#0696d7",
    "datePicker.currentDateCell.hover.borderWidth": "1px",
    "datePicker.currentDateCell.focus.backgroundColor": "#ffffff",
    "datePicker.currentDateCell.focus.borderColor": "#0696d7",
    "datePicker.currentDateCell.focus.borderWidth": "1px",
    "datePicker.currentDateCell.focus.haloColor": "rgba(6, 150, 215, 0.35)",
    "datePicker.currentDateCell.focus.haloWidth": "2px",
    "datePicker.currentDateCell.pressed.backgroundColor": "rgba(128, 128, 128, 0.2)",
    "datePicker.currentDateCell.pressed.borderColor": "#0696d7",
    "datePicker.currentDateCell.pressed.borderWidth": "1px",
    "divider.borderWidth": "1px",
    "divider.lightColor": "rgba(60, 60, 60, 0.1)",
    "divider.heavyColor": "rgba(60, 60, 60, 0.25)",
    "divider.width": "1px",
    "flyout.backgroundColor": "#ffffff",
    "flyout.borderColor": "rgba(128, 128, 128, 0)",
    "flyout.borderRadius": "4px",
    "flyout.shadowBlur": "16px",
    "flyout.shadowColor": "rgba(0, 0, 0, 0.2)",
    "flyout.nub.hypotenuseLength": "16px",
    "formField.instructionalText.fontSize": "14px",
    "formField.instructionalText.fontWeight": 600,
    "formField.instructionalText.fontFamily": "ArtifaktElement, sans-serif",
    "formField.instructionalText.fontColor": "rgba(60, 60, 60, 0.4)",
    "formField.instructionalText.lineHeight": "1.4",
    "formField.icon.width": "24px",
    "formField.icon.paddingRight": "12px",
    "formField.icon.color": "rgba(102, 102, 102, 0.7)",
    "illustration.colors.100": "#ffffff",
    "illustration.colors.200": "#f5f8fa",
    "illustration.colors.300": "#e6edf0",
    "illustration.colors.400": "#dee7ec",
    "illustration.colors.500": "#ccd9e0",
    "illustration.colors.600": "#b0c4ce",
    "illustration.colors.700": "#8ca9b8",
    "illustration.colors.800": "#5a7d91",
    "illustration.colors.outline": "#5a7d91",
    "iconButton.borderRadius": "2px",
    "iconButton.borderWidth": "0",
    "iconButton.focus.haloColor": "rgba(6, 150, 215, 0.35)",
    "iconButton.focus.haloWidth": "2px",
    "iconButton.dynamic.default.backgroundColor": "rgba(128, 128, 128, 0)",
    "iconButton.dynamic.hover.backgroundColor": "rgba(128, 128, 128, 0)",
    "iconButton.dynamic.focus.backgroundColor": "rgba(128, 128, 128, 0)",
    "iconButton.dynamic.default.iconColor": "#808080",
    "iconButton.dynamic.hover.iconColor": "#3c3c3c",
    "iconButton.dynamic.focus.iconColor": "#808080",
    "iconButton.dynamic.pressed.iconColor": "#3c3c3c",
    "iconButton.dynamic.on.default.iconColor": "#0696d7",
    "iconButton.dynamic.on.hover.iconColor": "#006eaf",
    "iconButton.dynamic.on.focus.iconColor": "#0696d7",
    "iconButton.dynamic.on.pressed.iconColor": "#006eaf",
    "iconButton.dynamic.pressed.100To250BackgroundColor": "rgba(128, 128, 128, 0.2)",
    "iconButton.dynamic.pressed.300To350BackgroundColor": "rgba(255, 255, 255, 0.35)",
    "iconButton.static.default.backgroundColor": "rgba(128, 128, 128, 0)",
    "iconButton.static.focus.backgroundColor": "rgba(128, 128, 128, 0)",
    "iconButton.static.default.borderColor": "rgba(128, 128, 128, 0)",
    "iconButton.static.hover.borderColor": "rgba(128, 128, 128, 0)",
    "iconButton.static.focus.borderColor": "rgba(128, 128, 128, 0)",
    "iconButton.static.pressed.borderColor": "rgba(128, 128, 128, 0)",
    "iconButton.static.on.default.backgroundColor": "rgba(155, 213, 239, 0.7)",
    "iconButton.static.on.hover.backgroundColor": "rgba(155, 213, 239, 0.7)",
    "iconButton.static.on.focus.backgroundColor": "rgba(205, 234, 247, 0.6)",
    "iconButton.static.on.pressed.backgroundColor": "rgba(106, 192, 231, 0.7)",
    "iconButton.static.on.default.borderColor": "rgba(6, 150, 215, 0.5)",
    "iconButton.static.on.hover.borderColor": "rgba(6, 150, 215, 0.5)",
    "iconButton.static.on.focus.borderColor": "#0696d7",
    "iconButton.static.on.pressed.borderColor": "rgba(6, 150, 215, 0.5)",
    "iconButton.static.hover.100To250BackgroundColor": "rgba(128, 128, 128, 0.1)",
    "iconButton.static.pressed.100To250BackgroundColor": "rgba(128, 128, 128, 0.2)",
    "iconButton.static.hover.300To350BackgroundColor": "rgba(255, 255, 255, 0.25)",
    "iconButton.static.pressed.300To350BackgroundColor": "rgba(255, 255, 255, 0.35)",
    "iconButton.static.on.hover.100To250BackgroundColor": "rgba(6, 150, 215, 0.35)",
    "iconButton.static.on.hover.300To350BackgroundColor": "rgba(6, 150, 215, 0.35)",
    "iconButton.focus.halo.color": "rgba(6, 150, 215, 0.35)",
    "iconButton.focus.halo.width": "2px",
    "iconButton.focus.iconColor": "#808080",
    "iconButton.focus.on.iconColor": "#0696d7",
    "iconButton.hover.iconColor": "#3c3c3c",
    "iconButton.hover.on.iconColor": "#006eaf",
    "iconButton.iconColor": "#808080",
    "iconButton.on.iconColor": "#0696d7",
    "iconButton.pressed.backgroundColor": "rgba(128, 128, 128, 0.2)",
    "iconButton.pressed.iconColor": "#3c3c3c",
    "iconButton.pressed.level100To250.backgroundColor": "rgba(128, 128, 128, 0.2)",
    "iconButton.pressed.level300To350.backgroundColor": "rgba(255, 255, 255, 0.35)",
    "iconButton.pressed.on.iconColor": "#006eaf",
    "iconButton.static.hover.level100To250.backgroundColor": "rgba(128, 128, 128, 0.1)",
    "iconButton.static.hover.level300To350.backgroundColor": "rgba(255, 255, 255, 0.25)",
    "iconButton.static.on.backgroundColor": "rgba(155, 213, 239, 0.7)",
    "iconButton.static.on.borderColor": "rgba(6, 150, 215, 0.5)",
    "iconButton.static.on.hover.level100To250.backgroundColor": "rgba(6, 150, 215, 0.35)",
    "iconButton.static.on.hover.level300To350.backgroundColor": "rgba(6, 150, 215, 0.35)",
    "input.borderWidth": "1px",
    "input.borderBottomWidth": "1px",
    "input.borderColor": "rgba(128, 128, 128, 0.2)",
    "input.borderRadius": "0",
    "input.haloWidth": "4px",
    "input.minHeight": "36px",
    "input.paddingVertical": "4px",
    "input.gutterWidth": "8px",
    "input.disabled.opacity": 0.4,
    "input.error.borderBottomColor": "#dd2222",
    "input.hover.haloColor": "rgba(128, 128, 128, 0.15)",
    "input.focus.haloColor": "rgba(6, 150, 215, 0.25)",
    "input.pressed.haloColor": "rgba(128, 128, 128, 0.25)",
    "input.value.fontColor": "#3c3c3c",
    "input.value.fontFamily": "ArtifaktElement, sans-serif",
    "input.value.fontSize": "14px",
    "input.value.fontWeight": 600,
    "input.value.highlightColor": "rgba(6, 150, 215, 0.2)",
    "input.value.lineHeight": "1.4",
    "input.value.placeholderFontColor": "rgba(60, 60, 60, 0.4)",
    "input.indicator.default": "rgba(102, 102, 102, 0.7)",
    "input.indicator.focus": "rgba(102, 102, 102, 0.7)",
    "input.indicator.hover": "#666666",
    "input.indicator.pressed": "#3c3c3c",
    "input.line.paddingHorizontal": "0",
    "input.line.default.borderBottomColor": "rgba(128, 128, 128, 0.35)",
    "input.line.hover.borderBottomColor": "#808080",
    "input.line.focus.borderBottomColor": "#0696d7",
    "input.line.pressed.borderBottomColor": "rgba(128, 128, 128, 0.85)",
    "input.box.paddingHorizontal": "12px",
    "input.box.default.backgroundColor": "#ffffff",
    "input.box.hover.backgroundColor": "#ffffff",
    "input.box.focus.backgroundColor": "#ffffff",
    "input.box.pressed.backgroundColor": "#ffffff",
    "input.box.default.borderColor": "rgba(128, 128, 128, 0.2)",
    "input.box.hover.borderColor": "rgba(128, 128, 128, 0.2)",
    "input.box.focus.borderColor": "rgba(128, 128, 128, 0.2)",
    "input.box.pressed.borderColor": "rgba(128, 128, 128, 0.2)",
    "input.box.default.borderBottomColor": "rgba(255, 255, 255, 0.2)",
    "input.box.hover.borderBottomColor": "#808080",
    "input.box.focus.borderBottomColor": "#0696d7",
    "input.box.pressed.borderBottomColor": "rgba(128, 128, 128, 0.85)",
    "input.textArea.line.borderColor": "rgba(128, 128, 128, 0.2)",
    "input.active.halo.color": "rgba(6, 150, 215, 0.25)",
    "input.borderBottomColor": "rgba(128, 128, 128, 0.35)",
    "input.active.halo.width": "4px",
    "input.box.backgroundColor": "#ffffff",
    "input.box.borderBottomColor": "rgba(255, 255, 255, 0.2)",
    "input.boxType.horizontalPadding": "12px",
    "input.focus.borderBottomColor": "#0696d7",
    "input.focus.halo.color": "rgba(6, 150, 215, 0.25)",
    "input.focus.halo.width": "4px",
    "input.fontColor": "#3c3c3c",
    "input.fontFamily": "ArtifaktElement, sans-serif",
    "input.fontSize": "14px",
    "input.fontWeight": 600,
    "input.halo.color": "rgba(128, 128, 128, 0.15)",
    "input.halo.width": "4px",
    "input.height": "36px",
    "input.highlightColor": "rgba(6, 150, 215, 0.2)",
    "input.horizontalPadding": "0",
    "input.hover.borderBottomColor": "#808080",
    "input.hover.halo.width": "4px",
    "input.lineHeight": "1.4",
    "input.placeholder.fontColor": "rgba(60, 60, 60, 0.4)",
    "input.verticalPadding": "4px",
    "label.fontFamily": "ArtifaktElement, sans-serif",
    "label.fontSize": "14px",
    "label.fontColor": "rgba(60, 60, 60, 0.9)",
    "label.hover.fontColor": "rgba(60, 60, 60, 0.9)",
    "label.fontWeight": 400,
    "label.lineHeight": "1.4",
    "label.top.fontSize": "12px",
    "menu.backgroundColor": "#ffffff",
    "menu.fontFamily": "ArtifaktElement, sans-serif",
    "menu.borderRadius": "0",
    "menu.topFlushBorderTopRadius": "0",
    "menu.container.paddingVertical": "8px",
    "menu.divider.backgroundColor": "rgba(60, 60, 60, 0.1)",
    "menu.divider.paddingVertical": "12px",
    "menu.header.fontSize": "12px",
    "menu.header.fontWeight": 700,
    "menu.header.fontColor": "#3c3c3c",
    "menu.header.marginBottom": "12px",
    "menu.label.fontSize": "14px",
    "menu.label.default.fontWeight": 400,
    "menu.label.selected.fontWeight": 700,
    "menu.label.fontColor": "#3c3c3c",
    "menu.shortcut.fontSize": "12px",
    "menu.shortcut.fontWeight": 400,
    "menu.shortcut.fontColor": "rgba(60, 60, 60, 0.7)",
    "menu.item.default.backgroundColor": "rgba(128, 128, 128, 0)",
    "menu.item.hover.backgroundColor": "rgba(128, 128, 128, 0.1)",
    "menu.item.focus.backgroundColor": "rgba(128, 128, 128, 0.1)",
    "menu.item.pressed.backgroundColor": "rgba(128, 128, 128, 0.2)",
    "menu.item.pressed.active.backgroundColor": "rgba(128, 128, 128, 0.2)",
    "menu.item.paddingHorizontal": "12px",
    "menu.item.paddingVertical": "8px",
    "menu.item.minHeight": "18px",
    "menu.item.gutterWidth": "12px",
    "menu.item.checkmark.hover.iconColor": "rgba(102, 102, 102, 0.7)",
    "menu.item.checkmark.active.iconColor": "#0696d7",
    "menu.item.indicatorColor": "rgba(102, 102, 102, 0.7)",
    "menu.item.backgroundColor": "rgba(128, 128, 128, 0)",
    "menu.item.active.backgroundColor": "rgba(128, 128, 128, 0.2)",
    "menu.item.horizontalPadding": "12px",
    "menu.item.verticalPadding": "8px",
    "modal.fontColor": "#3c3c3c",
    "modal.paddingHorizontal": "24px",
    "modal.overlayColor": "rgba(0, 0, 0, 0.5)",
    "modal.header.backgroundColor": "#ffffff",
    "modal.header.borderBottomColor": "rgba(60, 60, 60, 0.25)",
    "modal.header.minHeight": "60px",
    "modal.body.minHeight": "152px",
    "modal.shell.backgroundColor": "#ffffff",
    "modal.shell.borderRadius": "4px",
    "modal.shell.minHeight": "300px",
    "modal.shell.minWidth": "400px",
    "modal.shell.shadowColor": "rgba(0, 0, 0, 0.2)",
    "modal.overlay.color": "rgba(0, 0, 0, 0.5)",
    "modal.textColor": "#3c3c3c",
    "modal.body.height": "152px",
    "modal.horizontalPadding": "24px",
    "modal.header.borderColor": "rgba(60, 60, 60, 0.25)",
    "modal.header.height": "60px",
    "modal.window.backgroundColor": "#ffffff",
    "modal.window.borderRadius": "4px",
    "modal.window.height": "300px",
    "modal.window.width": "400px",
    "modal.window.shadowColor": "rgba(0, 0, 0, 0.2)",
    "notifications.borderRadius": "4px",
    "notifications.fontColor": "#3c3c3c",
    "notifications.fontFamily": "ArtifaktElement, sans-serif",
    "notifications.default.backgroundColor": "rgba(128, 128, 128, 0)",
    "notifications.hover.backgroundColor": "rgba(128, 128, 128, 0.1)",
    "notifications.container.backgroundColor": "#ffffff",
    "notifications.container.borderColor": "rgba(128, 128, 128, 0)",
    "notifications.container.shadowBlur": "4px",
    "notifications.container.shadowColor": "rgba(0, 0, 0, 0.2)",
    "notifications.statusIndicator.width": "3px",
    "notifications.header.fontSize": "14px",
    "notifications.header.fontWeight": 700,
    "notifications.header.lineHeight": "20px",
    "notifications.toast.object.fontSize": "12px",
    "notifications.toast.object.fontWeight": 700,
    "notifications.toast.object.lineHeight": "16px",
    "notifications.toast.description.fontSize": "12px",
    "notifications.toast.description.fontWeight": 400,
    "notifications.toast.description.lineHeight": "16px",
    "panel.container.backgroundColor": "#ffffff",
    "panel.container.padding": "12px",
    "panel.header.actions.padding": "8px",
    "panel.header.backgroundColor": "#d9d9d9",
    "panel.header.labelIcon.marginRight": "12px",
    "panel.header.minHeight": "40px",
    "panel.header.paddingHorizontal": "8px",
    "panel.header.paddingVertical": "4px",
    "panel.label.fontColor": "#3c3c3c",
    "panel.label.fontFamily": "ArtifaktElement, sans-serif",
    "panel.label.fontSize": "14px",
    "panel.label.fontWeight": 400,
    "panel.resize.backgroundColor": "#d9d9d9",
    "panel.resize.grip.backgroundColor": "#808080",
    "progress.bar.backgroundColor": "rgba(0, 0, 0, 0.05)",
    "progress.bar.highlightColor": "#38abdf",
    "progress.bar.borderRadius": "2px",
    "progress.bar.minHeight": "4px",
    "progressBar.backgroundColor": "rgba(0, 0, 0, 0.05)",
    "progressBar.highlightColor": "#38abdf",
    "progressBar.borderRadius": "2px",
    "progressBar.height": "4px",
    "progress.ring.backgroundColor": "rgba(0, 0, 0, 0.05)",
    "progress.ring.highlightColor1": "#007fc6",
    "progress.ring.highlightColor2": "#38abdf",
    "progressRing.backgroundColor": "rgba(0, 0, 0, 0.05)",
    "progressRing.highlightColor1": "#007fc6",
    "progressRing.highlightColor2": "#38abdf",
    "scrollbar.radii": "1000em",
    "scrollbar.height": "5px",
    "scrollbar.default.backgroundColor": "rgba(128, 128, 128, 0.2)",
    "scrollbar.pressed.backgroundColor": "rgba(128, 128, 128, 0.5)",
    "segmentedButton.borderRadius": "2px",
    "segmentedButton.borderWidth": "1px",
    "segmentedButton.gutterWidth": "4px",
    "segmentedButton.minWidth": "10px",
    "segmentedButton.paddingHorizontal": "16px",
    "segmentedButton.paddingVertical": "8px",
    "segmentedButton.default.backgroundColor": "rgba(128, 128, 128, 0)",
    "segmentedButton.hover.backgroundColor": "rgba(128, 128, 128, 0)",
    "segmentedButton.focus.backgroundColor": "rgba(128, 128, 128, 0)",
    "segmentedButton.pressed.backgroundColor": "rgba(128, 128, 128, 0)",
    "segmentedButton.default.borderColor": "rgba(128, 128, 128, 0.5)",
    "segmentedButton.hover.borderColor": "rgba(128, 128, 128, 0.5)",
    "segmentedButton.focus.borderColor": "#0696d7",
    "segmentedButton.pressed.borderColor": "rgba(128, 128, 128, 0.85)",
    "segmentedButton.hover.haloWidth": "2px",
    "segmentedButton.focus.haloWidth": "2px",
    "segmentedButton.pressed.haloWidth": "4px",
    "segmentedButton.hover.haloColor": "rgba(128, 128, 128, 0.15)",
    "segmentedButton.focus.haloColor": "rgba(6, 150, 215, 0.35)",
    "segmentedButton.pressed.haloColor": "rgba(128, 128, 128, 0.25)",
    "segmentedButton.default.iconColor": "#808080",
    "segmentedButton.active.iconColor": "#eeeeee",
    "segmentedButton.active.backgroundColor": "#808080",
    "segmentedButton.label.fontSize": "14px",
    "segmentedButton.label.default.fontColor": "#3c3c3c",
    "segmentedButton.label.default.fontWeight": 600,
    "segmentedButton.label.active.fontColor": "#f5f5f5",
    "segmentedButton.label.active.fontWeight": 700,
    "sideNav.fontFamily": "ArtifaktElement, sans-serif",
    "sideNav.container.backgroundColor": "#ffffff",
    "sideNav.account.fontColor": "#3c3c3c",
    "sideNav.account.fontSize": "12px",
    "sideNav.account.fontWeight": 500,
    "sideNav.account.lineHeight": "1.428571429",
    "sideNav.project.fontColor": "#3c3c3c",
    "sideNav.project.fontSize": "14px",
    "sideNav.project.fontWeight": 700,
    "sideNav.project.lineHeight": "1.428571429",
    "sideNav.module.default.fontColor": "#3c3c3c",
    "sideNav.module.default.fontSize": "14px",
    "sideNav.module.default.fontWeight": 700,
    "sideNav.module.default.lineHeight": "1.428571429",
    "sideNav.module.active.fontColor": "#0696d7",
    "sideNav.module.active.fontSize": "14px",
    "sideNav.module.active.fontWeight": 700,
    "sideNav.module.active.lineHeight": "1.428571429",
    "sideNav.subModule.default.fontColor": "#3c3c3c",
    "sideNav.subModule.default.fontSize": "14px",
    "sideNav.subModule.default.fontWeight": 400,
    "sideNav.subModule.default.lineHeight": "1.428571429",
    "sideNav.subModule.active.fontColor": "#0696d7",
    "sideNav.subModule.active.fontSize": "14px",
    "sideNav.subModule.active.fontWeight": 400,
    "sideNav.subModule.active.lineHeight": "1.428571429",
    "sideNav.legal.fontColor": "#3c3c3c",
    "sideNav.legal.fontSize": "12px",
    "sideNav.legal.fontWeight": 500,
    "sideNav.legal.lineHeight": "1.5",
    "sideNav.icon.defaultColor": "#3c3c3c",
    "sideNav.icon.activeColor": "#0696d7",
    "sideNav.activeIndicator.backgroundColor": "#0696d7",
    "skeletonItem.borderRadius": "2px",
    "skeletonItem.minHeight": "16px",
    "skeletonItem.backgroundColor": "rgba(0, 0, 0, 0.06)",
    "skeletonItem.highlightColor": "rgba(255, 255, 255, 0.3)",
    "skeletonItem.defaultHeight": "16px",
    "slider.hover.haloColor": "rgba(128, 128, 128, 0.15)",
    "slider.focus.haloColor": "rgba(6, 150, 215, 0.35)",
    "slider.pressed.haloColor": "rgba(128, 128, 128, 0.25)",
    "slider.hover.haloWidth": "2px",
    "slider.focus.haloWidth": "2px",
    "slider.pressed.haloWidth": "4px",
    "slider.thumb.backgroundColor": "#808080",
    "slider.thumb.minWidth": "6px",
    "slider.thumb.minHeight": "20px",
    "slider.track.backgroundColor": "rgba(128, 128, 128, 0.2)",
    "slider.track.minHeight": "2px",
    "slider.value.backgroundColor": "#808080",
    "slider.inputOverlay.backgroundColor": "rgba(128, 128, 128, 0.2)",
    "slider.halo.width": 0,
    "slider.halo.color": "rgba(128, 128, 128, 0.15)",
    "slider.thumb.width": "6px",
    "slider.focused.halo.color": "rgba(6, 150, 215, 0.35)",
    "slider.focused.halo.width": "2px",
    "slider.focused.thumb.color": "#808080",
    "slider.hover.halo.color": "rgba(128, 128, 128, 0.15)",
    "slider.hover.halo.width": "2px",
    "slider.hover.thumb.color": "#808080",
    "slider.pressed.halo.color": "rgba(128, 128, 128, 0.25)",
    "slider.pressed.halo.width": "4px",
    "slider.pressed.thumb.color": "#808080",
    "slider.track.color": "rgba(128, 128, 128, 0.2)",
    "slider.track.width": "2px",
    "slider.value.color": "#808080",
    "stepIndicator.fontFamily": "ArtifaktElement, sans-serif",
    "stepIndicator.borderWidth": "2px",
    "stepIndicator.minDiameter": "22px",
    "stepIndicator.hover.haloColor": "rgba(128, 128, 128, 0.15)",
    "stepIndicator.focus.haloColor": "rgba(6, 150, 215, 0.35)",
    "stepIndicator.pressed.haloColor": "rgba(128, 128, 128, 0.25)",
    "stepIndicator.hover.haloWidth": "2px",
    "stepIndicator.focus.haloWidth": "2px",
    "stepIndicator.pressed.haloWidth": "4px",
    "stepIndicator.incomplete.backgroundColor": "rgba(128, 128, 128, 0)",
    "stepIndicator.incomplete.borderColor": "#dcdcdc",
    "stepIndicator.inProgress.backgroundColor": "rgba(128, 128, 128, 0)",
    "stepIndicator.inProgress.borderColor": "#0696d7",
    "stepIndicator.completed.backgroundColor": "#0696d7",
    "stepIndicator.completed.iconColor": "#ffffff",
    "stepIndicator.accordion.paddingHorizontal": "16px",
    "stepIndicator.accordion.paddingVertical": "24px",
    "stepIndicator.connector.minWidth": "2px",
    "stepIndicator.connector.default.backgroundColor": "#dcdcdc",
    "stepIndicator.connector.active.backgroundColor": "#0696d7",
    "stepIndicator.label.fontColor": "#3c3c3c",
    "stepIndicator.label.default.fontWeight": 400,
    "stepIndicator.label.horizontal.fontSize": "12px",
    "stepIndicator.label.horizontal.marginBottom": "12px",
    "stepIndicator.label.horizontal.marginTop": "12px",
    "stepIndicator.label.vertical.fontSize": "14px",
    "stepIndicator.label.vertical.marginLeft": "12px",
    "stepIndicator.label.inProgress.fontWeight": 700,
    "stepIndicator.number.fontSize": "14px",
    "stepIndicator.number.inProgress.fontColor": "#0696d7",
    "stepIndicator.number.inProgress.fontWeight": 700,
    "stepIndicator.number.incomplete.fontColor": "rgba(60, 60, 60, 0.4)",
    "stepIndicator.number.incomplete.fontWeight": 600,
    "table.borderWidth": "1px",
    "table.background.backgroundColor": "rgba(255, 255, 255, 0.8)",
    "table.borderRightColor": "rgba(60, 60, 60, 0.1)",
    "table.focus.haloColor": "rgba(6, 150, 215, 0.35)",
    "table.focus.haloWidth": "2px",
    "table.fontColor": "#3c3c3c",
    "table.fontFamily": "ArtifaktElement, sans-serif",
    "table.fontSize": "14px",
    "table.lineHeight": "1.428571429",
    "table.cell.fontWeight": 400,
    "table.cell.action.marginLeft": "12px",
    "table.cell.gutter": "12px",
    "table.cell.iconColor": "#808080",
    "table.cell.paddingHorizontal": "16px",
    "table.cell.paddingVertical": "4px",
    "table.cell.minHeight": "32px",
    "table.frozenColumn.shadowBlur": "4px",
    "table.frozenColumn.shadowColor": "rgba(0, 0, 0, 0.2)",
    "table.cell.multiSelect.default.backgroundColor": "rgba(205, 234, 247, 0.6)",
    "table.cell.multiSelect.default.borderColor": "rgba(128, 128, 128, 0)",
    "table.cell.multiSelect.focus.backgroundColor": "rgba(205, 234, 247, 0.6)",
    "table.cell.multiSelect.focus.borderColor": "#0696d7",
    "table.cell.multiSelect.hover.backgroundColor": "rgba(155, 213, 239, 0.7)",
    "table.cell.multiSelect.hover.borderColor": "rgba(128, 128, 128, 0)",
    "table.cell.multiSelect.pressed.backgroundColor": "rgba(106, 192, 231, 0.7)",
    "table.cell.multiSelect.pressed.borderColor": "rgba(128, 128, 128, 0)",
    "table.cell.null.backgroundColor": "#d9d9d9",
    "table.cell.selected.default.backgroundColor": "rgba(128, 128, 128, 0)",
    "table.cell.selected.default.borderColor": "rgba(6, 150, 215, 0.5)",
    "table.cell.selected.focus.backgroundColor": "rgba(128, 128, 128, 0)",
    "table.cell.selected.focus.borderColor": "#0696d7",
    "table.cell.selected.hover.backgroundColor": "rgba(128, 128, 128, 0)",
    "table.cell.selected.hover.borderColor": "rgba(128, 128, 128, 0)",
    "table.cell.selected.pressed.backgroundColor": "rgba(128, 128, 128, 0)",
    "table.cell.selected.pressed.borderColor": "rgba(128, 128, 128, 0)",
    "table.cell.unselected.default.backgroundColor": "rgba(128, 128, 128, 0)",
    "table.cell.unselected.default.borderColor": "rgba(128, 128, 128, 0)",
    "table.cell.unselected.focus.backgroundColor": "rgba(128, 128, 128, 0)",
    "table.cell.unselected.focus.borderColor": "#0696d7",
    "table.cell.unselected.hover.backgroundColor": "rgba(128, 128, 128, 0.1)",
    "table.cell.unselected.hover.borderColor": "rgba(128, 128, 128, 0)",
    "table.cell.unselected.pressed.backgroundColor": "rgba(128, 128, 128, 0.2)",
    "table.cell.unselected.pressed.borderColor": "rgba(128, 128, 128, 0)",
    "table.header.minHeight": "40px",
    "table.header.backgroundColor": "#cccccc",
    "table.header.iconColor": "#808080",
    "table.header.indicatorColor": "rgba(102, 102, 102, 0.7)",
    "table.header.selected.default.backgroundColor": "rgba(128, 128, 128, 0.2)",
    "table.header.selected.default.borderColor": "rgba(128, 128, 128, 0)",
    "table.header.selected.focus.backgroundColor": "rgba(128, 128, 128, 0.2)",
    "table.header.selected.focus.borderColor": "#0696d7",
    "table.header.unselected.default.backgroundColor": "rgba(128, 128, 128, 0)",
    "table.header.unselected.default.borderColor": "rgba(128, 128, 128, 0)",
    "table.header.unselected.focus.backgroundColor": "rgba(128, 128, 128, 0)",
    "table.header.unselected.focus.borderColor": "#0696d7",
    "table.header.unselected.hover.backgroundColor": "rgba(128, 128, 128, 0.1)",
    "table.header.unselected.hover.borderColor": "rgba(128, 128, 128, 0)",
    "table.header.unselected.pressed.backgroundColor": "rgba(128, 128, 128, 0.2)",
    "table.header.unselected.pressed.borderColor": "rgba(128, 128, 128, 0)",
    "table.header.default.fontWeight": 400,
    "table.header.selected.fontWeight": 700,
    "table.resize.hover.borderColor": "rgba(60, 60, 60, 0.25)",
    "table.resize.pressed.borderColor": "#0696d7",
    "table.row.backgroundColor": "rgba(128, 128, 128, 0)",
    "table.row.checkbox.padding": "8px",
    "table.row.unselected.default.backgroundColor": "rgba(128, 128, 128, 0)",
    "table.row.unselected.default.borderColor": "rgba(60, 60, 60, 0.1)",
    "table.row.unselected.focus.backgroundColor": "rgba(128, 128, 128, 0)",
    "table.row.unselected.focus.borderColor": "#0696d7",
    "table.row.unselected.hover.backgroundColor": "rgba(128, 128, 128, 0.1)",
    "table.row.unselected.hover.borderColor": "rgba(60, 60, 60, 0.1)",
    "table.row.unselected.pressed.backgroundColor": "rgba(128, 128, 128, 0.2)",
    "table.row.unselected.pressed.borderColor": "rgba(60, 60, 60, 0.1)",
    "table.row.selected.default.backgroundColor": "rgba(205, 234, 247, 0.6)",
    "table.row.selected.default.borderColor": "rgba(6, 150, 215, 0.5)",
    "table.row.selected.focus.backgroundColor": "rgba(205, 234, 247, 0.6)",
    "table.row.selected.focus.borderColor": "#0696d7",
    "table.row.selected.hover.backgroundColor": "rgba(155, 213, 239, 0.7)",
    "table.row.selected.hover.borderColor": "rgba(6, 150, 215, 0.5)",
    "table.row.selected.pressed.backgroundColor": "rgba(106, 192, 231, 0.7)",
    "table.row.selected.pressed.borderColor": "rgba(6, 150, 215, 0.5)",
    "table.row.drag.backgroundColor": "#ffffff",
    "table.row.drag.fontWeight": 700,
    "table.row.drag.iconColor": "#808080",
    "table.row.drag.gutter": "16px",
    "table.row.drag.paddingLeft": "4px",
    "table.row.drag.paddingRight": "16px",
    "table.row.drag.paddingVertical": "4px",
    "table.row.drag.shadowBlur": "4px",
    "table.row.drag.shadowColor": "rgba(0, 0, 0, 0.2)",
    "table.zebraStripe.backgroundColor": "rgba(204, 204, 204, 0.2)",
    "table.item.fontWeight": 400,
    "table.row.hover.backgroundColor": "rgba(128, 128, 128, 0.1)",
    "table.row.pressed.backgroundColor": "rgba(128, 128, 128, 0.2)",
    "table.row.selected.backgroundColor": "rgba(205, 234, 247, 0.6)",
    "table.header.borderTopColor": "rgba(60, 60, 60, 0.1)",
    "table.header.borderBottomColor": "rgba(60, 60, 60, 0.1)",
    "tabs.focus.haloWidth": "2px",
    "tabs.focus.haloColor": "rgba(6, 150, 215, 0.5)",
    "tabs.label.fontColor": "#3c3c3c",
    "tabs.label.fontFamily": "ArtifaktElement, sans-serif",
    "tabs.label.fontSize": "14px",
    "tabs.label.inactive.fontWeight": 400,
    "tabs.label.active.fontWeight": 700,
    "tabs.label.active.lineHeight": "1.428571429",
    "tabs.iconSize": "24px",
    "tabs.iconColor": "#808080",
    "tabs.iconGutter": "12px",
    "tabs.closeButton.minSize": "16px",
    "tabs.closeButton.gutter": "12px",
    "tabs.closeButton.default.iconColor": "#808080",
    "tabs.closeButton.hover.iconColor": "#3c3c3c",
    "tabs.closeButton.pressed.iconColor": "#3c3c3c",
    "tabs.underline.wrapper.borderBottomColor": "rgba(128, 128, 128, 0.35)",
    "tabs.underline.wrapper.borderBottomWidth": "1px",
    "tabs.underline.tab.gutter": "24px",
    "tabs.underline.tab.paddingBottom": "4px",
    "tabs.underline.hover.haloColor": "rgba(128, 128, 128, 0.85)",
    "tabs.underline.active.haloColor": "#0696d7",
    "tabs.box.wrapper.backgroundColor": "rgba(128, 128, 128, 0)",
    "tabs.box.tab.paddingHorizontal": "12px",
    "tabs.box.tab.paddingVertical": "8px",
    "tabs.box.tab.active.backgroundColor": "#ffffff",
    "tabs.box.tab.hover.backgroundColor": "rgba(255, 255, 255, 0.5)",
    "tabs.box.divider.borderColor": "rgba(60, 60, 60, 0.25)",
    "tabs.box.dividerWidth": "1px",
    "tabs.box.dividerHeight": "18px",
    "tabs.canvas.wrapper.backgroundColor": "rgba(128, 128, 128, 0)",
    "tabs.canvas.tab.paddingHorizontal": "16px",
    "tabs.canvas.tab.paddingVertical": "8px",
    "tabs.canvas.tab.hover.backgroundColor": "rgba(245, 245, 245, 0.5)",
    "tabs.canvas.tab.active.backgroundColor": "#f5f5f5",
    "tabs.canvas.divider.borderColor": "rgba(60, 60, 60, 0.25)",
    "tabs.canvas.dividerWidth": "1px",
    "tabs.canvas.dividerHeight": "18px",
    "tabs.general.tab.fontFamily": "ArtifaktElement, sans-serif",
    "tabs.general.tab.fontSize": "14px",
    "tabs.general.tab.fontWeight": 400,
    "tabs.general.tab.active.fontWeight": 700,
    "tabs.general.tab.color": "#3c3c3c",
    "tabs.general.tab.lineHeight": "1.428571429",
    "tabs.general.halo.size": "2px",
    "tabs.general.halo.color": "rgba(6, 150, 215, 0.5)",
    "tabs.general.icon.size": "24px",
    "tabs.general.icon.color": "#808080",
    "tabs.general.icon.gutter": "12px",
    "tabs.general.closeButton.size": "16px",
    "tabs.general.closeButton.gutter": "12px",
    "tabs.general.closeButton.color": "#808080",
    "tabs.general.closeButton.hover.color": "#3c3c3c",
    "tabs.general.closeButton.pressed.color": "#3c3c3c",
    "tabs.underline.halo.hover.color": "rgba(128, 128, 128, 0.85)",
    "tabs.underline.halo.active.color": "#0696d7",
    "tabs.box.tab.horizontalPadding": "12px",
    "tabs.box.tab.verticalPadding": "8px",
    "tabs.box.divider.color": "rgba(60, 60, 60, 0.25)",
    "tabs.box.divider.width": "1px",
    "tabs.box.divider.height": "18px",
    "tabs.canvas.tab.horizontalPadding": "16px",
    "tabs.canvas.tab.verticalPadding": "8px",
    "tabs.canvas.divider.color": "rgba(60, 60, 60, 0.25)",
    "tabs.canvas.divider.width": "1px",
    "tabs.canvas.divider.height": "18px",
    "tag.borderWidth": "1px",
    "tag.borderRadii": "1000em",
    "tag.hover.haloWidth": "2px",
    "tag.focus.haloWidth": "4px",
    "tag.paddingLeft": "12px",
    "tag.paddingRight": "8px",
    "tag.paddingVertical": "8px",
    "tag.default.backgroundColor": "rgba(128, 128, 128, 0.15)",
    "tag.hover.backgroundColor": "rgba(128, 128, 128, 0.25)",
    "tag.focus.backgroundColor": "rgba(128, 128, 128, 0.15)",
    "tag.pressed.backgroundColor": "rgba(128, 128, 128, 0.35)",
    "tag.default.borderColor": "rgba(128, 128, 128, 0)",
    "tag.hover.borderColor": "rgba(128, 128, 128, 0)",
    "tag.focus.borderColor": "rgba(128, 128, 128, 0)",
    "tag.pressed.borderColor": "rgba(128, 128, 128, 0)",
    "tag.focus.haloColor": "rgba(6, 150, 215, 0.35)",
    "tag.on.default.backgroundColor": "rgba(205, 234, 247, 0.6)",
    "tag.on.hover.backgroundColor": "rgba(128, 128, 128, 0.1)",
    "tag.on.focus.backgroundColor": "rgba(205, 234, 247, 0.6)",
    "tag.on.pressed.backgroundColor": "rgba(128, 128, 128, 0.7)",
    "tag.on.default.borderColor": "rgba(6, 150, 215, 0.5)",
    "tag.on.hover.borderColor": "rgba(6, 150, 215, 0.5)",
    "tag.on.focus.borderColor": "#0696d7",
    "tag.on.pressed.borderColor": "rgba(6, 150, 215, 0.5)",
    "tag.on.focus.haloColor": "rgba(6, 150, 215, 0.35)",
    "tag.label.marginRight": "8px",
    "tag.label.fontColor": "#3c3c3c",
    "tag.label.fontFamily": "ArtifaktElement, sans-serif",
    "tag.label.fontSize": "14px",
    "tag.label.fontWeight": 600,
    "tag.closeButton.iconColor": "#808080",
    "textArea.minHeight": "250px",
    "textArea.borderColor": "rgba(128, 128, 128, 0.2)",
    "textLink.focus.haloColor": "rgba(6, 150, 215, 0.35)",
    "textLink.focus.haloWidth": "2px",
    "textLink.primary.default.fontColor": "#006eaf",
    "textLink.primary.hover.fontColor": "#006eaf",
    "textLink.primary.focus.fontColor": "#006eaf",
    "textLink.primary.hover.underlineColor": "#006eaf",
    "textLink.secondary.default.fontColor": "#3c3c3c",
    "textLink.secondary.hover.fontColor": "#3c3c3c",
    "textLink.secondary.focus.fontColor": "#3c3c3c",
    "textLink.secondary.hover.underlineColor": "#3c3c3c",
    "textLink.textColor": "#006eaf",
    "textLink.hover.textColor": "#006eaf",
    "textLink.focus.textColor": "#006eaf",
    "textLink.hover.underline.color": "#006eaf",
    "textLink.focus.halo.color": "rgba(6, 150, 215, 0.35)",
    "textLink.focus.halo.width": "2px",
    "tile.borderRadii": "0",
    "tile.borderWidth": "1px",
    "tile.haloWidth": "4px",
    "tile.padding": "12px",
    "tile.fontColor": "#3c3c3c",
    "tile.fontFamily": "ArtifaktElement, sans-serif",
    "tile.focus.haloColor": "rgba(6, 150, 215, 0.35)",
    "tile.thumbnail.marginRight": "12px",
    "tile.title.fontSize": "14px",
    "tile.title.fontWeight": 600,
    "tile.title.lineHeight": "1.333333333",
    "tile.title.marginBottom": "8px",
    "tile.subTitle.fontSize": "12px",
    "tile.subTitle.fontWeight": 400,
    "tile.subTitle.lineHeight": "1.272727273",
    "tile.default.level300To350BackgroundColor": "rgba(255, 255, 255, 0.5)",
    "tile.hover.level300To350BackgroundColor": "rgba(255, 255, 255, 0.7)",
    "tile.focus.level300To350BackgroundColor": "rgba(255, 255, 255, 0.5)",
    "tile.pressed.level300To350BackgroundColor": "rgba(255, 255, 255, 0.9)",
    "tile.selected.default.backgroundColor": "rgba(205, 234, 247, 0.6)",
    "tile.selected.hover.backgroundColor": "rgba(155, 213, 239, 0.7)",
    "tile.selected.focus.backgroundColor": "rgba(205, 234, 247, 0.6)",
    "tile.selected.pressed.backgroundColor": "rgba(128, 128, 128, 0.2)",
    "tile.selected.default.borderColor": "rgba(6, 150, 215, 0.5)",
    "tile.selected.hover.borderColor": "rgba(6, 150, 215, 0.5)",
    "tile.selected.focus.borderColor": "#0696d7",
    "tile.selected.pressed.borderColor": "rgba(6, 150, 215, 0.5)",
    "tile.filled.default.level100To250.backgroundColor": "rgba(128, 128, 128, 0.15)",
    "tile.filled.hover.level100To250.backgroundColor": "rgba(128, 128, 128, 0.25)",
    "tile.filled.focus.level100To250.backgroundColor": "rgba(128, 128, 128, 0.15)",
    "tile.filled.pressed.level100To250.backgroundColor": "rgba(128, 128, 128, 0.35)",
    "tile.filled.default.level100To250.borderColor": "rgba(128, 128, 128, 0)",
    "tile.filled.hover.level100To250.borderColor": "rgba(128, 128, 128, 0)",
    "tile.filled.focus.level100To250.borderColor": "rgba(128, 128, 128, 0)",
    "tile.filled.pressed.level100To250.borderColor": "rgba(128, 128, 128, 0)",
    "tile.filled.default.level300To350.backgroundColor": "rgba(255, 255, 255, 0.5)",
    "tile.filled.hover.level300To350.backgroundColor": "rgba(255, 255, 255, 0.7)",
    "tile.filled.focus.level300To350.backgroundColor": "rgba(255, 255, 255, 0.5)",
    "tile.filled.pressed.level300To350.backgroundColor": "#ffffff",
    "tile.filled.default.level300To350.borderColor": "rgba(128, 128, 128, 0)",
    "tile.filled.hover.level300To350.borderColor": "rgba(128, 128, 128, 0)",
    "tile.filled.focus.level300To350.borderColor": "rgba(128, 128, 128, 0)",
    "tile.filled.pressed.level300To350.borderColor": "rgba(128, 128, 128, 0)",
    "tile.empty.default.level100To250.backgroundColor": "rgba(128, 128, 128, 0)",
    "tile.empty.hover.level100To250.backgroundColor": "rgba(128, 128, 128, 0.1)",
    "tile.empty.focus.level100To250.backgroundColor": "rgba(128, 128, 128, 0)",
    "tile.empty.pressed.level100To250.backgroundColor": "rgba(128, 128, 128, 0.2)",
    "tile.empty.default.level100To250.borderColor": "rgba(128, 128, 128, 0)",
    "tile.empty.hover.level100To250.borderColor": "rgba(128, 128, 128, 0)",
    "tile.empty.focus.level100To250.borderColor": "rgba(128, 128, 128, 0)",
    "tile.empty.pressed.level100To250.borderColor": "rgba(128, 128, 128, 0)",
    "tile.empty.default.level300To350.backgroundColor": "rgba(128, 128, 128, 0)",
    "tile.empty.hover.level300To350.backgroundColor": "rgba(255, 255, 255, 0.25)",
    "tile.empty.focus.level300To350.backgroundColor": "rgba(128, 128, 128, 0)",
    "tile.empty.pressed.level300To350.backgroundColor": "rgba(255, 255, 255, 0.35)",
    "tile.empty.default.level300To350.borderColor": "rgba(128, 128, 128, 0)",
    "tile.empty.hover.level300To350.borderColor": "rgba(255, 255, 255, 0.25)",
    "tile.empty.focus.level300To350.borderColor": "rgba(128, 128, 128, 0)",
    "tile.empty.pressed.level300To350.borderColor": "rgba(255, 255, 255, 0.35)",
    "timestamp.fontColor": "rgba(60, 60, 60, 0.7)",
    "timestamp.fontFamily": "ArtifaktElement, sans-serif",
    "timestamp.fontSize": "12px",
    "timestamp.fontWeight": 400,
    "timestamp.lineHeight": "20px",
    "thumbnail.backgroundColor": "#eeeeee",
    "thumbnail.borderColor": "rgba(128, 128, 128, 0.5)",
    "toggle.borderRadii": "1000em",
    "toggle.borderWidth": "1px",
    "toggle.minHeight": "20px",
    "toggle.minWidth": "37px",
    "toggle.padding": "4px",
    "toggle.hover.haloColor": "rgba(128, 128, 128, 0.15)",
    "toggle.focus.haloColor": "rgba(6, 150, 215, 0.35)",
    "toggle.pressed.haloColor": "rgba(128, 128, 128, 0.25)",
    "toggle.hover.haloWidth": "2px",
    "toggle.focus.haloWidth": "2px",
    "toggle.pressed.haloWidth": "4px",
    "toggle.off.default.backgroundColor": "rgba(128, 128, 128, 0)",
    "toggle.off.default.borderColor": "rgba(128, 128, 128, 0.5)",
    "toggle.off.hover.backgroundColor": "rgba(128, 128, 128, 0)",
    "toggle.off.focus.backgroundColor": "rgba(128, 128, 128, 0)",
    "toggle.off.pressed.backgroundColor": "rgba(128, 128, 128, 0)",
    "toggle.off.hover.borderColor": "rgba(128, 128, 128, 0.5)",
    "toggle.off.focus.borderColor": "#0696d7",
    "toggle.off.pressed.borderColor": "rgba(128, 128, 128, 0.5)",
    "toggle.on.default.backgroundColor": "#0696d7",
    "toggle.on.default.borderColor": "#0696d7",
    "toggle.thumb.borderRadii": "50%",
    "toggle.thumb.minDiameter": "12px",
    "toggle.thumb.on.backgroundColor": "#ffffff",
    "toggle.thumb.off.backgroundColor": "#808080",
    "token.borderRadii": "0",
    "token.paddingLeft": "8px",
    "token.paddingRight": "4px",
    "token.paddingVertical": "4px",
    "token.default.backgroundColor": "rgba(128, 128, 128, 0.15)",
    "token.hover.backgroundColor": "rgba(128, 128, 128, 0.25)",
    "token.pressed.backgroundColor": "rgba(128, 128, 128, 0.35)",
    "token.default.borderColor": "rgba(128, 128, 128, 0)",
    "token.hover.borderColor": "rgba(128, 128, 128, 0)",
    "token.pressed.borderColor": "rgba(128, 128, 128, 0)",
    "token.selected.default.backgroundColor": "rgba(205, 234, 247, 0.6)",
    "token.selected.hover.backgroundColor": "rgba(155, 213, 239, 0.7)",
    "token.selected.pressed.backgroundColor": "rgba(128, 128, 128, 0.2)",
    "token.selected.default.borderColor": "rgba(6, 150, 215, 0.5)",
    "token.selected.hover.borderColor": "rgba(6, 150, 215, 0.5)",
    "token.selected.pressed.borderColor": "rgba(6, 150, 215, 0.5)",
    "token.warning.default.backgroundColor": "rgba(250, 162, 27, 0.15)",
    "token.warning.hover.backgroundColor": "rgba(250, 162, 27, 0.3)",
    "token.warning.iconColor": "#faa21b",
    "token.icon.marginRight": "8px",
    "token.label.fontColor": "#3c3c3c",
    "token.label.fontFamily": "ArtifaktElement, sans-serif",
    "token.label.fontSize": "14px",
    "token.label.fontWeight": 600,
    "token.label.marginRight": "4px",
    "token.closeButton.iconColor": "#808080",
    "tooltip.backgroundColor": "#535353",
    "tooltip.borderRadius": "2px",
    "tooltip.shadowBlur": "16px",
    "tooltip.shadowColor": "rgba(0, 0, 0, 0.2)",
    "tooltip.title.fontColor": "#f5f5f5",
    "tooltip.title.fontFamily": "ArtifaktElement, sans-serif",
    "tooltip.title.fontSize": "12px",
    "tooltip.title.fontWeight": 700,
    "tooltip.title.lineHeight": 1.333333333,
    "tooltip.nub.hypotenuseLength": "16px",
    "tooltip.description.fontColor": "#F5F5F5",
    "tooltip.description.fontFamily": "ArtifaktElement, sans-serif",
    "tooltip.description.fontSize": "12px",
    "tooltip.description.fontWeight": 400,
    "tooltip.description.lineHeight": 1.333333333,
    "tooltip.divider.borderBottomColor": "rgba(255, 255, 255, 0.1)",
    "tooltip.textColor": "#f5f5f5",
    "tooltip.borderColor": "#535353",
    "topNav.padding": "12px",
    "topNav.backgroundColor": "#ffffff",
    "topNav.borderColor": "rgba(60, 60, 60, 0.1)",
    "topNav.productLockupColor": "#000000",
    "topNav.hamburgetIcon.margin": "8px",
    "treeView.fontColor": "#3c3c3c",
    "treeView.fontFamily": "ArtifaktElement, sans-serif",
    "treeView.indicatorColor": "#3c3c3c",
    "treeView.icon.marginRight": "8px",
    "treeView.row.height": "40px",
    "treeView.row.paddingHorizontal": "12px",
    "treeView.row.paddingVertical": "8px",
    "treeView.title.fontSize": "14px",
    "treeView.title.fontWeight": 600,
    "treeView.title.lineHeight": "1.428571429",
    "treeView.item.fontSize": "14px",
    "treeView.item.fontWeight": 600,
    "treeView.item.lineHeight": "1.428571429",
    "treeView.guideLine.backgroundColor": "rgba(128, 128, 128, 0.5)",
    "typography.body.fontFamily": "ArtifaktElement, sans-serif",
    "typography.body.fontWeight": 400,
    "typography.body.fontSize": "14px",
    "typography.body.lineHeight": "1.428571429",
    "typography.body.color": "#3c3c3c",
    "typography.caption.fontFamily": "ArtifaktElement, sans-serif",
    "typography.caption.fontWeight": 400,
    "typography.caption.fontSize": "12px",
    "typography.caption.lineHeight": "1.5",
    "typography.caption.color": "#3c3c3c",
    "typography.h1.fontFamily": "ArtifaktElement, sans-serif",
    "typography.h1.fontWeight": 400,
    "typography.h1.fontSize": "28px",
    "typography.h1.lineHeight": "1.285714286",
    "typography.h1.color": "#3c3c3c",
    "typography.h2.fontFamily": "ArtifaktElement, sans-serif",
    "typography.h2.fontWeight": 400,
    "typography.h2.fontSize": "24px",
    "typography.h2.lineHeight": "1.25",
    "typography.h2.color": "#3c3c3c",
    "typography.h3.fontFamily": "ArtifaktElement, sans-serif",
    "typography.h3.fontWeight": 600,
    "typography.h3.fontSize": "20px",
    "typography.h3.lineHeight": "1.3",
    "typography.h3.color": "#3c3c3c"
  },
  "unresolvedRoles": {
    "basics.borderRadii.none": {
      "value": "0",
      "type": "borderRadius"
    },
    "basics.borderRadii.small": {
      "value": "0",
      "type": "borderRadius"
    },
    "basics.borderRadii.medium": {
      "value": "2px",
      "type": "borderRadius"
    },
    "basics.borderRadii.large": {
      "value": "4px",
      "type": "borderRadius"
    },
    "basics.borderRadii.ellipse": {
      "value": "50%",
      "type": "borderRadius"
    },
    "basics.borderRadii.pill": {
      "value": "1000em",
      "type": "borderRadius"
    },
    "basics.borderWidths.none": {
      "value": "0",
      "type": "borderWidth"
    },
    "basics.borderWidths.small": {
      "value": "1px",
      "type": "borderWidth"
    },
    "basics.borderWidths.medium": {
      "value": "2px",
      "type": "borderWidth"
    },
    "basics.borderWidths.large": {
      "value": "4px",
      "type": "borderWidth"
    },
    "basics.colors.primary.black": {
      "value": "#000000",
      "type": "color"
    },
    "basics.colors.primary.white": {
      "value": "#ffffff",
      "type": "color"
    },
    "basics.colors.primary.autodeskBlue.100": {
      "value": "#cdeaf7",
      "type": "color"
    },
    "basics.colors.primary.autodeskBlue.200": {
      "value": "#9bd5ef",
      "type": "color"
    },
    "basics.colors.primary.autodeskBlue.300": {
      "value": "#6ac0e7",
      "type": "color"
    },
    "basics.colors.primary.autodeskBlue.400": {
      "value": "#38abdf",
      "type": "color"
    },
    "basics.colors.primary.autodeskBlue.500": {
      "value": "#0696d7",
      "type": "color"
    },
    "basics.colors.primary.autodeskBlue.600": {
      "value": "#007fc6",
      "type": "color"
    },
    "basics.colors.primary.autodeskBlue.700": {
      "value": "#006eaf",
      "type": "color"
    },
    "basics.colors.primary.autodeskBlue.800": {
      "value": "#074b78",
      "type": "color"
    },
    "basics.colors.primary.autodeskBlue.900": {
      "value": "#0a324d",
      "type": "color"
    },
    "basics.colors.primary.charcoal.100": {
      "value": "#eeeeee",
      "type": "color"
    },
    "basics.colors.primary.charcoal.200": {
      "value": "#dcdcdc",
      "type": "color"
    },
    "basics.colors.primary.charcoal.300": {
      "value": "#cccccc",
      "type": "color"
    },
    "basics.colors.primary.charcoal.400": {
      "value": "#bbbbbb",
      "type": "color"
    },
    "basics.colors.primary.charcoal.500": {
      "value": "#999999",
      "type": "color"
    },
    "basics.colors.primary.charcoal.600": {
      "value": "#808080",
      "type": "color"
    },
    "basics.colors.primary.charcoal.700": {
      "value": "#666666",
      "type": "color"
    },
    "basics.colors.primary.charcoal.800": {
      "value": "#4d4d4d",
      "type": "color"
    },
    "basics.colors.primary.charcoal.900": {
      "value": "#3c3c3c",
      "type": "color"
    },
    "basics.colors.secondary.darkBlue.100": {
      "value": "#e1ebf7",
      "type": "color"
    },
    "basics.colors.secondary.darkBlue.200": {
      "value": "#bcd3ee",
      "type": "color"
    },
    "basics.colors.secondary.darkBlue.300": {
      "value": "#8babdc",
      "type": "color"
    },
    "basics.colors.secondary.darkBlue.400": {
      "value": "#5f8bcb",
      "type": "color"
    },
    "basics.colors.secondary.darkBlue.500": {
      "value": "#3970b9",
      "type": "color"
    },
    "basics.colors.secondary.darkBlue.600": {
      "value": "#1858a8",
      "type": "color"
    },
    "basics.colors.secondary.darkBlue.700": {
      "value": "#064285",
      "type": "color"
    },
    "basics.colors.secondary.darkBlue.800": {
      "value": "#003163",
      "type": "color"
    },
    "basics.colors.secondary.darkBlue.900": {
      "value": "#0c2c54",
      "type": "color"
    },
    "basics.colors.secondary.green.100": {
      "value": "#e7f2d9",
      "type": "color"
    },
    "basics.colors.secondary.green.200": {
      "value": "#cfe4b3",
      "type": "color"
    },
    "basics.colors.secondary.green.300": {
      "value": "#b7d78c",
      "type": "color"
    },
    "basics.colors.secondary.green.400": {
      "value": "#9fc966",
      "type": "color"
    },
    "basics.colors.secondary.green.500": {
      "value": "#87b340",
      "type": "color"
    },
    "basics.colors.secondary.green.600": {
      "value": "#6a9728",
      "type": "color"
    },
    "basics.colors.secondary.green.700": {
      "value": "#507b16",
      "type": "color"
    },
    "basics.colors.secondary.green.800": {
      "value": "#385e08",
      "type": "color"
    },
    "basics.colors.secondary.green.900": {
      "value": "#234200",
      "type": "color"
    },
    "basics.colors.secondary.red.100": {
      "value": "#faeded",
      "type": "color"
    },
    "basics.colors.secondary.red.200": {
      "value": "#f7d6d6",
      "type": "color"
    },
    "basics.colors.secondary.red.300": {
      "value": "#f9b4b4",
      "type": "color"
    },
    "basics.colors.secondary.red.400": {
      "value": "#f48686",
      "type": "color"
    },
    "basics.colors.secondary.red.500": {
      "value": "#eb5555",
      "type": "color"
    },
    "basics.colors.secondary.red.600": {
      "value": "#dd2222",
      "type": "color"
    },
    "basics.colors.secondary.red.700": {
      "value": "#af1b1b",
      "type": "color"
    },
    "basics.colors.secondary.red.800": {
      "value": "#800f0f",
      "type": "color"
    },
    "basics.colors.secondary.red.900": {
      "value": "#520404",
      "type": "color"
    },
    "basics.colors.secondary.turquoise.100": {
      "value": "#d6f2ef",
      "type": "color"
    },
    "basics.colors.secondary.turquoise.200": {
      "value": "#ade4de",
      "type": "color"
    },
    "basics.colors.secondary.turquoise.300": {
      "value": "#84d7ce",
      "type": "color"
    },
    "basics.colors.secondary.turquoise.400": {
      "value": "#5bc9bd",
      "type": "color"
    },
    "basics.colors.secondary.turquoise.500": {
      "value": "#32bcad",
      "type": "color"
    },
    "basics.colors.secondary.turquoise.600": {
      "value": "#23a597",
      "type": "color"
    },
    "basics.colors.secondary.turquoise.700": {
      "value": "#168576",
      "type": "color"
    },
    "basics.colors.secondary.turquoise.800": {
      "value": "#0c665b",
      "type": "color"
    },
    "basics.colors.secondary.turquoise.900": {
      "value": "#04403d",
      "type": "color"
    },
    "basics.colors.secondary.yellowOrange.100": {
      "value": "#feecd1",
      "type": "color"
    },
    "basics.colors.secondary.yellowOrange.200": {
      "value": "#fddaa4",
      "type": "color"
    },
    "basics.colors.secondary.yellowOrange.300": {
      "value": "#fcc776",
      "type": "color"
    },
    "basics.colors.secondary.yellowOrange.400": {
      "value": "#fbb549",
      "type": "color"
    },
    "basics.colors.secondary.yellowOrange.500": {
      "value": "#faa21b",
      "type": "color"
    },
    "basics.colors.secondary.yellowOrange.600": {
      "value": "#ed8d16",
      "type": "color"
    },
    "basics.colors.secondary.yellowOrange.700": {
      "value": "#d9730b",
      "type": "color"
    },
    "basics.colors.secondary.yellowOrange.800": {
      "value": "#bf5808",
      "type": "color"
    },
    "basics.colors.secondary.yellowOrange.900": {
      "value": "#8c3401",
      "type": "color"
    },
    "basics.colors.tertiary.pink.100": {
      "value": "#ffebf5",
      "type": "color"
    },
    "basics.colors.tertiary.pink.200": {
      "value": "#ffd6eb",
      "type": "color"
    },
    "basics.colors.tertiary.pink.300": {
      "value": "#ffb8db",
      "type": "color"
    },
    "basics.colors.tertiary.pink.400": {
      "value": "#ff8cc6",
      "type": "color"
    },
    "basics.colors.tertiary.pink.500": {
      "value": "#fc56a9",
      "type": "color"
    },
    "basics.colors.tertiary.pink.600": {
      "value": "#e84396",
      "type": "color"
    },
    "basics.colors.tertiary.pink.700": {
      "value": "#c72877",
      "type": "color"
    },
    "basics.colors.tertiary.pink.800": {
      "value": "#991f5c",
      "type": "color"
    },
    "basics.colors.tertiary.pink.900": {
      "value": "#781848",
      "type": "color"
    },
    "basics.colors.tertiary.purple.100": {
      "value": "#f4edfd",
      "type": "color"
    },
    "basics.colors.tertiary.purple.200": {
      "value": "#eadcfd",
      "type": "color"
    },
    "basics.colors.tertiary.purple.300": {
      "value": "#d5bcf7",
      "type": "color"
    },
    "basics.colors.tertiary.purple.400": {
      "value": "#c5a1f8",
      "type": "color"
    },
    "basics.colors.tertiary.purple.500": {
      "value": "#b385f2",
      "type": "color"
    },
    "basics.colors.tertiary.purple.600": {
      "value": "#a76ef5",
      "type": "color"
    },
    "basics.colors.tertiary.purple.700": {
      "value": "#8558c5",
      "type": "color"
    },
    "basics.colors.tertiary.purple.800": {
      "value": "#5f3e8e",
      "type": "color"
    },
    "basics.colors.tertiary.purple.900": {
      "value": "#482f6b",
      "type": "color"
    },
    "basics.colors.tertiary.salmon.100": {
      "value": "#ffefec",
      "type": "color"
    },
    "basics.colors.tertiary.salmon.200": {
      "value": "#fcded9",
      "type": "color"
    },
    "basics.colors.tertiary.salmon.300": {
      "value": "#ffbeb3",
      "type": "color"
    },
    "basics.colors.tertiary.salmon.400": {
      "value": "#ff9582",
      "type": "color"
    },
    "basics.colors.tertiary.salmon.500": {
      "value": "#f26a52",
      "type": "color"
    },
    "basics.colors.tertiary.salmon.600": {
      "value": "#db5942",
      "type": "color"
    },
    "basics.colors.tertiary.salmon.700": {
      "value": "#a84a39",
      "type": "color"
    },
    "basics.colors.tertiary.salmon.800": {
      "value": "#853729",
      "type": "color"
    },
    "basics.colors.tertiary.salmon.900": {
      "value": "#66251a",
      "type": "color"
    },
    "basics.colors.tertiary.slate.100": {
      "value": "#e9f0f7",
      "type": "color"
    },
    "basics.colors.tertiary.slate.200": {
      "value": "#dce7f3",
      "type": "color"
    },
    "basics.colors.tertiary.slate.300": {
      "value": "#c1cedc",
      "type": "color"
    },
    "basics.colors.tertiary.slate.400": {
      "value": "#a7bacf",
      "type": "color"
    },
    "basics.colors.tertiary.slate.500": {
      "value": "#7993b0",
      "type": "color"
    },
    "basics.colors.tertiary.slate.600": {
      "value": "#6784a6",
      "type": "color"
    },
    "basics.colors.tertiary.slate.700": {
      "value": "#4b6b8f",
      "type": "color"
    },
    "basics.colors.tertiary.slate.800": {
      "value": "#354d67",
      "type": "color"
    },
    "basics.colors.tertiary.slate.900": {
      "value": "#2c3e53",
      "type": "color"
    },
    "basics.colors.surface.lightGray.100": {
      "value": "#ffffff",
      "type": "color"
    },
    "basics.colors.surface.lightGray.200": {
      "value": "#f5f5f5",
      "type": "color"
    },
    "basics.colors.surface.lightGray.250": {
      "value": "#eeeeee",
      "type": "color"
    },
    "basics.colors.surface.lightGray.300": {
      "value": "#d9d9d9",
      "type": "color"
    },
    "basics.colors.surface.lightGray.350": {
      "value": "#cccccc",
      "type": "color"
    },
    "basics.colors.surface.darkBlue.100": {
      "value": "#454f61",
      "type": "color"
    },
    "basics.colors.surface.darkBlue.200": {
      "value": "#3b4453",
      "type": "color"
    },
    "basics.colors.surface.darkBlue.250": {
      "value": "#2e3440",
      "type": "color"
    },
    "basics.colors.surface.darkBlue.300": {
      "value": "#222933",
      "type": "color"
    },
    "basics.colors.surface.darkBlue.350": {
      "value": "#1a1f25",
      "type": "color"
    },
    "basics.colors.surface.darkGray.100": {
      "value": "#535353",
      "type": "color"
    },
    "basics.colors.surface.darkGray.200": {
      "value": "#474747",
      "type": "color"
    },
    "basics.colors.surface.darkGray.250": {
      "value": "#373737",
      "type": "color"
    },
    "basics.colors.surface.darkGray.300": {
      "value": "#2a2a2a",
      "type": "color"
    },
    "basics.colors.surface.darkGray.350": {
      "value": "#202020",
      "type": "color"
    },
    "basics.colors.shadow.darkBlue": {
      "value": "#1a1f26",
      "type": "color",
      "transform": {
        "alpha": 0.5
      }
    },
    "basics.colors.shadow.darkGray": {
      "value": "#000000",
      "type": "color",
      "transform": {
        "alpha": 0.3
      }
    },
    "basics.colors.shadow.lightGray": {
      "value": "#000000",
      "type": "color",
      "transform": {
        "alpha": 0.2
      }
    },
    "basics.colors.text.againstDark": {
      "value": "#f5f5f5",
      "type": "color"
    },
    "basics.colors.text.againstLight": {
      "value": "#3c3c3c",
      "type": "color"
    },
    "basics.colors.textLink.primary.againstLight": {
      "value": "#006eaf",
      "type": "color"
    },
    "basics.colors.textLink.primary.againstDark": {
      "value": "#6dd2ff",
      "type": "color"
    },
    "basics.colors.textLink.secondary.againstLight": {
      "value": "#3c3c3c",
      "type": "color"
    },
    "basics.colors.textLink.secondary.againstDark": {
      "value": "#f5f5f5",
      "type": "color"
    },
    "basics.colors.icon.lightGray": {
      "value": "#808080",
      "type": "color"
    },
    "basics.colors.icon.darkBlue": {
      "value": "#a2a6b0",
      "type": "color"
    },
    "basics.colors.icon.darkGray": {
      "value": "#999999",
      "type": "color"
    },
    "basics.colors.black": {
      "value": {
        "ref": "basics.colors.primary.black"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.primary.black"
        }
      },
      "type": "color"
    },
    "basics.colors.white": {
      "value": {
        "ref": "basics.colors.primary.white"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.primary.white"
        }
      },
      "type": "color"
    },
    "basics.colors.autodeskBlue100": {
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.100"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.primary.autodeskBlue.100"
        }
      },
      "type": "color"
    },
    "basics.colors.autodeskBlue200": {
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.200"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.primary.autodeskBlue.200"
        }
      },
      "type": "color"
    },
    "basics.colors.autodeskBlue300": {
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.300"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.primary.autodeskBlue.300"
        }
      },
      "type": "color"
    },
    "basics.colors.autodeskBlue400": {
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.400"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.primary.autodeskBlue.400"
        }
      },
      "type": "color"
    },
    "basics.colors.autodeskBlue500": {
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.500"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.primary.autodeskBlue.500"
        }
      },
      "type": "color"
    },
    "basics.colors.autodeskBlue600": {
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.600"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.primary.autodeskBlue.600"
        }
      },
      "type": "color"
    },
    "basics.colors.autodeskBlue700": {
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.700"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.primary.autodeskBlue.700"
        }
      },
      "type": "color"
    },
    "basics.colors.autodeskBlue800": {
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.800"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.primary.autodeskBlue.800"
        }
      },
      "type": "color"
    },
    "basics.colors.autodeskBlue900": {
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.900"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.primary.autodeskBlue.900"
        }
      },
      "type": "color"
    },
    "basics.colors.charcoal100": {
      "value": {
        "ref": "basics.colors.primary.charcoal.100"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.primary.charcoal.100"
        }
      },
      "type": "color"
    },
    "basics.colors.charcoal200": {
      "value": {
        "ref": "basics.colors.primary.charcoal.200"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.primary.charcoal.200"
        }
      },
      "type": "color"
    },
    "basics.colors.charcoal300": {
      "value": {
        "ref": "basics.colors.primary.charcoal.300"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.primary.charcoal.300"
        }
      },
      "type": "color"
    },
    "basics.colors.charcoal400": {
      "value": {
        "ref": "basics.colors.primary.charcoal.400"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.primary.charcoal.400"
        }
      },
      "type": "color"
    },
    "basics.colors.charcoal500": {
      "value": {
        "ref": "basics.colors.primary.charcoal.500"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.primary.charcoal.500"
        }
      },
      "type": "color"
    },
    "basics.colors.charcoal600": {
      "value": {
        "ref": "basics.colors.primary.charcoal.600"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.primary.charcoal.600"
        }
      },
      "type": "color"
    },
    "basics.colors.charcoal700": {
      "value": {
        "ref": "basics.colors.primary.charcoal.700"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.primary.charcoal.700"
        }
      },
      "type": "color"
    },
    "basics.colors.charcoal800": {
      "value": {
        "ref": "basics.colors.primary.charcoal.800"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.primary.charcoal.800"
        }
      },
      "type": "color"
    },
    "basics.colors.charcoal900": {
      "value": {
        "ref": "basics.colors.primary.charcoal.900"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.primary.charcoal.900"
        }
      },
      "type": "color"
    },
    "basics.colors.darkBlue100": {
      "value": {
        "ref": "basics.colors.secondary.darkBlue.100"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.darkBlue.100"
        }
      },
      "type": "color"
    },
    "basics.colors.darkBlue200": {
      "value": {
        "ref": "basics.colors.secondary.darkBlue.200"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.darkBlue.200"
        }
      },
      "type": "color"
    },
    "basics.colors.darkBlue300": {
      "value": {
        "ref": "basics.colors.secondary.darkBlue.300"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.darkBlue.300"
        }
      },
      "type": "color"
    },
    "basics.colors.darkBlue400": {
      "value": {
        "ref": "basics.colors.secondary.darkBlue.400"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.darkBlue.400"
        }
      },
      "type": "color"
    },
    "basics.colors.darkBlue500": {
      "value": {
        "ref": "basics.colors.secondary.darkBlue.500"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.darkBlue.500"
        }
      },
      "type": "color"
    },
    "basics.colors.darkBlue600": {
      "value": {
        "ref": "basics.colors.secondary.darkBlue.600"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.darkBlue.600"
        }
      },
      "type": "color"
    },
    "basics.colors.darkBlue700": {
      "value": {
        "ref": "basics.colors.secondary.darkBlue.700"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.darkBlue.700"
        }
      },
      "type": "color"
    },
    "basics.colors.darkBlue800": {
      "value": {
        "ref": "basics.colors.secondary.darkBlue.800"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.darkBlue.800"
        }
      },
      "type": "color"
    },
    "basics.colors.darkBlue900": {
      "value": {
        "ref": "basics.colors.secondary.darkBlue.900"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.darkBlue.900"
        }
      },
      "type": "color"
    },
    "basics.colors.green100": {
      "value": {
        "ref": "basics.colors.secondary.green.100"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.green.100"
        }
      },
      "type": "color"
    },
    "basics.colors.green200": {
      "value": {
        "ref": "basics.colors.secondary.green.200"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.green.200"
        }
      },
      "type": "color"
    },
    "basics.colors.green300": {
      "value": {
        "ref": "basics.colors.secondary.green.300"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.green.300"
        }
      },
      "type": "color"
    },
    "basics.colors.green400": {
      "value": {
        "ref": "basics.colors.secondary.green.400"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.green.400"
        }
      },
      "type": "color"
    },
    "basics.colors.green500": {
      "value": {
        "ref": "basics.colors.secondary.green.500"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.green.500"
        }
      },
      "type": "color"
    },
    "basics.colors.green600": {
      "value": {
        "ref": "basics.colors.secondary.green.600"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.green.600"
        }
      },
      "type": "color"
    },
    "basics.colors.green700": {
      "value": {
        "ref": "basics.colors.secondary.green.700"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.green.700"
        }
      },
      "type": "color"
    },
    "basics.colors.green800": {
      "value": {
        "ref": "basics.colors.secondary.green.800"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.green.800"
        }
      },
      "type": "color"
    },
    "basics.colors.green900": {
      "value": {
        "ref": "basics.colors.secondary.green.900"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.green.900"
        }
      },
      "type": "color"
    },
    "basics.colors.red100": {
      "value": {
        "ref": "basics.colors.secondary.red.100"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.red.100"
        }
      },
      "type": "color"
    },
    "basics.colors.red200": {
      "value": {
        "ref": "basics.colors.secondary.red.200"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.red.200"
        }
      },
      "type": "color"
    },
    "basics.colors.red300": {
      "value": {
        "ref": "basics.colors.secondary.red.300"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.red.300"
        }
      },
      "type": "color"
    },
    "basics.colors.red400": {
      "value": {
        "ref": "basics.colors.secondary.red.400"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.red.400"
        }
      },
      "type": "color"
    },
    "basics.colors.red500": {
      "value": {
        "ref": "basics.colors.secondary.red.500"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.red.500"
        }
      },
      "type": "color"
    },
    "basics.colors.red600": {
      "value": {
        "ref": "basics.colors.secondary.red.600"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.red.600"
        }
      },
      "type": "color"
    },
    "basics.colors.red700": {
      "value": {
        "ref": "basics.colors.secondary.red.700"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.red.700"
        }
      },
      "type": "color"
    },
    "basics.colors.red800": {
      "value": {
        "ref": "basics.colors.secondary.red.800"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.red.800"
        }
      },
      "type": "color"
    },
    "basics.colors.red900": {
      "value": {
        "ref": "basics.colors.secondary.red.900"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.red.900"
        }
      },
      "type": "color"
    },
    "basics.colors.turquoise100": {
      "value": {
        "ref": "basics.colors.secondary.turquoise.100"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.turquoise.100"
        }
      },
      "type": "color"
    },
    "basics.colors.turquoise200": {
      "value": {
        "ref": "basics.colors.secondary.turquoise.200"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.turquoise.200"
        }
      },
      "type": "color"
    },
    "basics.colors.turquoise300": {
      "value": {
        "ref": "basics.colors.secondary.turquoise.300"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.turquoise.300"
        }
      },
      "type": "color"
    },
    "basics.colors.turquoise400": {
      "value": {
        "ref": "basics.colors.secondary.turquoise.400"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.turquoise.400"
        }
      },
      "type": "color"
    },
    "basics.colors.turquoise500": {
      "value": {
        "ref": "basics.colors.secondary.turquoise.500"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.turquoise.500"
        }
      },
      "type": "color"
    },
    "basics.colors.turquoise600": {
      "value": {
        "ref": "basics.colors.secondary.turquoise.600"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.turquoise.600"
        }
      },
      "type": "color"
    },
    "basics.colors.turquoise700": {
      "value": {
        "ref": "basics.colors.secondary.turquoise.700"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.turquoise.700"
        }
      },
      "type": "color"
    },
    "basics.colors.turquoise800": {
      "value": {
        "ref": "basics.colors.secondary.turquoise.800"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.turquoise.800"
        }
      },
      "type": "color"
    },
    "basics.colors.turquoise900": {
      "value": {
        "ref": "basics.colors.secondary.turquoise.900"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.turquoise.900"
        }
      },
      "type": "color"
    },
    "basics.colors.yellowOrange100": {
      "value": {
        "ref": "basics.colors.secondary.yellowOrange.100"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.yellowOrange.100"
        }
      },
      "type": "color"
    },
    "basics.colors.yellowOrange200": {
      "value": {
        "ref": "basics.colors.secondary.yellowOrange.200"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.yellowOrange.200"
        }
      },
      "type": "color"
    },
    "basics.colors.yellowOrange300": {
      "value": {
        "ref": "basics.colors.secondary.yellowOrange.300"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.yellowOrange.300"
        }
      },
      "type": "color"
    },
    "basics.colors.yellowOrange400": {
      "value": {
        "ref": "basics.colors.secondary.yellowOrange.400"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.yellowOrange.400"
        }
      },
      "type": "color"
    },
    "basics.colors.yellowOrange500": {
      "value": {
        "ref": "basics.colors.secondary.yellowOrange.500"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.yellowOrange.500"
        }
      },
      "type": "color"
    },
    "basics.colors.yellowOrange600": {
      "value": {
        "ref": "basics.colors.secondary.yellowOrange.600"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.yellowOrange.600"
        }
      },
      "type": "color"
    },
    "basics.colors.yellowOrange700": {
      "value": {
        "ref": "basics.colors.secondary.yellowOrange.700"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.yellowOrange.700"
        }
      },
      "type": "color"
    },
    "basics.colors.yellowOrange800": {
      "value": {
        "ref": "basics.colors.secondary.yellowOrange.800"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.yellowOrange.800"
        }
      },
      "type": "color"
    },
    "basics.colors.yellowOrange900": {
      "value": {
        "ref": "basics.colors.secondary.yellowOrange.900"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.yellowOrange.900"
        }
      },
      "type": "color"
    },
    "basics.colors.pink100": {
      "value": {
        "ref": "basics.colors.tertiary.pink.100"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.pink.100"
        }
      },
      "type": "color"
    },
    "basics.colors.pink200": {
      "value": {
        "ref": "basics.colors.tertiary.pink.200"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.pink.200"
        }
      },
      "type": "color"
    },
    "basics.colors.pink300": {
      "value": {
        "ref": "basics.colors.tertiary.pink.300"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.pink.300"
        }
      },
      "type": "color"
    },
    "basics.colors.pink400": {
      "value": {
        "ref": "basics.colors.tertiary.pink.400"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.pink.400"
        }
      },
      "type": "color"
    },
    "basics.colors.pink500": {
      "value": {
        "ref": "basics.colors.tertiary.pink.500"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.pink.500"
        }
      },
      "type": "color"
    },
    "basics.colors.pink600": {
      "value": {
        "ref": "basics.colors.tertiary.pink.600"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.pink.600"
        }
      },
      "type": "color"
    },
    "basics.colors.pink700": {
      "value": {
        "ref": "basics.colors.tertiary.pink.700"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.pink.700"
        }
      },
      "type": "color"
    },
    "basics.colors.pink800": {
      "value": {
        "ref": "basics.colors.tertiary.pink.800"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.pink.800"
        }
      },
      "type": "color"
    },
    "basics.colors.pink900": {
      "value": {
        "ref": "basics.colors.tertiary.pink.900"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.pink.900"
        }
      },
      "type": "color"
    },
    "basics.colors.purple100": {
      "value": {
        "ref": "basics.colors.tertiary.purple.100"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.purple.100"
        }
      },
      "type": "color"
    },
    "basics.colors.purple200": {
      "value": {
        "ref": "basics.colors.tertiary.purple.200"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.purple.200"
        }
      },
      "type": "color"
    },
    "basics.colors.purple300": {
      "value": {
        "ref": "basics.colors.tertiary.purple.300"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.purple.300"
        }
      },
      "type": "color"
    },
    "basics.colors.purple400": {
      "value": {
        "ref": "basics.colors.tertiary.purple.400"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.purple.400"
        }
      },
      "type": "color"
    },
    "basics.colors.purple500": {
      "value": {
        "ref": "basics.colors.tertiary.purple.500"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.purple.500"
        }
      },
      "type": "color"
    },
    "basics.colors.purple600": {
      "value": {
        "ref": "basics.colors.tertiary.purple.600"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.purple.600"
        }
      },
      "type": "color"
    },
    "basics.colors.purple700": {
      "value": {
        "ref": "basics.colors.tertiary.purple.700"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.purple.700"
        }
      },
      "type": "color"
    },
    "basics.colors.purple800": {
      "value": {
        "ref": "basics.colors.tertiary.purple.800"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.purple.800"
        }
      },
      "type": "color"
    },
    "basics.colors.purple900": {
      "value": {
        "ref": "basics.colors.tertiary.purple.900"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.purple.900"
        }
      },
      "type": "color"
    },
    "basics.colors.salmon100": {
      "value": {
        "ref": "basics.colors.tertiary.salmon.100"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.salmon.100"
        }
      },
      "type": "color"
    },
    "basics.colors.salmon200": {
      "value": {
        "ref": "basics.colors.tertiary.salmon.200"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.salmon.200"
        }
      },
      "type": "color"
    },
    "basics.colors.salmon300": {
      "value": {
        "ref": "basics.colors.tertiary.salmon.300"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.salmon.300"
        }
      },
      "type": "color"
    },
    "basics.colors.salmon400": {
      "value": {
        "ref": "basics.colors.tertiary.salmon.400"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.salmon.400"
        }
      },
      "type": "color"
    },
    "basics.colors.salmon500": {
      "value": {
        "ref": "basics.colors.tertiary.salmon.500"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.salmon.500"
        }
      },
      "type": "color"
    },
    "basics.colors.salmon600": {
      "value": {
        "ref": "basics.colors.tertiary.salmon.600"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.salmon.600"
        }
      },
      "type": "color"
    },
    "basics.colors.salmon700": {
      "value": {
        "ref": "basics.colors.tertiary.salmon.700"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.salmon.700"
        }
      },
      "type": "color"
    },
    "basics.colors.salmon800": {
      "value": {
        "ref": "basics.colors.tertiary.salmon.800"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.salmon.800"
        }
      },
      "type": "color"
    },
    "basics.colors.salmon900": {
      "value": {
        "ref": "basics.colors.tertiary.salmon.900"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.salmon.900"
        }
      },
      "type": "color"
    },
    "basics.colors.slate100": {
      "value": {
        "ref": "basics.colors.tertiary.slate.100"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.slate.100"
        }
      },
      "type": "color"
    },
    "basics.colors.slate200": {
      "value": {
        "ref": "basics.colors.tertiary.slate.200"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.slate.200"
        }
      },
      "type": "color"
    },
    "basics.colors.slate300": {
      "value": {
        "ref": "basics.colors.tertiary.slate.300"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.slate.300"
        }
      },
      "type": "color"
    },
    "basics.colors.slate400": {
      "value": {
        "ref": "basics.colors.tertiary.slate.400"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.slate.400"
        }
      },
      "type": "color"
    },
    "basics.colors.slate500": {
      "value": {
        "ref": "basics.colors.tertiary.slate.500"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.slate.500"
        }
      },
      "type": "color"
    },
    "basics.colors.slate600": {
      "value": {
        "ref": "basics.colors.tertiary.slate.600"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.slate.600"
        }
      },
      "type": "color"
    },
    "basics.colors.slate700": {
      "value": {
        "ref": "basics.colors.tertiary.slate.700"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.slate.700"
        }
      },
      "type": "color"
    },
    "basics.colors.slate800": {
      "value": {
        "ref": "basics.colors.tertiary.slate.800"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.slate.800"
        }
      },
      "type": "color"
    },
    "basics.colors.slate900": {
      "value": {
        "ref": "basics.colors.tertiary.slate.900"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.slate.900"
        }
      },
      "type": "color"
    },
    "basics.colors.surfaceLightGrayLevel100": {
      "value": {
        "ref": "basics.colors.surface.lightGray.100"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.surface.lightGray.100"
        }
      },
      "type": "color"
    },
    "basics.colors.surfaceLightGrayLevel200": {
      "value": {
        "ref": "basics.colors.surface.lightGray.200"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.surface.lightGray.200"
        }
      },
      "type": "color"
    },
    "basics.colors.surfaceLightGrayLevel250": {
      "value": {
        "ref": "basics.colors.surface.lightGray.250"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.surface.lightGray.250"
        }
      },
      "type": "color"
    },
    "basics.colors.surfaceLightGrayLevel300": {
      "value": {
        "ref": "basics.colors.surface.lightGray.300"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.surface.lightGray.300"
        }
      },
      "type": "color"
    },
    "basics.colors.surfaceLightGrayLevel350": {
      "value": {
        "ref": "basics.colors.surface.lightGray.350"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.surface.lightGray.350"
        }
      },
      "type": "color"
    },
    "basics.colors.surfaceDarkBlueLevel100": {
      "value": {
        "ref": "basics.colors.surface.darkBlue.100"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.surface.darkBlue.100"
        }
      },
      "type": "color"
    },
    "basics.colors.surfaceDarkBlueLevel200": {
      "value": {
        "ref": "basics.colors.surface.darkBlue.200"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.surface.darkBlue.200"
        }
      },
      "type": "color"
    },
    "basics.colors.surfaceDarkBlueLevel250": {
      "value": {
        "ref": "basics.colors.surface.darkBlue.250"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.surface.darkBlue.250"
        }
      },
      "type": "color"
    },
    "basics.colors.surfaceDarkBlueLevel300": {
      "value": {
        "ref": "basics.colors.surface.darkBlue.300"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.surface.darkBlue.300"
        }
      },
      "type": "color"
    },
    "basics.colors.surfaceDarkBlueLevel350": {
      "value": {
        "ref": "basics.colors.surface.darkBlue.350"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.surface.darkBlue.350"
        }
      },
      "type": "color"
    },
    "basics.colors.surfaceDarkGrayLevel100": {
      "value": {
        "ref": "basics.colors.surface.darkGray.100"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.surface.darkGray.100"
        }
      },
      "type": "color"
    },
    "basics.colors.surfaceDarkGrayLevel200": {
      "value": {
        "ref": "basics.colors.surface.darkGray.200"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.surface.darkGray.200"
        }
      },
      "type": "color"
    },
    "basics.colors.surfaceDarkGrayLevel250": {
      "value": {
        "ref": "basics.colors.surface.darkGray.250"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.surface.darkGray.250"
        }
      },
      "type": "color"
    },
    "basics.colors.surfaceDarkGrayLevel300": {
      "value": {
        "ref": "basics.colors.surface.darkGray.300"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.surface.darkGray.300"
        }
      },
      "type": "color"
    },
    "basics.colors.surfaceDarkGrayLevel350": {
      "value": {
        "ref": "basics.colors.surface.darkGray.350"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.surface.darkGray.350"
        }
      },
      "type": "color"
    },
    "basics.colors.surfaceDarkBlueShadow": {
      "value": {
        "ref": "basics.colors.shadow.darkBlue"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.shadow.darkBlue"
        }
      },
      "type": "color"
    },
    "basics.colors.surfaceDarkGrayShadow": {
      "value": {
        "ref": "basics.colors.shadow.darkGray"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.shadow.darkGray"
        }
      },
      "type": "color"
    },
    "basics.colors.surfaceLightGrayShadow": {
      "value": {
        "ref": "basics.colors.shadow.lightGray"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.shadow.lightGray"
        }
      },
      "type": "color"
    },
    "basics.colors.textAgainstDark": {
      "value": {
        "ref": "basics.colors.text.againstDark"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.text.againstDark"
        }
      },
      "type": "color"
    },
    "basics.colors.textAgainstLight": {
      "value": {
        "ref": "basics.colors.text.againstLight"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.text.againstLight"
        }
      },
      "type": "color"
    },
    "basics.colors.iconLightGrayColor": {
      "value": {
        "ref": "basics.colors.icon.lightGray"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.icon.lightGray"
        }
      },
      "type": "color"
    },
    "basics.colors.iconDarkBlueColor": {
      "value": {
        "ref": "basics.colors.icon.darkBlue"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.icon.darkBlue"
        }
      },
      "type": "color"
    },
    "basics.colors.iconDarkGrayColor": {
      "value": {
        "ref": "basics.colors.icon.darkGray"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.icon.darkGray"
        }
      },
      "type": "color"
    },
    "basics.colors.textLinkAgainstLight": {
      "value": {
        "ref": "basics.colors.textLink.primary.againstLight"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.textLink.primary.againstLight"
        }
      },
      "type": "color"
    },
    "basics.colors.textLinkAgainstDark": {
      "value": {
        "ref": "basics.colors.textLink.primary.againstDark"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.textLink.primary.againstDark"
        }
      },
      "type": "color"
    },
    "basics.colors.error": {
      "value": {
        "ref": "colorScheme.status.error"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "colorScheme.status.error"
        }
      },
      "type": "color"
    },
    "basics.colors.success": {
      "value": {
        "ref": "colorScheme.status.success"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "colorScheme.status.success"
        }
      },
      "type": "color"
    },
    "basics.colors.warning": {
      "value": {
        "ref": "colorScheme.status.warning"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "colorScheme.status.warning"
        }
      },
      "type": "color"
    },
    "basics.fontFamilies.main": {
      "value": "ArtifaktElement, sans-serif",
      "type": "fontFamily"
    },
    "basics.fontFamilies.monospace": {
      "value": "'Source Code Pro', monospace",
      "type": "fontFamily"
    },
    "basics.fontSizes.highSmall": {
      "value": "11px",
      "type": "fontSize"
    },
    "basics.fontSizes.highMedium": {
      "value": "12px",
      "type": "fontSize"
    },
    "basics.fontSizes.highLarge": {
      "value": "16px",
      "type": "fontSize"
    },
    "basics.fontSizes.highExtraLarge": {
      "value": "20px",
      "type": "fontSize"
    },
    "basics.fontSizes.highExtraExtraLarge": {
      "value": "24px",
      "type": "fontSize"
    },
    "basics.fontSizes.mediumSmall": {
      "value": "12px",
      "type": "fontSize"
    },
    "basics.fontSizes.mediumMedium": {
      "value": "14px",
      "type": "fontSize"
    },
    "basics.fontSizes.mediumLarge": {
      "value": "20px",
      "type": "fontSize"
    },
    "basics.fontSizes.mediumExtraLarge": {
      "value": "24px",
      "type": "fontSize"
    },
    "basics.fontSizes.mediumExtraExtraLarge": {
      "value": "28px",
      "type": "fontSize"
    },
    "basics.fontSizes.lowSmall": {
      "value": "14px",
      "type": "fontSize"
    },
    "basics.fontSizes.lowMedium": {
      "value": "16px",
      "type": "fontSize"
    },
    "basics.fontSizes.lowLarge": {
      "value": "22px",
      "type": "fontSize"
    },
    "basics.fontSizes.lowExtraLarge": {
      "value": "26px",
      "type": "fontSize"
    },
    "basics.fontSizes.lowExtraExtraLarge": {
      "value": "30px",
      "type": "fontSize"
    },
    "basics.fontWeights.regular": {
      "value": 400,
      "type": "fontWeight"
    },
    "basics.fontWeights.medium": {
      "value": 600,
      "type": "fontWeight"
    },
    "basics.fontWeights.bold": {
      "value": 700,
      "type": "fontWeight"
    },
    "basics.lineHeights.small": {
      "value": "1.3",
      "type": "lineHeight"
    },
    "basics.lineHeights.medium": {
      "value": "1.4",
      "type": "lineHeight"
    },
    "basics.lineHeights.large": {
      "value": "1.5",
      "type": "lineHeight"
    },
    "basics.lineHeights.highSmall": {
      "value": "1.25",
      "type": "lineHeight"
    },
    "basics.lineHeights.highMedium": {
      "value": "1.272727273",
      "type": "lineHeight"
    },
    "basics.lineHeights.highLarge": {
      "value": "1.3",
      "type": "lineHeight"
    },
    "basics.lineHeights.highExtraLarge": {
      "value": "1.333333333",
      "type": "lineHeight"
    },
    "basics.lineHeights.highExtraExtraLarge": {
      "value": "1.375",
      "type": "lineHeight"
    },
    "basics.lineHeights.mediumSmall": {
      "value": "1.25",
      "type": "lineHeight"
    },
    "basics.lineHeights.mediumMedium": {
      "value": "1.285714286",
      "type": "lineHeight"
    },
    "basics.lineHeights.mediumLarge": {
      "value": "1.3",
      "type": "lineHeight"
    },
    "basics.lineHeights.mediumExtraLarge": {
      "value": "1.428571429",
      "type": "lineHeight"
    },
    "basics.lineHeights.mediumExtraExtraLarge": {
      "value": "1.5",
      "type": "lineHeight"
    },
    "basics.shadows.lowBlur": {
      "value": "4px",
      "type": "shadow"
    },
    "basics.shadows.highBlur": {
      "value": "16px",
      "type": "shadow"
    },
    "basics.spacings.none": {
      "value": "0",
      "type": "spacing"
    },
    "basics.spacings.highExtraExtraSmall": {
      "value": "2px",
      "type": "spacing"
    },
    "basics.spacings.highExtraSmall": {
      "value": "4px",
      "type": "spacing"
    },
    "basics.spacings.highSmall": {
      "value": "8px",
      "type": "spacing"
    },
    "basics.spacings.highMedium": {
      "value": "12px",
      "type": "spacing"
    },
    "basics.spacings.highLarge": {
      "value": "16px",
      "type": "spacing"
    },
    "basics.spacings.highExtraLarge": {
      "value": "24px",
      "type": "spacing"
    },
    "basics.spacings.highExtraExtraLarge": {
      "value": "32px",
      "type": "spacing"
    },
    "basics.spacings.mediumExtraExtraSmall": {
      "value": "4px",
      "type": "spacing"
    },
    "basics.spacings.mediumExtraSmall": {
      "value": "8px",
      "type": "spacing"
    },
    "basics.spacings.mediumSmall": {
      "value": "12px",
      "type": "spacing"
    },
    "basics.spacings.mediumMedium": {
      "value": "16px",
      "type": "spacing"
    },
    "basics.spacings.mediumLarge": {
      "value": "24px",
      "type": "spacing"
    },
    "basics.spacings.mediumExtraLarge": {
      "value": "32px",
      "type": "spacing"
    },
    "basics.spacings.mediumExtraExtraLarge": {
      "value": "48px",
      "type": "spacing"
    },
    "basics.spacings.lowExtraExtraSmall": {
      "value": "8px",
      "type": "spacing"
    },
    "basics.spacings.lowExtraSmall": {
      "value": "12px",
      "type": "spacing"
    },
    "basics.spacings.lowSmall": {
      "value": "16px",
      "type": "spacing"
    },
    "basics.spacings.lowMedium": {
      "value": "24px",
      "type": "spacing"
    },
    "basics.spacings.lowLarge": {
      "value": "32px",
      "type": "spacing"
    },
    "basics.spacings.lowExtraLarge": {
      "value": "48px",
      "type": "spacing"
    },
    "basics.spacings.lowExtraExtraLarge": {
      "value": "64px",
      "type": "spacing"
    },
    "colorScheme.reference.accent": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.500"
      }
    },
    "colorScheme.reference.base": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.600"
      }
    },
    "colorScheme.surface.level100": {
      "type": "color",
      "value": {
        "ref": "basics.colors.surface.lightGray.100"
      }
    },
    "colorScheme.surface.level200": {
      "type": "color",
      "value": {
        "ref": "basics.colors.surface.lightGray.200"
      }
    },
    "colorScheme.surface.level250": {
      "type": "color",
      "value": {
        "ref": "basics.colors.surface.lightGray.250"
      }
    },
    "colorScheme.surface.level300": {
      "type": "color",
      "value": {
        "ref": "basics.colors.surface.lightGray.300"
      }
    },
    "colorScheme.surface.level350": {
      "type": "color",
      "value": {
        "ref": "basics.colors.surface.lightGray.350"
      }
    },
    "colorScheme.background.selected": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.accent"
      },
      "transform": {
        "alpha": 0.15
      }
    },
    "colorScheme.background.on.default": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.100"
      },
      "transform": {
        "alpha": 0.6
      }
    },
    "colorScheme.background.on.hover": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.200"
      },
      "transform": {
        "alpha": 0.7
      }
    },
    "colorScheme.background.on.focus": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.100"
      },
      "transform": {
        "alpha": 0.6
      }
    },
    "colorScheme.background.on.pressed": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.300"
      },
      "transform": {
        "alpha": 0.7
      }
    },
    "colorScheme.background.empty.level100To250.hover": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.600"
      },
      "transform": {
        "alpha": 0.1
      }
    },
    "colorScheme.background.empty.level100To250.pressed": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.600"
      },
      "transform": {
        "alpha": 0.2
      }
    },
    "colorScheme.background.empty.level300To350.hover": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      },
      "transform": {
        "alpha": 0.25
      }
    },
    "colorScheme.background.empty.level300To350.pressed": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      },
      "transform": {
        "alpha": 0.35
      }
    },
    "colorScheme.background.filled.level100To250.default": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.600"
      },
      "transform": {
        "alpha": 0.15
      }
    },
    "colorScheme.background.filled.level100To250.hover": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.600"
      },
      "transform": {
        "alpha": 0.25
      }
    },
    "colorScheme.background.filled.level100To250.focus": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.600"
      },
      "transform": {
        "alpha": 0.15
      }
    },
    "colorScheme.background.filled.level100To250.pressed": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.600"
      },
      "transform": {
        "alpha": 0.35
      }
    },
    "colorScheme.background.filled.level300To350.default": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      },
      "transform": {
        "alpha": 0.5
      }
    },
    "colorScheme.background.filled.level300To350.hover": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      },
      "transform": {
        "alpha": 0.7
      }
    },
    "colorScheme.background.filled.level300To350.focus": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      },
      "transform": {
        "alpha": 0.5
      }
    },
    "colorScheme.background.filled.level300To350.pressed": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      },
      "transfrom": {
        "alpha": 0.9
      }
    },
    "colorScheme.background.transparent": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0
      }
    },
    "colorScheme.border.base": {
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.5
      },
      "type": "color"
    },
    "colorScheme.border.accent": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.accent"
      }
    },
    "colorScheme.border.on": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.accent"
      },
      "transform": {
        "alpha": 0.5
      }
    },
    "colorScheme.border.transparent": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0
      }
    },
    "colorScheme.halo.hover": {
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.15
      },
      "type": "color"
    },
    "colorScheme.halo.focus": {
      "value": {
        "ref": "colorScheme.reference.accent"
      },
      "transform": {
        "alpha": 0.35
      },
      "type": "color"
    },
    "colorScheme.halo.pressed": {
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.25
      },
      "type": "color"
    },
    "colorScheme.shadow.high": {
      "type": "color",
      "value": {
        "ref": "basics.colors.shadow.lightGray"
      }
    },
    "colorScheme.shadow.low": {
      "type": "color",
      "value": {
        "ref": "basics.colors.shadow.lightGray"
      }
    },
    "colorScheme.text.default": {
      "type": "color",
      "value": {
        "ref": "basics.colors.text.againstLight"
      }
    },
    "colorScheme.text.dim": {
      "type": "color",
      "value": {
        "ref": "basics.colors.text.againstLight"
      },
      "transform": {
        "alpha": 0.7
      }
    },
    "colorScheme.text.placeholder": {
      "type": "color",
      "value": {
        "ref": "basics.colors.text.againstLight"
      },
      "transform": {
        "alpha": 0.4
      }
    },
    "colorScheme.text.active": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.accent"
      }
    },
    "colorScheme.icon.default": {
      "type": "color",
      "value": {
        "ref": "basics.colors.icon.lightGray"
      }
    },
    "colorScheme.icon.hover": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.900"
      }
    },
    "colorScheme.icon.focus": {
      "type": "color",
      "value": {
        "ref": "basics.colors.icon.lightGray"
      }
    },
    "colorScheme.icon.pressed": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.900"
      }
    },
    "colorScheme.icon.on.default": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.500"
      }
    },
    "colorScheme.icon.on.hover": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.700"
      }
    },
    "colorScheme.icon.on.focus": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.500"
      }
    },
    "colorScheme.icon.on.pressed": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.700"
      }
    },
    "colorScheme.indicator.default": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.700"
      },
      "transform": {
        "alpha": 0.7
      }
    },
    "colorScheme.indicator.hover": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.700"
      }
    },
    "colorScheme.indicator.focus": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.700"
      },
      "transform": {
        "alpha": 0.7
      }
    },
    "colorScheme.indicator.pressed": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.900"
      }
    },
    "colorScheme.indicator.on": {
      "value": {
        "ref": "colorScheme.reference.accent"
      },
      "type": "color"
    },
    "colorScheme.status.error": {
      "value": {
        "ref": "basics.colors.secondary.red.600"
      },
      "type": "color"
    },
    "colorScheme.status.success": {
      "value": {
        "ref": "basics.colors.secondary.green.600"
      },
      "type": "color"
    },
    "colorScheme.status.warning": {
      "value": {
        "ref": "basics.colors.secondary.yellowOrange.500"
      },
      "type": "color"
    },
    "colorScheme.status.info": {
      "value": {
        "ref": "colorScheme.reference.accent"
      },
      "type": "color"
    },
    "colorScheme.status.read": {
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.4
      },
      "type": "color"
    },
    "colorScheme.divider.lightweight": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.900"
      },
      "transform": {
        "alpha": 0.1
      }
    },
    "colorScheme.divider.heavyweight": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.900"
      },
      "transform": {
        "alpha": 0.25
      }
    },
    "colorScheme.opacity.mask": {
      "type": "color",
      "value": {
        "ref": "basics.colors.tertiary.pink.600"
      }
    },
    "colorScheme.opacity.disabled": {
      "value": 0.4,
      "type": "opacity"
    },
    "colorScheme.accentColor": {
      "type": "color",
      "metadata": {
        "deprecated": {
          "equivalent": "colorScheme.reference.accent"
        }
      },
      "value": {
        "ref": "colorScheme.reference.accent"
      }
    },
    "colorScheme.baseColor": {
      "type": "color",
      "metadata": {
        "deprecated": {
          "equivalent": "colorScheme.reference.base"
        }
      },
      "value": {
        "ref": "colorScheme.reference.base"
      }
    },
    "colorScheme.surfaceLevel100Color": {
      "type": "color",
      "metadata": {
        "deprecated": {
          "equivalent": "colorScheme.surface.level100"
        }
      },
      "value": {
        "ref": "colorScheme.surface.level100"
      }
    },
    "colorScheme.surfaceLevel200Color": {
      "type": "color",
      "metadata": {
        "deprecated": {
          "equivalent": "colorScheme.surface.level200"
        }
      },
      "value": {
        "ref": "colorScheme.surface.level200"
      }
    },
    "colorScheme.surfaceLevel250Color": {
      "type": "color",
      "metadata": {
        "deprecated": {
          "equivalent": "colorScheme.surface.level250"
        }
      },
      "value": {
        "ref": "colorScheme.surface.level250"
      }
    },
    "colorScheme.surfaceLevel300Color": {
      "type": "color",
      "metadata": {
        "deprecated": {
          "equivalent": "colorScheme.surface.level300"
        }
      },
      "value": {
        "ref": "colorScheme.surface.level300"
      }
    },
    "colorScheme.surfaceLevel350Color": {
      "type": "color",
      "metadata": {
        "deprecated": {
          "equivalent": "colorScheme.surface.level350"
        }
      },
      "value": {
        "ref": "colorScheme.surface.level350"
      }
    },
    "colorScheme.highShadowColor": {
      "type": "color",
      "metadata": {
        "deprecated": {
          "equivalent": "colorScheme.shadow.high"
        }
      },
      "value": {
        "ref": "colorScheme.shadow.high"
      }
    },
    "colorScheme.lowShadowColor": {
      "type": "color",
      "metadata": {
        "deprecated": {
          "equivalent": "colorScheme.shadow.low"
        }
      },
      "value": {
        "ref": "colorScheme.shadow.low"
      }
    },
    "colorScheme.textColor": {
      "type": "color",
      "metadata": {
        "deprecated": {
          "equivalent": "colorScheme.text.default"
        }
      },
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "colorScheme.textColorDim": {
      "type": "color",
      "metadata": {
        "deprecated": {
          "equivalent": "colorScheme.text.dim"
        }
      },
      "value": {
        "ref": "colorScheme.text.dim"
      }
    },
    "colorScheme.iconColor": {
      "type": "color",
      "metadata": {
        "deprecated": {
          "equivalent": "colorScheme.icon.default"
        }
      },
      "value": {
        "ref": "colorScheme.icon.default"
      }
    },
    "colorScheme.errorColor": {
      "value": {
        "ref": "colorScheme.status.error"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "colorScheme.status.error"
        }
      },
      "type": "color"
    },
    "colorScheme.successColor": {
      "value": {
        "ref": "colorScheme.status.success"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "colorScheme.status.success"
        }
      },
      "type": "color"
    },
    "colorScheme.warningColor": {
      "value": {
        "ref": "colorScheme.status.warning"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "colorScheme.status.warning"
        }
      },
      "type": "color"
    },
    "colorScheme.infoColor": {
      "value": {
        "ref": "colorScheme.status.info"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "colorScheme.status.info"
        }
      },
      "type": "color"
    },
    "colorScheme.component.backgroundColor": {
      "type": "color",
      "metadata": {
        "deprecated": {
          "equivalent": "colorScheme.surface.level"
        }
      },
      "value": {
        "ref": "basics.colors.primary.white"
      }
    },
    "density.spacings.extraExtraSmall": {
      "type": "spacing",
      "value": {
        "ref": "basics.spacings.mediumExtraExtraSmall"
      }
    },
    "density.spacings.extraSmall": {
      "type": "spacing",
      "value": {
        "ref": "basics.spacings.mediumExtraSmall"
      }
    },
    "density.spacings.small": {
      "type": "spacing",
      "value": {
        "ref": "basics.spacings.mediumSmall"
      }
    },
    "density.spacings.medium": {
      "type": "spacing",
      "value": {
        "ref": "basics.spacings.mediumMedium"
      }
    },
    "density.spacings.large": {
      "type": "spacing",
      "value": {
        "ref": "basics.spacings.mediumLarge"
      }
    },
    "density.spacings.extraLarge": {
      "type": "spacing",
      "value": {
        "ref": "basics.spacings.mediumExtraLarge"
      }
    },
    "density.spacings.extraExtraLarge": {
      "type": "spacing",
      "value": {
        "ref": "basics.spacings.mediumExtraExtraLarge"
      }
    },
    "density.fontSizes.small": {
      "type": "fontSize",
      "value": {
        "ref": "basics.fontSizes.mediumSmall"
      }
    },
    "density.fontSizes.medium": {
      "type": "fontSize",
      "value": {
        "ref": "basics.fontSizes.mediumMedium"
      }
    },
    "density.fontSizes.large": {
      "type": "fontSize",
      "value": {
        "ref": "basics.fontSizes.mediumLarge"
      }
    },
    "density.fontSizes.extraLarge": {
      "type": "fontSize",
      "value": {
        "ref": "basics.fontSizes.mediumExtraLarge"
      }
    },
    "density.fontSizes.extraExtraLarge": {
      "type": "fontSize",
      "value": {
        "ref": "basics.fontSizes.mediumExtraExtraLarge"
      }
    },
    "accordion.header.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "accordion.header.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "accordion.header.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "accordion.header.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.bold"
      }
    },
    "accordion.header.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "basics.lineHeights.mediumExtraLarge"
      }
    },
    "accordion.header.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.600"
      },
      "transform": {
        "alpha": 0.1
      }
    },
    "accordion.header.paddingHorizontal": {
      "type": "length",
      "value": {
        "ref": "density.spacings.extraSmall"
      }
    },
    "accordion.header.paddingVertical": {
      "type": "length",
      "value": {
        "ref": "density.spacings.extraSmall"
      }
    },
    "accordion.header.indicatorGutter": {
      "type": "length",
      "value": {
        "ref": "density.spacings.extraSmall"
      }
    },
    "accordion.header.indicatorSize": {
      "type": "length",
      "value": {
        "ref": "density.spacings.medium"
      }
    },
    "accordion.header.default.indicatorColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.indicator.default"
      }
    },
    "accordion.header.hover.indicatorColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.indicator.hover"
      }
    },
    "accordion.header.indicatorRight.paddingLeft": {
      "type": "length",
      "value": {
        "ref": "density.spacings.small"
      }
    },
    "accordion.header.indicatorRight.paddingRight": {
      "type": "length",
      "value": {
        "ref": "density.spacings.medium"
      }
    },
    "accordion.header.indicatorColor": {
      "type": "color",
      "value": {
        "ref": "accordion.header.default.indicatorColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "accordion.header.default.indicatorColor"
        }
      }
    },
    "avatar.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.regular"
      }
    },
    "avatar.fontColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      }
    },
    "avatar.extraSmall.fontSize": {
      "type": "fontSize",
      "value": "11px"
    },
    "avatar.extraSmall.diameter": {
      "type": "length",
      "value": "16px"
    },
    "avatar.small.fontSize": {
      "type": "fontSize",
      "value": "12px"
    },
    "avatar.small.diameter": {
      "type": "length",
      "value": "24px"
    },
    "avatar.medium.fontSize": {
      "type": "fontSize",
      "value": "14px"
    },
    "avatar.medium.diameter": {
      "type": "length",
      "value": "32px"
    },
    "avatar.large.fontSize": {
      "type": "fontSize",
      "value": "24px"
    },
    "avatar.large.diameter": {
      "type": "length",
      "value": "48px"
    },
    "avatar.extraLarge.fontSize": {
      "type": "fontSize",
      "value": "30px"
    },
    "avatar.extraLarge.diameter": {
      "type": "length",
      "value": "64px"
    },
    "avatar.backgroundColor1": {
      "type": "color",
      "value": {
        "ref": "dataVis.colors.red.b.80"
      }
    },
    "avatar.backgroundColor2": {
      "type": "color",
      "value": {
        "ref": "dataVis.colors.red.b.100"
      }
    },
    "avatar.backgroundColor3": {
      "type": "color",
      "value": {
        "ref": "dataVis.colors.orange.a.70"
      }
    },
    "avatar.backgroundColor4": {
      "type": "color",
      "value": {
        "ref": "dataVis.colors.yellowGreen.c.90"
      }
    },
    "avatar.backgroundColor5": {
      "type": "color",
      "value": {
        "ref": "dataVis.colors.blueGreen.a.100"
      }
    },
    "avatar.backgroundColor6": {
      "type": "color",
      "value": {
        "ref": "dataVis.colors.cyan.c.80"
      }
    },
    "avatar.backgroundColor7": {
      "type": "color",
      "value": {
        "ref": "dataVis.colors.blueCyan.b.90"
      }
    },
    "avatar.backgroundColor8": {
      "type": "color",
      "value": {
        "ref": "dataVis.colors.blue.a.70"
      }
    },
    "avatar.backgroundColor9": {
      "type": "color",
      "value": {
        "ref": "dataVis.colors.blue.a.100"
      }
    },
    "avatar.backgroundColor10": {
      "type": "color",
      "value": {
        "ref": "dataVis.colors.blue.c.70"
      }
    },
    "avatar.backgroundColor11": {
      "type": "color",
      "value": {
        "ref": "dataVis.colors.purple.c.100"
      }
    },
    "avatar.backgroundColor12": {
      "type": "color",
      "value": {
        "ref": "dataVis.colors.magenta.b.100"
      }
    },
    "avatar.backgroundColor13": {
      "type": "color",
      "value": {
        "ref": "dataVis.colors.magenta.c.80"
      }
    },
    "avatar.backgroundColor14": {
      "type": "color",
      "value": {
        "ref": "dataVis.colors.rose.b.100"
      }
    },
    "avatar.backgroundColor15": {
      "type": "color",
      "value": {
        "ref": "dataVis.colors.rose.d.70"
      }
    },
    "avatar.darkBackground.fontColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.primary.white"
        }
      }
    },
    "avatar.lightBackground.fontColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.text.againstLight"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.text.againstLight"
        }
      }
    },
    "avatar.color1.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.300"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.primary.autodeskBlue.300"
        }
      }
    },
    "avatar.color2.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.secondary.darkBlue.600"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.darkBlue.600"
        }
      }
    },
    "avatar.color3.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.secondary.green.700"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.green.700"
        }
      }
    },
    "avatar.color4.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.tertiary.salmon.400"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.salmon.400"
        }
      }
    },
    "avatar.color5.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.tertiary.slate.700"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.tertiary.slate.700"
        }
      }
    },
    "avatar.color6.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.secondary.turquoise.400"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.turquoise.400"
        }
      }
    },
    "avatar.color7.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.secondary.yellowOrange.500"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.secondary.yellowOrange.500"
        }
      }
    },
    "avatar.color1.fontColor": {
      "type": "color",
      "value": {
        "ref": "avatar.lightBackground.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.text.againstLight"
        }
      }
    },
    "avatar.color2.fontColor": {
      "type": "color",
      "value": {
        "ref": "avatar.darkBackground.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "avatar.fontColor"
        }
      }
    },
    "avatar.color3.fontColor": {
      "type": "color",
      "value": {
        "ref": "avatar.darkBackground.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "avatar.fontColor"
        }
      }
    },
    "avatar.color4.fontColor": {
      "type": "color",
      "value": {
        "ref": "avatar.lightBackground.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.text.againstLight"
        }
      }
    },
    "avatar.color5.fontColor": {
      "type": "color",
      "value": {
        "ref": "avatar.darkBackground.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "avatar.fontColor"
        }
      }
    },
    "avatar.color6.fontColor": {
      "type": "color",
      "value": {
        "ref": "avatar.lightBackground.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.text.againstLight"
        }
      }
    },
    "avatar.color7.fontColor": {
      "type": "color",
      "value": {
        "ref": "avatar.lightBackground.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.text.againstLight"
        }
      }
    },
    "avatar.fontColorOnDark": {
      "type": "color",
      "value": {
        "ref": "avatar.darkBackground.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "avatar.fontColor"
        }
      }
    },
    "avatar.fontColorOnLight": {
      "type": "color",
      "value": {
        "ref": "avatar.lightBackground.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.colors.text.againstLight"
        }
      }
    },
    "avatarBundle.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "avatarBundle.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.100"
      }
    },
    "avatarBundle.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.100"
      }
    },
    "avatarBundle.pressed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.100"
      }
    },
    "avatarBundle.hover.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.halo.hover"
      }
    },
    "avatarBundle.pressed.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.halo.pressed"
      }
    },
    "avatarBundle.hover.haloWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.medium"
      }
    },
    "avatarBundle.pressed.haloWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.large"
      }
    },
    "avatarBundle.extraSmall.default.spacing.secondItem": {
      "type": "spacing",
      "value": "16px"
    },
    "avatarBundle.extraSmall.default.spacing.thirdItem": {
      "type": "spacing",
      "value": "32px"
    },
    "avatarBundle.small.default.spacing.secondItem": {
      "type": "spacing",
      "value": "20px"
    },
    "avatarBundle.small.default.spacing.thirdItem": {
      "type": "spacing",
      "value": "40px"
    },
    "avatarBundle.medium.default.spacing.secondItem": {
      "type": "spacing",
      "value": "28px"
    },
    "avatarBundle.medium.default.spacing.thirdItem": {
      "type": "spacing",
      "value": "56px"
    },
    "avatarBundle.large.default.spacing.secondItem": {
      "type": "spacing",
      "value": "44px"
    },
    "avatarBundle.large.default.spacing.thirdItem": {
      "type": "spacing",
      "value": "88px"
    },
    "avatarBundle.extraLarge.default.spacing.secondItem": {
      "type": "spacing",
      "value": "60px"
    },
    "avatarBundle.extraLarge.default.spacing.thirdItem": {
      "type": "spacing",
      "value": "120px"
    },
    "avatarBundle.extraSmall.condensed.spacing.secondItem": {
      "type": "spacing",
      "value": "12px"
    },
    "avatarBundle.extraSmall.condensed.spacing.thirdItem": {
      "type": "spacing",
      "value": "24px"
    },
    "avatarBundle.small.condensed.spacing.secondItem": {
      "type": "spacing",
      "value": "16px"
    },
    "avatarBundle.small.condensed.spacing.thirdItem": {
      "type": "spacing",
      "value": "32px"
    },
    "avatarBundle.medium.condensed.spacing.secondItem": {
      "type": "spacing",
      "value": "20px"
    },
    "avatarBundle.medium.condensed.spacing.thirdItem": {
      "type": "spacing",
      "value": "40px"
    },
    "avatarBundle.large.condensed.spacing.secondItem": {
      "type": "spacing",
      "value": "28px"
    },
    "avatarBundle.large.condensed.spacing.thirdItem": {
      "type": "spacing",
      "value": "56px"
    },
    "avatarBundle.extraLarge.condensed.spacing.secondItem": {
      "type": "spacing",
      "value": "40px"
    },
    "avatarBundle.extraLarge.condensed.spacing.thirdItem": {
      "type": "spacing",
      "value": "80px"
    },
    "avatarBundle.extraSmall.superCondensed.spacing.secondItem": {
      "type": "spacing",
      "value": "4px"
    },
    "avatarBundle.extraSmall.superCondensed.spacing.thirdItem": {
      "type": "spacing",
      "value": "8px"
    },
    "avatarBundle.small.superCondensed.spacing.secondItem": {
      "type": "spacing",
      "value": "8px"
    },
    "avatarBundle.small.superCondensed.spacing.thirdItem": {
      "type": "spacing",
      "value": "16px"
    },
    "avatarBundle.medium.superCondensed.spacing.secondItem": {
      "type": "spacing",
      "value": "12px"
    },
    "avatarBundle.medium.superCondensed.spacing.thirdItem": {
      "type": "spacing",
      "value": "24px"
    },
    "avatarBundle.large.superCondensed.spacing.secondItem": {
      "type": "spacing",
      "value": "16px"
    },
    "avatarBundle.large.superCondensed.spacing.thirdItem": {
      "type": "spacing",
      "value": "32px"
    },
    "avatarBundle.extraLarge.superCondensed.spacing.secondItem": {
      "type": "spacing",
      "value": "24px"
    },
    "avatarBundle.extraLarge.superCondensed.spacing.thirdItem": {
      "type": "spacing",
      "value": "48px"
    },
    "avatarBundle.extraSmall.border": {
      "type": "length",
      "value": "1px"
    },
    "avatarBundle.small.border": {
      "type": "length",
      "value": "1px"
    },
    "avatarBundle.medium.border": {
      "type": "length",
      "value": "2px"
    },
    "avatarBundle.large.border": {
      "type": "length",
      "value": "2px"
    },
    "avatarBundle.extraLarge.border": {
      "type": "length",
      "value": "4px"
    },
    "badge.text.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "badge.text.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "basics.fontSizes.highSmall"
      }
    },
    "badge.text.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.bold"
      }
    },
    "badge.text.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "basics.lineHeights.highSmall"
      }
    },
    "badge.text.padding.horizontal": {
      "type": "spacing",
      "value": {
        "ref": "basics.spacings.highSmall"
      }
    },
    "badge.text.cornerRadius": {
      "type": "borderRadius",
      "value": {
        "ref": "basics.borderRadii.pill"
      }
    },
    "badge.text.minHeight": {
      "type": "length",
      "value": "20px"
    },
    "badge.icon.cornerRadius": {
      "type": "borderRadius",
      "value": {
        "ref": "basics.borderRadii.ellipse"
      }
    },
    "badge.icon.large.minHeight": {
      "type": "length",
      "value": "28px"
    },
    "badge.icon.small.minHeight": {
      "type": "length",
      "value": "20px"
    },
    "badge.dot.cornerRadius": {
      "type": "borderRadius",
      "value": {
        "ref": "basics.borderRadii.ellipse"
      }
    },
    "badge.dot.large.minHeight": {
      "type": "length",
      "value": "12px"
    },
    "badge.dot.small.minHeight": {
      "type": "length",
      "value": "8px"
    },
    "badge.outline.borderWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.medium"
      }
    },
    "badge.green.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.status.success"
      }
    },
    "badge.green.fontColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      }
    },
    "badge.green.iconColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      }
    },
    "badge.orange.backgroundColor": {
      "type": "color",
      "value": "#fe8d55"
    },
    "badge.orange.fontColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.black"
      }
    },
    "badge.red.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.status.error"
      }
    },
    "badge.red.fontColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      }
    },
    "badge.red.iconColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      }
    },
    "badge.yellow.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.status.warning"
      }
    },
    "badge.yellow.fontColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.black"
      }
    },
    "badge.yellow.iconColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      }
    },
    "banner.error.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.tertiary.salmon.100"
      }
    },
    "banner.error.borderColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.secondary.red.300"
      }
    },
    "banner.error.iconField.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.status.error"
      }
    },
    "banner.info.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.100"
      }
    },
    "banner.info.borderColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.200"
      }
    },
    "banner.info.iconField.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.status.info"
      }
    },
    "banner.success.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.secondary.green.100"
      }
    },
    "banner.success.borderColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.secondary.green.300"
      }
    },
    "banner.success.iconField.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.status.success"
      }
    },
    "banner.warning.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.secondary.yellowOrange.100"
      }
    },
    "banner.warning.borderColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.secondary.yellowOrange.300"
      }
    },
    "banner.warning.iconField.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.status.warning"
      }
    },
    "banner.info.iconBackground": {
      "type": "color",
      "value": {
        "ref": "banner.info.iconField.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "banner.info.iconField.backgroundColor"
        }
      }
    },
    "banner.success.iconBackground": {
      "type": "color",
      "value": {
        "ref": "banner.success.iconField.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "banner.success.iconField.backgroundColor"
        }
      }
    },
    "banner.warning.iconBackground": {
      "type": "color",
      "value": {
        "ref": "banner.warning.iconField.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "banner.warning.iconField.backgroundColor"
        }
      }
    },
    "banner.error.iconBackground": {
      "type": "color",
      "value": {
        "ref": "banner.error.iconField.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "banner.error.iconField.backgroundColor"
        }
      }
    },
    "breadcrumb.label.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "breadcrumb.label.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "breadcrumb.label.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "breadcrumb.label.default.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.regular"
      }
    },
    "breadcrumb.label.selected.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.medium"
      }
    },
    "breadcrumb.default.indicatorColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.indicator.default"
      }
    },
    "breadcrumb.selected.indicatorColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.indicator.pressed"
      }
    },
    "breadcrumb.divider.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      },
      "transform": {
        "alpha": 0.4
      }
    },
    "breadcrumb.divider.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.medium"
      }
    },
    "button.borderRadius": {
      "type": "borderRadius",
      "value": {
        "ref": "basics.borderRadii.medium"
      }
    },
    "button.borderWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.small"
      }
    },
    "button.minWidth": {
      "type": "length",
      "value": "10px"
    },
    "button.paddingHorizontal": {
      "type": "length",
      "value": {
        "ref": "density.spacings.medium"
      }
    },
    "button.paddingVertical": {
      "type": "length",
      "value": {
        "ref": "density.spacings.extraSmall"
      }
    },
    "button.gutterWidth": {
      "type": "length",
      "value": "4px",
      "comment": "\n      The space between elements with the component.\n      E.g. The space between an icon and label within a button."
    },
    "button.label.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "button.label.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "button.label.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.medium"
      }
    },
    "button.label.lineHeight": {
      "type": "lineHeight",
      "value": "18px"
    },
    "button.haloWidth": {
      "type": "length",
      "value": "2px"
    },
    "button.hover.haloWidth": {
      "type": "length",
      "value": "2px"
    },
    "button.pressed.haloWidth": {
      "type": "length",
      "value": "4px"
    },
    "button.hover.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.15
      }
    },
    "button.focus.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.accent"
      },
      "transform": {
        "alpha": 0.35
      }
    },
    "button.pressed.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.25
      }
    },
    "button.solid.label.fontColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      }
    },
    "button.solid.iconColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      }
    },
    "button.solid.indicatorColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      }
    },
    "button.solid.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.accent"
      }
    },
    "button.solid.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.accent"
      }
    },
    "button.solid.focus.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.accent"
      }
    },
    "button.solid.pressed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "button.solid.default.backgroundColor"
      }
    },
    "button.solid.default.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.accent"
      }
    },
    "button.solid.hover.borderColor": {
      "type": "color",
      "value": {
        "ref": "button.solid.borderColor"
      }
    },
    "button.solid.focus.borderColor": {
      "type": "color",
      "value": {
        "ref": "button.solid.default.borderColor"
      }
    },
    "button.solid.pressed.borderColor": {
      "type": "color",
      "value": {
        "ref": "button.solid.default.borderColor"
      }
    },
    "button.outline.label.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "button.outline.indicatorColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.indicator.default"
      }
    },
    "button.outline.iconColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.icon.default"
      }
    },
    "button.outline.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "button.outline.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "button.outline.backgroundColor"
      }
    },
    "button.outline.focus.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "button.outline.backgroundColor"
      }
    },
    "button.outline.pressed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "button.outline.backgroundColor"
      }
    },
    "button.outline.default.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.5
      }
    },
    "button.outline.hover.borderColor": {
      "type": "color",
      "value": {
        "ref": "button.outline.borderColor"
      }
    },
    "button.outline.focus.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.accent"
      }
    },
    "button.outline.pressed.borderColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.600"
      },
      "transform": {
        "alpha": 0.85
      }
    },
    "button.flat.label.fontColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.700"
      }
    },
    "button.flat.iconColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.700"
      }
    },
    "button.flat.indicatorColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.700"
      }
    },
    "button.flat.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "button.flat.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "button.flat.default.backgroundColor"
      }
    },
    "button.flat.focus.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "button.flat.default.backgroundColor"
      }
    },
    "button.flat.pressed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "button.flat.default.backgroundColor"
      }
    },
    "button.flat.default.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "button.flat.hover.borderColor": {
      "type": "color",
      "value": {
        "ref": "button.flat.default.borderColor"
      }
    },
    "button.flat.focus.borderColor": {
      "type": "color",
      "value": {
        "ref": "button.flat.default.borderColor"
      }
    },
    "button.flat.pressed.borderColor": {
      "type": "color",
      "value": {
        "ref": "button.flat.default.borderColor"
      }
    },
    "button.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "button.label.fontWeight"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.label.fontWeight"
        }
      }
    },
    "button.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "button.label.lineHeight"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.label.lineHeight"
        }
      }
    },
    "button.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "button.label.fontFamily"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.label.fontFamily"
        }
      }
    },
    "button.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "button.label.fontSize"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.label.fontSize"
        }
      }
    },
    "button.gutter": {
      "type": "length",
      "value": {
        "ref": "button.gutterWidth"
      },
      "comment": "\n      The space between elements with the component.\n      E.g. The space between an icon and label within a button.",
      "metadata": {
        "deprecated": {
          "equivalent": "button.gutterWidth"
        }
      }
    },
    "button.horizontalPadding": {
      "type": "length",
      "value": {
        "ref": "button.paddingHorizontal"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.paddingHorizontal"
        }
      }
    },
    "button.minimumWidth": {
      "type": "length",
      "value": {
        "ref": "button.minWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.minWidth"
        }
      }
    },
    "button.verticalPadding": {
      "type": "length",
      "value": {
        "ref": "button.paddingVertical"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.paddingVertical"
        }
      }
    },
    "button.halo.width": {
      "type": "length",
      "value": "2px",
      "metadata": {
        "deprecated": {
          "equivalent": "button.haloWidth"
        }
      }
    },
    "button.halo.color": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "colorScheme.halo"
        }
      }
    },
    "button.hover.halo.width": {
      "type": "length",
      "value": "2px",
      "metadata": {
        "deprecated": {
          "equivalent": "button.hover.haloWidth"
        }
      }
    },
    "button.focus.halo.width": {
      "type": "length",
      "value": {
        "ref": "button.haloWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.haloWidth"
        }
      }
    },
    "button.pressed.halo.width": {
      "type": "length",
      "value": {
        "ref": "button.pressed.haloWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.pressed.haloWidth"
        }
      }
    },
    "button.focus.halo.color": {
      "type": "color",
      "value": {
        "ref": "button.focus.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.focus.haloColor"
        }
      }
    },
    "button.pressed.halo.color": {
      "type": "color",
      "value": {
        "ref": "button.pressed.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.pressed.haloColor"
        }
      }
    },
    "button.outline.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "button.outline.default.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.outline.default.backgroundColor"
        }
      }
    },
    "button.outline.borderColor": {
      "type": "color",
      "value": {
        "ref": "button.outline.default.borderColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.outline.default.borderColor"
        }
      }
    },
    "button.outline.focus.halo.color": {
      "type": "color",
      "value": {
        "ref": "button.focus.halo.color"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.focus.haloColor"
        }
      }
    },
    "button.outline.focus.icon.color": {
      "type": "color",
      "value": {
        "ref": "button.outline.icon.color"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.outline.iconColor"
        }
      }
    },
    "button.outline.focus.textColor": {
      "type": "color",
      "value": {
        "ref": "button.outline.textColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.outline.label.fontColor"
        }
      }
    },
    "button.outline.halo.color": {
      "type": "color",
      "value": {
        "ref": "button.halo.color"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "colorScheme.halo"
        }
      }
    },
    "button.outline.hover.halo.color": {
      "type": "color",
      "value": {
        "ref": "button.hover.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.hover.haloColor"
        }
      }
    },
    "button.outline.hover.icon.color": {
      "type": "color",
      "value": {
        "ref": "button.outline.iconColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.outline.iconColor"
        }
      }
    },
    "button.outline.hover.textColor": {
      "type": "color",
      "value": {
        "ref": "button.outline.label.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.outline.label.fontColor"
        }
      }
    },
    "button.outline.icon.color": {
      "type": "color",
      "value": {
        "ref": "button.outline.iconColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.outline.iconColor"
        }
      }
    },
    "button.outline.pressed.halo.color": {
      "type": "color",
      "value": {
        "ref": "button.pressed.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.pressed.haloColor"
        }
      }
    },
    "button.outline.pressed.haloWidth": {
      "type": "length",
      "value": {
        "ref": "button.pressed.haloWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.pressed.haloWidth"
        }
      }
    },
    "button.outline.pressed.icon.color": {
      "type": "color",
      "value": {
        "ref": "button.outline.iconColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.outline.iconColor"
        }
      }
    },
    "button.outline.pressed.textColor": {
      "type": "color",
      "value": {
        "ref": "button.outline.label.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.outline.label.fontColor"
        }
      }
    },
    "button.outline.textColor": {
      "type": "color",
      "value": {
        "ref": "button.outline.label.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.outline.label.fontColor"
        }
      }
    },
    "button.solid.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "button.solid.default.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.solid.default.backgroundColor"
        }
      }
    },
    "button.solid.borderColor": {
      "type": "color",
      "value": {
        "ref": "button.solid.default.borderColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.solid.default.borderColor"
        }
      }
    },
    "button.solid.halo.color": {
      "type": "color",
      "value": {
        "ref": "button.halo.color"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "colorScheme.halo"
        }
      }
    },
    "button.solid.textColor": {
      "type": "color",
      "value": {
        "ref": "button.solid.label.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.solid.label.fontColor"
        }
      }
    },
    "button.solid.icon.color": {
      "type": "color",
      "value": {
        "ref": "button.solid.iconColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.solid.iconColor"
        }
      }
    },
    "button.solid.hover.halo.color": {
      "type": "color",
      "value": {
        "ref": "button.hover.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.hover.haloColor"
        }
      }
    },
    "button.solid.hover.textColor": {
      "type": "color",
      "value": {
        "ref": "button.solid.label.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.solid.label.fontColor"
        }
      }
    },
    "button.solid.hover.icon.color": {
      "type": "color",
      "value": {
        "ref": "button.solid.iconColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.solid.iconColor"
        }
      }
    },
    "button.solid.focus.halo.color": {
      "type": "color",
      "value": {
        "ref": "button.focus.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.focus.haloColor"
        }
      }
    },
    "button.solid.focus.textColor": {
      "type": "color",
      "value": {
        "ref": "button.solid.label.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.solid.label.fontColor"
        }
      }
    },
    "button.solid.focus.icon.color": {
      "type": "color",
      "value": {
        "ref": "button.solid.iconColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.solid.iconColor"
        }
      }
    },
    "button.solid.pressed.haloWidth": {
      "type": "length",
      "value": {
        "ref": "button.pressed.haloWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.pressed.haloWidth"
        }
      }
    },
    "button.solid.pressed.halo.color": {
      "type": "color",
      "value": {
        "ref": "button.pressed.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.pressed.haloColor"
        }
      }
    },
    "button.solid.pressed.textColor": {
      "type": "color",
      "value": {
        "ref": "button.solid.label.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.solid.label.fontColor"
        }
      }
    },
    "button.solid.pressed.icon.color": {
      "type": "color",
      "value": {
        "ref": "button.solid.iconColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.solid.iconColor"
        }
      }
    },
    "button.flat.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "button.flat.default.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.flat.default.backgroundColor"
        }
      }
    },
    "button.flat.borderColor": {
      "type": "color",
      "value": {
        "ref": "button.flat.default.borderColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.flat.default.borderColor"
        }
      }
    },
    "button.flat.halo.color": {
      "type": "color",
      "value": {
        "ref": "button.halo.color"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "colorScheme.halo"
        }
      }
    },
    "button.flat.textColor": {
      "type": "color",
      "value": {
        "ref": "button.flat.label.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.flat.label.fontColor"
        }
      }
    },
    "button.flat.icon.color": {
      "type": "color",
      "value": {
        "ref": "button.flat.iconColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.flat.iconColor"
        }
      }
    },
    "button.flat.hover.halo.color": {
      "type": "color",
      "value": {
        "ref": "button.hover.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.hover.haloColor"
        }
      }
    },
    "button.flat.hover.textColor": {
      "type": "color",
      "value": {
        "ref": "button.flat.label.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.flat.label.fontColor"
        }
      }
    },
    "button.flat.hover.icon.color": {
      "type": "color",
      "value": {
        "ref": "button.flat.iconColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.flat.iconColor"
        }
      }
    },
    "button.flat.focus.halo.color": {
      "type": "color",
      "value": {
        "ref": "button.focus.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.focus.haloColor"
        }
      }
    },
    "button.flat.focus.textColor": {
      "type": "color",
      "value": {
        "ref": "button.flat.label.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.flat.label.fontColor"
        }
      }
    },
    "button.flat.focus.icon.color": {
      "type": "color",
      "value": {
        "ref": "button.flat.iconColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.flat.iconColor"
        }
      }
    },
    "button.flat.pressed.haloWidth": {
      "type": "length",
      "value": {
        "ref": "button.pressed.haloWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.pressed.haloWidth"
        }
      }
    },
    "button.flat.pressed.halo.color": {
      "type": "color",
      "value": {
        "ref": "button.pressed.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.pressed.haloColor"
        }
      }
    },
    "button.flat.pressed.textColor": {
      "type": "color",
      "value": {
        "ref": "button.flat.label.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.flat.label.fontColor"
        }
      }
    },
    "button.flat.pressed.icon.color": {
      "type": "color",
      "value": {
        "ref": "button.flat.iconColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "button.flat.iconColor"
        }
      }
    },
    "canvasFrame.label.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "canvasFrame.label.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "canvasFrame.label.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "canvasFrame.label.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.medium"
      }
    },
    "canvasFrame.label.marginLeft": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.small"
      }
    },
    "canvasFrame.border.borderColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.500"
      }
    },
    "canvasFrame.border.borderWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.medium"
      }
    },
    "canvasFrame.controlPanel.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level100"
      }
    },
    "canvasFrame.controlPanel.paddingRight": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.small"
      }
    },
    "canvasFrame.controlPanel.paddingLeft": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.extraSmall"
      }
    },
    "canvasFrame.controlPanel.paddingVertical": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.extraSmall"
      }
    },
    "canvasFrame.closeIcon.marginLeft": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.small"
      }
    },
    "checkbox.borderWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.small"
      }
    },
    "checkbox.borderRadius": {
      "type": "borderRadius",
      "value": {
        "ref": "basics.borderRadii.none"
      }
    },
    "checkbox.halo.color": {
      "type": "color",
      "value": {
        "ref": "checkbox.hover.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "checkbox.hover.haloColor"
        }
      }
    },
    "checkbox.halo.width": {
      "type": "length",
      "value": {
        "ref": "checkbox.hover.haloWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "checkbox.hover.haloWidth"
        }
      }
    },
    "checkbox.minHeight": {
      "type": "length",
      "value": "16px"
    },
    "checkbox.height": {
      "type": "length",
      "value": {
        "ref": "checkbox.minHeight"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "checkbox.minHeight"
        }
      }
    },
    "checkbox.indicatorColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      }
    },
    "checkbox.iconColor": {
      "type": "color",
      "value": {
        "ref": "checkbox.indicatorColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "checkbox.indicatorColor"
        }
      }
    },
    "checkbox.minWidth": {
      "type": "length",
      "value": "16px"
    },
    "checkbox.width": {
      "type": "length",
      "value": {
        "ref": "checkbox.minWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "checkbox.minWidth"
        }
      }
    },
    "checkbox.unchecked.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "checkbox.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "checkbox.unchecked.default.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "checkbox.unchecked.default.backgroundColor"
        }
      }
    },
    "checkbox.unchecked.default.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.base"
      }
    },
    "checkbox.borderColor": {
      "type": "color",
      "value": {
        "ref": "checkbox.unchecked.default.borderColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "checkbox.unchecked.default.borderColor"
        }
      }
    },
    "checkbox.unchecked.hover.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.base"
      }
    },
    "checkbox.hover.borderColor": {
      "type": "color",
      "value": {
        "ref": "checkbox.unchecked.hover.borderColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "checkbox.unchecked.hover.borderColor"
        }
      }
    },
    "checkbox.hover.halo.width": {
      "type": "length",
      "value": {
        "ref": "checkbox.hover.haloWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "checkbox.hover.haloWidth"
        }
      }
    },
    "checkbox.hover.halo.color": {
      "type": "color",
      "value": {
        "ref": "checkbox.hover.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "checkbox.hover.haloColor"
        }
      }
    },
    "checkbox.unchecked.focus.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.accent"
      }
    },
    "checkbox.focus.borderColor": {
      "type": "color",
      "value": {
        "ref": "checkbox.unchecked.focus.borderColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "checkbox.unchecked.focus.borderColor"
        }
      }
    },
    "checkbox.focus.halo.color": {
      "type": "color",
      "value": {
        "ref": "checkbox.focus.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "checkbox.focus.haloColor"
        }
      }
    },
    "checkbox.focus.halo.width": {
      "type": "length",
      "value": {
        "ref": "checkbox.focus.haloWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "checkbox.focus.haloWidth"
        }
      }
    },
    "checkbox.unchecked.pressed.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.base"
      }
    },
    "checkbox.pressed.borderColor": {
      "type": "color",
      "value": {
        "ref": "checkbox.unchecked.pressed.borderColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "checkbox.unchecked.pressed.borderColor"
        }
      }
    },
    "checkbox.pressed.halo.color": {
      "type": "color",
      "value": {
        "ref": "checkbox.pressed.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "checkbox.pressed.haloColor"
        }
      }
    },
    "checkbox.pressed.halo.width": {
      "type": "length",
      "value": {
        "ref": "checkbox.pressed.haloWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "checkbox.pressed.haloWidth"
        }
      }
    },
    "checkbox.checked.default.borderColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.600"
      }
    },
    "checkbox.checked.borderColor": {
      "type": "color",
      "value": {
        "ref": "checkbox.checked.default.borderColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "checkbox.checked.default.borderColor"
        }
      }
    },
    "checkbox.checked.iconColor": {
      "type": "color",
      "value": {
        "ref": "checkbox.indicatorColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "checkbox.indicatorColor"
        }
      }
    },
    "checkbox.checked.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.600"
      }
    },
    "checkbox.checked.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "checkbox.checked.default.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "checkbox.checked.default.backgroundColor"
        }
      }
    },
    "checkbox.indeterminate.borderColor": {
      "type": "color",
      "value": {
        "ref": "checkbox.checked.default.borderColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "checkbox.checked.default.borderColor"
        }
      }
    },
    "checkbox.indeterminate.iconColor": {
      "type": "color",
      "value": {
        "ref": "checkbox.indicatorColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "checkbox.indicatorColor"
        }
      }
    },
    "checkbox.indeterminate.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "checkbox.checked.default.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "checkbox.checked.default.backgroundColor"
        }
      }
    },
    "checkbox.focus.checked.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "checkbox.checked.default.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "checkbox.checked.default.backgroundColor"
        }
      }
    },
    "checkbox.focus.checked.borderColor": {
      "type": "color",
      "value": {
        "ref": "checkbox.checked.default.borderColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "checkbox.checked.default.borderColor"
        }
      }
    },
    "checkbox.focus.indeterminate.borderColor": {
      "type": "color",
      "value": {
        "ref": "checkbox.checked.default.borderColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "checkbox.checked.default.borderColor"
        }
      }
    },
    "checkbox.focus.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.halo.focus"
      }
    },
    "checkbox.hover.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.halo.hover"
      }
    },
    "checkbox.pressed.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.halo.pressed"
      }
    },
    "checkbox.focus.haloWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.medium"
      }
    },
    "checkbox.hover.haloWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.medium"
      }
    },
    "checkbox.pressed.haloWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.large"
      }
    },
    "checkbox.unchecked.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "checkbox.unchecked.focus.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "checkbox.unchecked.pressed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "checkbox.checked.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      }
    },
    "checkbox.checked.hover.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      }
    },
    "checkbox.checked.pressed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      }
    },
    "checkbox.checked.pressed.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      }
    },
    "component.disabled.opacity": {
      "type": "opacity",
      "value": "0.4",
      "metadata": {
        "deprecated": {
          "equivalent": "colorScheme.opacity.disabled"
        }
      }
    },
    "dataVis.colors.red.a.10": {
      "type": "color",
      "value": "#e7b1ba"
    },
    "dataVis.colors.red.a.20": {
      "type": "color",
      "value": "#e09da8"
    },
    "dataVis.colors.red.a.30": {
      "type": "color",
      "value": "#da8997"
    },
    "dataVis.colors.red.a.40": {
      "type": "color",
      "value": "#d47686"
    },
    "dataVis.colors.red.a.50": {
      "type": "color",
      "value": "#ce6274"
    },
    "dataVis.colors.red.a.60": {
      "type": "color",
      "value": "#c84f63"
    },
    "dataVis.colors.red.a.70": {
      "type": "color",
      "value": "#c23b52"
    },
    "dataVis.colors.red.a.80": {
      "type": "color",
      "value": "#bc2840"
    },
    "dataVis.colors.red.a.90": {
      "type": "color",
      "value": "#a31d33"
    },
    "dataVis.colors.red.a.100": {
      "type": "color",
      "value": "#801628"
    },
    "dataVis.colors.red.b.10": {
      "type": "color",
      "value": "#e7b2b2"
    },
    "dataVis.colors.red.b.20": {
      "type": "color",
      "value": "#e09f9f"
    },
    "dataVis.colors.red.b.30": {
      "type": "color",
      "value": "#da8c8c"
    },
    "dataVis.colors.red.b.40": {
      "type": "color",
      "value": "#d47878"
    },
    "dataVis.colors.red.b.50": {
      "type": "color",
      "value": "#ce6565"
    },
    "dataVis.colors.red.b.60": {
      "type": "color",
      "value": "#c85252"
    },
    "dataVis.colors.red.b.70": {
      "type": "color",
      "value": "#c23f3f"
    },
    "dataVis.colors.red.b.80": {
      "type": "color",
      "value": "#bc2b2b"
    },
    "dataVis.colors.red.b.90": {
      "type": "color",
      "value": "#ab1d1d"
    },
    "dataVis.colors.red.b.100": {
      "type": "color",
      "value": "#871616"
    },
    "dataVis.colors.red.c.10": {
      "type": "color",
      "value": "#e7b4a9"
    },
    "dataVis.colors.red.c.20": {
      "type": "color",
      "value": "#e0a194"
    },
    "dataVis.colors.red.c.30": {
      "type": "color",
      "value": "#da8e7f"
    },
    "dataVis.colors.red.c.40": {
      "type": "color",
      "value": "#d47b69"
    },
    "dataVis.colors.red.c.50": {
      "type": "color",
      "value": "#ce6854"
    },
    "dataVis.colors.red.c.60": {
      "type": "color",
      "value": "#c8553f"
    },
    "dataVis.colors.red.c.70": {
      "type": "color",
      "value": "#c24329"
    },
    "dataVis.colors.red.c.80": {
      "type": "color",
      "value": "#a53823"
    },
    "dataVis.colors.red.c.90": {
      "type": "color",
      "value": "#882e1d"
    },
    "dataVis.colors.red.c.100": {
      "type": "color",
      "value": "#6b2516"
    },
    "dataVis.colors.orange.a.10": {
      "type": "color",
      "value": "#f3dace"
    },
    "dataVis.colors.orange.a.20": {
      "type": "color",
      "value": "#edc8b6"
    },
    "dataVis.colors.orange.a.30": {
      "type": "color",
      "value": "#e7b69e"
    },
    "dataVis.colors.orange.a.40": {
      "type": "color",
      "value": "#e0a485"
    },
    "dataVis.colors.orange.a.50": {
      "type": "color",
      "value": "#da916d"
    },
    "dataVis.colors.orange.a.60": {
      "type": "color",
      "value": "#d47f54"
    },
    "dataVis.colors.orange.a.70": {
      "type": "color",
      "value": "#ce6d3c"
    },
    "dataVis.colors.orange.a.80": {
      "type": "color",
      "value": "#bd5e2f"
    },
    "dataVis.colors.orange.a.90": {
      "type": "color",
      "value": "#a45229"
    },
    "dataVis.colors.orange.a.100": {
      "type": "color",
      "value": "#8b4623"
    },
    "dataVis.colors.orange.b.10": {
      "type": "color",
      "value": "#f3dcc5"
    },
    "dataVis.colors.orange.b.20": {
      "type": "color",
      "value": "#edcba9"
    },
    "dataVis.colors.orange.b.30": {
      "type": "color",
      "value": "#e7b98c"
    },
    "dataVis.colors.orange.b.40": {
      "type": "color",
      "value": "#e0a86f"
    },
    "dataVis.colors.orange.b.50": {
      "type": "color",
      "value": "#da9652"
    },
    "dataVis.colors.orange.b.60": {
      "type": "color",
      "value": "#d0863b"
    },
    "dataVis.colors.orange.b.70": {
      "type": "color",
      "value": "#bb7835"
    },
    "dataVis.colors.orange.b.80": {
      "type": "color",
      "value": "#a56a2f"
    },
    "dataVis.colors.orange.b.90": {
      "type": "color",
      "value": "#905c29"
    },
    "dataVis.colors.orange.b.100": {
      "type": "color",
      "value": "#7a4e23"
    },
    "dataVis.colors.orange.c.10": {
      "type": "color",
      "value": "#f3dfb7"
    },
    "dataVis.colors.orange.c.20": {
      "type": "color",
      "value": "#edcf93"
    },
    "dataVis.colors.orange.c.30": {
      "type": "color",
      "value": "#e7bf6f"
    },
    "dataVis.colors.orange.c.40": {
      "type": "color",
      "value": "#e0af4b"
    },
    "dataVis.colors.orange.c.50": {
      "type": "color",
      "value": "#ce9f41"
    },
    "dataVis.colors.orange.c.60": {
      "type": "color",
      "value": "#bb903b"
    },
    "dataVis.colors.orange.c.70": {
      "type": "color",
      "value": "#a88235"
    },
    "dataVis.colors.orange.c.80": {
      "type": "color",
      "value": "#94732f"
    },
    "dataVis.colors.orange.c.90": {
      "type": "color",
      "value": "#816429"
    },
    "dataVis.colors.orange.c.100": {
      "type": "color",
      "value": "#6e5523"
    },
    "dataVis.colors.yellow.a.10": {
      "type": "color",
      "value": "#f9f2cd"
    },
    "dataVis.colors.yellow.a.20": {
      "type": "color",
      "value": "#f3e49b"
    },
    "dataVis.colors.yellow.a.30": {
      "type": "color",
      "value": "#edd768"
    },
    "dataVis.colors.yellow.a.40": {
      "type": "color",
      "value": "#e0c84e"
    },
    "dataVis.colors.yellow.a.50": {
      "type": "color",
      "value": "#cfb847"
    },
    "dataVis.colors.yellow.a.60": {
      "type": "color",
      "value": "#bda841"
    },
    "dataVis.colors.yellow.a.70": {
      "type": "color",
      "value": "#ab993b"
    },
    "dataVis.colors.yellow.a.80": {
      "type": "color",
      "value": "#9a8935"
    },
    "dataVis.colors.yellow.a.90": {
      "type": "color",
      "value": "#88792f"
    },
    "dataVis.colors.yellow.a.100": {
      "type": "color",
      "value": "#766929"
    },
    "dataVis.colors.yellow.b.10": {
      "type": "color",
      "value": "#f9f9a5"
    },
    "dataVis.colors.yellow.b.20": {
      "type": "color",
      "value": "#f1f15a"
    },
    "dataVis.colors.yellow.b.30": {
      "type": "color",
      "value": "#e1e154"
    },
    "dataVis.colors.yellow.b.40": {
      "type": "color",
      "value": "#d0d04e"
    },
    "dataVis.colors.yellow.b.50": {
      "type": "color",
      "value": "#c0c047"
    },
    "dataVis.colors.yellow.b.60": {
      "type": "color",
      "value": "#afaf41"
    },
    "dataVis.colors.yellow.b.70": {
      "type": "color",
      "value": "#9f9f3b"
    },
    "dataVis.colors.yellow.b.80": {
      "type": "color",
      "value": "#8e8e35"
    },
    "dataVis.colors.yellow.b.90": {
      "type": "color",
      "value": "#7e7e2f"
    },
    "dataVis.colors.yellow.b.100": {
      "type": "color",
      "value": "#6e6e29"
    },
    "dataVis.colors.yellowGreen.a.10": {
      "type": "color",
      "value": "#e0f380"
    },
    "dataVis.colors.yellowGreen.a.20": {
      "type": "color",
      "value": "#d0e954"
    },
    "dataVis.colors.yellowGreen.a.30": {
      "type": "color",
      "value": "#c1d84e"
    },
    "dataVis.colors.yellowGreen.a.40": {
      "type": "color",
      "value": "#b2c747"
    },
    "dataVis.colors.yellowGreen.a.50": {
      "type": "color",
      "value": "#a2b641"
    },
    "dataVis.colors.yellowGreen.a.60": {
      "type": "color",
      "value": "#93a53b"
    },
    "dataVis.colors.yellowGreen.a.70": {
      "type": "color",
      "value": "#849435"
    },
    "dataVis.colors.yellowGreen.a.80": {
      "type": "color",
      "value": "#75832f"
    },
    "dataVis.colors.yellowGreen.a.90": {
      "type": "color",
      "value": "#667229"
    },
    "dataVis.colors.yellowGreen.a.100": {
      "type": "color",
      "value": "#566123"
    },
    "dataVis.colors.yellowGreen.b.10": {
      "type": "color",
      "value": "#d6f39b"
    },
    "dataVis.colors.yellowGreen.b.20": {
      "type": "color",
      "value": "#c1ed6a"
    },
    "dataVis.colors.yellowGreen.b.30": {
      "type": "color",
      "value": "#b0e14e"
    },
    "dataVis.colors.yellowGreen.b.40": {
      "type": "color",
      "value": "#a2cf47"
    },
    "dataVis.colors.yellowGreen.b.50": {
      "type": "color",
      "value": "#94bd41"
    },
    "dataVis.colors.yellowGreen.b.60": {
      "type": "color",
      "value": "#86ab3b"
    },
    "dataVis.colors.yellowGreen.b.70": {
      "type": "color",
      "value": "#789a35"
    },
    "dataVis.colors.yellowGreen.b.80": {
      "type": "color",
      "value": "#6a882f"
    },
    "dataVis.colors.yellowGreen.b.90": {
      "type": "color",
      "value": "#5c7629"
    },
    "dataVis.colors.yellowGreen.b.100": {
      "type": "color",
      "value": "#4f6523"
    },
    "dataVis.colors.yellowGreen.c.10": {
      "type": "color",
      "value": "#cff3ac"
    },
    "dataVis.colors.yellowGreen.c.20": {
      "type": "color",
      "value": "#b8ed83"
    },
    "dataVis.colors.yellowGreen.c.30": {
      "type": "color",
      "value": "#a0e759"
    },
    "dataVis.colors.yellowGreen.c.40": {
      "type": "color",
      "value": "#90d847"
    },
    "dataVis.colors.yellowGreen.c.50": {
      "type": "color",
      "value": "#83c641"
    },
    "dataVis.colors.yellowGreen.c.60": {
      "type": "color",
      "value": "#77b33b"
    },
    "dataVis.colors.yellowGreen.c.70": {
      "type": "color",
      "value": "#6ba135"
    },
    "dataVis.colors.yellowGreen.c.80": {
      "type": "color",
      "value": "#5e8e2f"
    },
    "dataVis.colors.yellowGreen.c.90": {
      "type": "color",
      "value": "#527c29"
    },
    "dataVis.colors.yellowGreen.c.100": {
      "type": "color",
      "value": "#466923"
    },
    "dataVis.colors.green.a.10": {
      "type": "color",
      "value": "#b1ed94"
    },
    "dataVis.colors.green.a.20": {
      "type": "color",
      "value": "#98e770"
    },
    "dataVis.colors.green.a.30": {
      "type": "color",
      "value": "#7ee04c"
    },
    "dataVis.colors.green.a.40": {
      "type": "color",
      "value": "#71cf41"
    },
    "dataVis.colors.green.a.50": {
      "type": "color",
      "value": "#66bc3b"
    },
    "dataVis.colors.green.a.60": {
      "type": "color",
      "value": "#5ba835"
    },
    "dataVis.colors.green.a.70": {
      "type": "color",
      "value": "#51952f"
    },
    "dataVis.colors.green.a.80": {
      "type": "color",
      "value": "#468129"
    },
    "dataVis.colors.green.a.90": {
      "type": "color",
      "value": "#3c6e23"
    },
    "dataVis.colors.green.a.100": {
      "type": "color",
      "value": "#315b1d"
    },
    "dataVis.colors.green.b.10": {
      "type": "color",
      "value": "#adeda0"
    },
    "dataVis.colors.green.b.20": {
      "type": "color",
      "value": "#92e781"
    },
    "dataVis.colors.green.b.30": {
      "type": "color",
      "value": "#76e061"
    },
    "dataVis.colors.green.b.40": {
      "type": "color",
      "value": "#5bda41"
    },
    "dataVis.colors.green.b.50": {
      "type": "color",
      "value": "#52c63b"
    },
    "dataVis.colors.green.b.60": {
      "type": "color",
      "value": "#4ab135"
    },
    "dataVis.colors.green.b.70": {
      "type": "color",
      "value": "#419d2f"
    },
    "dataVis.colors.green.b.80": {
      "type": "color",
      "value": "#398829"
    },
    "dataVis.colors.green.b.90": {
      "type": "color",
      "value": "#307423"
    },
    "dataVis.colors.green.b.100": {
      "type": "color",
      "value": "#285f1d"
    },
    "dataVis.colors.green.c.10": {
      "type": "color",
      "value": "#a9eda9"
    },
    "dataVis.colors.green.c.20": {
      "type": "color",
      "value": "#8de78d"
    },
    "dataVis.colors.green.c.30": {
      "type": "color",
      "value": "#70e070"
    },
    "dataVis.colors.green.c.40": {
      "type": "color",
      "value": "#54da54"
    },
    "dataVis.colors.green.c.50": {
      "type": "color",
      "value": "#3bd23b"
    },
    "dataVis.colors.green.c.60": {
      "type": "color",
      "value": "#35bc35"
    },
    "dataVis.colors.green.c.70": {
      "type": "color",
      "value": "#2fa62f"
    },
    "dataVis.colors.green.c.80": {
      "type": "color",
      "value": "#299129"
    },
    "dataVis.colors.green.c.90": {
      "type": "color",
      "value": "#237b23"
    },
    "dataVis.colors.green.c.100": {
      "type": "color",
      "value": "#1d651d"
    },
    "dataVis.colors.blueGreen.a.10": {
      "type": "color",
      "value": "#a6edb2"
    },
    "dataVis.colors.blueGreen.a.20": {
      "type": "color",
      "value": "#89e798"
    },
    "dataVis.colors.blueGreen.a.30": {
      "type": "color",
      "value": "#6be07f"
    },
    "dataVis.colors.blueGreen.a.40": {
      "type": "color",
      "value": "#4eda65"
    },
    "dataVis.colors.blueGreen.a.50": {
      "type": "color",
      "value": "#3bcd53"
    },
    "dataVis.colors.blueGreen.a.60": {
      "type": "color",
      "value": "#35b84b"
    },
    "dataVis.colors.blueGreen.a.70": {
      "type": "color",
      "value": "#2fa342"
    },
    "dataVis.colors.blueGreen.a.80": {
      "type": "color",
      "value": "#298d3a"
    },
    "dataVis.colors.blueGreen.a.90": {
      "type": "color",
      "value": "#237831"
    },
    "dataVis.colors.blueGreen.a.100": {
      "type": "color",
      "value": "#1d6328"
    },
    "dataVis.colors.blueGreen.b.10": {
      "type": "color",
      "value": "#a3edbb"
    },
    "dataVis.colors.blueGreen.b.20": {
      "type": "color",
      "value": "#84e7a5"
    },
    "dataVis.colors.blueGreen.b.30": {
      "type": "color",
      "value": "#65e08e"
    },
    "dataVis.colors.blueGreen.b.40": {
      "type": "color",
      "value": "#47da78"
    },
    "dataVis.colors.blueGreen.b.50": {
      "type": "color",
      "value": "#3bc96a"
    },
    "dataVis.colors.blueGreen.b.60": {
      "type": "color",
      "value": "#35b45f"
    },
    "dataVis.colors.blueGreen.b.70": {
      "type": "color",
      "value": "#2f9f54"
    },
    "dataVis.colors.blueGreen.b.80": {
      "type": "color",
      "value": "#298a49"
    },
    "dataVis.colors.blueGreen.b.90": {
      "type": "color",
      "value": "#23763e"
    },
    "dataVis.colors.blueGreen.b.100": {
      "type": "color",
      "value": "#1d6133"
    },
    "dataVis.colors.blueGreen.c.10": {
      "type": "color",
      "value": "#9fedc6"
    },
    "dataVis.colors.blueGreen.c.20": {
      "type": "color",
      "value": "#7fe7b3"
    },
    "dataVis.colors.blueGreen.c.30": {
      "type": "color",
      "value": "#5fe0a0"
    },
    "dataVis.colors.blueGreen.c.40": {
      "type": "color",
      "value": "#41d98d"
    },
    "dataVis.colors.blueGreen.c.50": {
      "type": "color",
      "value": "#3bc580"
    },
    "dataVis.colors.blueGreen.c.60": {
      "type": "color",
      "value": "#35b073"
    },
    "dataVis.colors.blueGreen.c.70": {
      "type": "color",
      "value": "#2f9c65"
    },
    "dataVis.colors.blueGreen.c.80": {
      "type": "color",
      "value": "#298858"
    },
    "dataVis.colors.blueGreen.c.90": {
      "type": "color",
      "value": "#23734b"
    },
    "dataVis.colors.blueGreen.c.100": {
      "type": "color",
      "value": "#1d5f3e"
    },
    "dataVis.colors.cyan.a.10": {
      "type": "color",
      "value": "#9bedd1"
    },
    "dataVis.colors.cyan.a.20": {
      "type": "color",
      "value": "#79e7c2"
    },
    "dataVis.colors.cyan.a.30": {
      "type": "color",
      "value": "#58e0b3"
    },
    "dataVis.colors.cyan.a.40": {
      "type": "color",
      "value": "#41d5a4"
    },
    "dataVis.colors.cyan.a.50": {
      "type": "color",
      "value": "#3bc194"
    },
    "dataVis.colors.cyan.a.60": {
      "type": "color",
      "value": "#35ad85"
    },
    "dataVis.colors.cyan.a.70": {
      "type": "color",
      "value": "#2f9976"
    },
    "dataVis.colors.cyan.a.80": {
      "type": "color",
      "value": "#298566"
    },
    "dataVis.colors.cyan.a.90": {
      "type": "color",
      "value": "#237157"
    },
    "dataVis.colors.cyan.a.100": {
      "type": "color",
      "value": "#1d5d48"
    },
    "dataVis.colors.cyan.b.10": {
      "type": "color",
      "value": "#96edde"
    },
    "dataVis.colors.cyan.b.20": {
      "type": "color",
      "value": "#73e7d3"
    },
    "dataVis.colors.cyan.b.30": {
      "type": "color",
      "value": "#50e0c8"
    },
    "dataVis.colors.cyan.b.40": {
      "type": "color",
      "value": "#41d1b9"
    },
    "dataVis.colors.cyan.b.50": {
      "type": "color",
      "value": "#3bbda8"
    },
    "dataVis.colors.cyan.b.60": {
      "type": "color",
      "value": "#35aa96"
    },
    "dataVis.colors.cyan.b.70": {
      "type": "color",
      "value": "#2f9685"
    },
    "dataVis.colors.cyan.b.80": {
      "type": "color",
      "value": "#298374"
    },
    "dataVis.colors.cyan.b.90": {
      "type": "color",
      "value": "#236f62"
    },
    "dataVis.colors.cyan.b.100": {
      "type": "color",
      "value": "#1d5b51"
    },
    "dataVis.colors.cyan.c.10": {
      "type": "color",
      "value": "#91eded"
    },
    "dataVis.colors.cyan.c.20": {
      "type": "color",
      "value": "#6ce7e7"
    },
    "dataVis.colors.cyan.c.30": {
      "type": "color",
      "value": "#47e0e0"
    },
    "dataVis.colors.cyan.c.40": {
      "type": "color",
      "value": "#41cdcd"
    },
    "dataVis.colors.cyan.c.50": {
      "type": "color",
      "value": "#3bbaba"
    },
    "dataVis.colors.cyan.c.60": {
      "type": "color",
      "value": "#35a7a7"
    },
    "dataVis.colors.cyan.c.70": {
      "type": "color",
      "value": "#2f9393"
    },
    "dataVis.colors.cyan.c.80": {
      "type": "color",
      "value": "#298080"
    },
    "dataVis.colors.cyan.c.90": {
      "type": "color",
      "value": "#236d6d"
    },
    "dataVis.colors.cyan.c.100": {
      "type": "color",
      "value": "#1d5a5a"
    },
    "dataVis.colors.blueCyan.a.10": {
      "type": "color",
      "value": "#a8e1ed"
    },
    "dataVis.colors.blueCyan.a.20": {
      "type": "color",
      "value": "#8ad7e7"
    },
    "dataVis.colors.blueCyan.a.30": {
      "type": "color",
      "value": "#6dcde0"
    },
    "dataVis.colors.blueCyan.a.40": {
      "type": "color",
      "value": "#50c3da"
    },
    "dataVis.colors.blueCyan.a.50": {
      "type": "color",
      "value": "#3bb6cf"
    },
    "dataVis.colors.blueCyan.a.60": {
      "type": "color",
      "value": "#35a3b9"
    },
    "dataVis.colors.blueCyan.a.70": {
      "type": "color",
      "value": "#2f90a4"
    },
    "dataVis.colors.blueCyan.a.80": {
      "type": "color",
      "value": "#297e8f"
    },
    "dataVis.colors.blueCyan.a.90": {
      "type": "color",
      "value": "#236b79"
    },
    "dataVis.colors.blueCyan.a.100": {
      "type": "color",
      "value": "#1d5864"
    },
    "dataVis.colors.blueCyan.b.10": {
      "type": "color",
      "value": "#b5daed"
    },
    "dataVis.colors.blueCyan.b.20": {
      "type": "color",
      "value": "#9dcee7"
    },
    "dataVis.colors.blueCyan.b.30": {
      "type": "color",
      "value": "#84c2e0"
    },
    "dataVis.colors.blueCyan.b.40": {
      "type": "color",
      "value": "#6bb5da"
    },
    "dataVis.colors.blueCyan.b.50": {
      "type": "color",
      "value": "#53a9d4"
    },
    "dataVis.colors.blueCyan.b.60": {
      "type": "color",
      "value": "#3a9dce"
    },
    "dataVis.colors.blueCyan.b.70": {
      "type": "color",
      "value": "#2f8cbb"
    },
    "dataVis.colors.blueCyan.b.80": {
      "type": "color",
      "value": "#297aa2"
    },
    "dataVis.colors.blueCyan.b.90": {
      "type": "color",
      "value": "#23688a"
    },
    "dataVis.colors.blueCyan.b.100": {
      "type": "color",
      "value": "#1d5572"
    },
    "dataVis.colors.blueCyan.c.10": {
      "type": "color",
      "value": "#bed5ed"
    },
    "dataVis.colors.blueCyan.c.20": {
      "type": "color",
      "value": "#a9c8e7"
    },
    "dataVis.colors.blueCyan.c.30": {
      "type": "color",
      "value": "#93bae0"
    },
    "dataVis.colors.blueCyan.c.40": {
      "type": "color",
      "value": "#7eacda"
    },
    "dataVis.colors.blueCyan.c.50": {
      "type": "color",
      "value": "#689ed4"
    },
    "dataVis.colors.blueCyan.c.60": {
      "type": "color",
      "value": "#5390ce"
    },
    "dataVis.colors.blueCyan.c.70": {
      "type": "color",
      "value": "#3d82c8"
    },
    "dataVis.colors.blueCyan.c.80": {
      "type": "color",
      "value": "#2974c0"
    },
    "dataVis.colors.blueCyan.c.90": {
      "type": "color",
      "value": "#2363a3"
    },
    "dataVis.colors.blueCyan.c.100": {
      "type": "color",
      "value": "#1d5186"
    },
    "dataVis.colors.blue.a.10": {
      "type": "color",
      "value": "#b2c3e7"
    },
    "dataVis.colors.blue.a.20": {
      "type": "color",
      "value": "#9eb4e0"
    },
    "dataVis.colors.blue.a.30": {
      "type": "color",
      "value": "#8ba5da"
    },
    "dataVis.colors.blue.a.40": {
      "type": "color",
      "value": "#7796d4"
    },
    "dataVis.colors.blue.a.50": {
      "type": "color",
      "value": "#6487ce"
    },
    "dataVis.colors.blue.a.60": {
      "type": "color",
      "value": "#5178c8"
    },
    "dataVis.colors.blue.a.70": {
      "type": "color",
      "value": "#3d6ac2"
    },
    "dataVis.colors.blue.a.80": {
      "type": "color",
      "value": "#2a5bbc"
    },
    "dataVis.colors.blue.a.90": {
      "type": "color",
      "value": "#1d4ba8"
    },
    "dataVis.colors.blue.a.100": {
      "type": "color",
      "value": "#163b84"
    },
    "dataVis.colors.blue.b.10": {
      "type": "color",
      "value": "#b8c0e7"
    },
    "dataVis.colors.blue.b.20": {
      "type": "color",
      "value": "#a6b0e0"
    },
    "dataVis.colors.blue.b.30": {
      "type": "color",
      "value": "#95a0da"
    },
    "dataVis.colors.blue.b.40": {
      "type": "color",
      "value": "#8391d4"
    },
    "dataVis.colors.blue.b.50": {
      "type": "color",
      "value": "#7181ce"
    },
    "dataVis.colors.blue.b.60": {
      "type": "color",
      "value": "#6071c8"
    },
    "dataVis.colors.blue.b.70": {
      "type": "color",
      "value": "#4e61c2"
    },
    "dataVis.colors.blue.b.80": {
      "type": "color",
      "value": "#3c51bc"
    },
    "dataVis.colors.blue.b.90": {
      "type": "color",
      "value": "#2a42b6"
    },
    "dataVis.colors.blue.b.100": {
      "type": "color",
      "value": "#1932af"
    },
    "dataVis.colors.blue.c.10": {
      "type": "color",
      "value": "#bdbde7"
    },
    "dataVis.colors.blue.c.20": {
      "type": "color",
      "value": "#adade0"
    },
    "dataVis.colors.blue.c.30": {
      "type": "color",
      "value": "#9c9cda"
    },
    "dataVis.colors.blue.c.40": {
      "type": "color",
      "value": "#8c8cd4"
    },
    "dataVis.colors.blue.c.50": {
      "type": "color",
      "value": "#7c7cce"
    },
    "dataVis.colors.blue.c.60": {
      "type": "color",
      "value": "#6b6bc8"
    },
    "dataVis.colors.blue.c.70": {
      "type": "color",
      "value": "#5b5bc2"
    },
    "dataVis.colors.blue.c.80": {
      "type": "color",
      "value": "#4a4abc"
    },
    "dataVis.colors.blue.c.90": {
      "type": "color",
      "value": "#3a3ab6"
    },
    "dataVis.colors.blue.c.100": {
      "type": "color",
      "value": "#2929af"
    },
    "dataVis.colors.purple.a.10": {
      "type": "color",
      "value": "#c2bbe7"
    },
    "dataVis.colors.purple.a.20": {
      "type": "color",
      "value": "#b3aae0"
    },
    "dataVis.colors.purple.a.30": {
      "type": "color",
      "value": "#a499da"
    },
    "dataVis.colors.purple.a.40": {
      "type": "color",
      "value": "#9488d4"
    },
    "dataVis.colors.purple.a.50": {
      "type": "color",
      "value": "#8577ce"
    },
    "dataVis.colors.purple.a.60": {
      "type": "color",
      "value": "#7666c8"
    },
    "dataVis.colors.purple.a.70": {
      "type": "color",
      "value": "#6755c2"
    },
    "dataVis.colors.purple.a.80": {
      "type": "color",
      "value": "#5843bc"
    },
    "dataVis.colors.purple.a.90": {
      "type": "color",
      "value": "#4832b6"
    },
    "dataVis.colors.purple.a.100": {
      "type": "color",
      "value": "#3921af"
    },
    "dataVis.colors.purple.b.10": {
      "type": "color",
      "value": "#c8b8e7"
    },
    "dataVis.colors.purple.b.20": {
      "type": "color",
      "value": "#baa6e0"
    },
    "dataVis.colors.purple.b.30": {
      "type": "color",
      "value": "#ac95da"
    },
    "dataVis.colors.purple.b.40": {
      "type": "color",
      "value": "#9e83d4"
    },
    "dataVis.colors.purple.b.50": {
      "type": "color",
      "value": "#9071ce"
    },
    "dataVis.colors.purple.b.60": {
      "type": "color",
      "value": "#825fc8"
    },
    "dataVis.colors.purple.b.70": {
      "type": "color",
      "value": "#744ec2"
    },
    "dataVis.colors.purple.b.80": {
      "type": "color",
      "value": "#663cbc"
    },
    "dataVis.colors.purple.b.90": {
      "type": "color",
      "value": "#592ab6"
    },
    "dataVis.colors.purple.b.100": {
      "type": "color",
      "value": "#4b18af"
    },
    "dataVis.colors.purple.c.10": {
      "type": "color",
      "value": "#ceb5e7"
    },
    "dataVis.colors.purple.c.20": {
      "type": "color",
      "value": "#c1a2e0"
    },
    "dataVis.colors.purple.c.30": {
      "type": "color",
      "value": "#b590da"
    },
    "dataVis.colors.purple.c.40": {
      "type": "color",
      "value": "#a97dd4"
    },
    "dataVis.colors.purple.c.50": {
      "type": "color",
      "value": "#9c6bce"
    },
    "dataVis.colors.purple.c.60": {
      "type": "color",
      "value": "#9058c8"
    },
    "dataVis.colors.purple.c.70": {
      "type": "color",
      "value": "#8446c2"
    },
    "dataVis.colors.purple.c.80": {
      "type": "color",
      "value": "#7733bc"
    },
    "dataVis.colors.purple.c.90": {
      "type": "color",
      "value": "#6b21b6"
    },
    "dataVis.colors.purple.c.100": {
      "type": "color",
      "value": "#571698"
    },
    "dataVis.colors.magenta.a.10": {
      "type": "color",
      "value": "#dfc5ed"
    },
    "dataVis.colors.magenta.a.20": {
      "type": "color",
      "value": "#d5b1e7"
    },
    "dataVis.colors.magenta.a.30": {
      "type": "color",
      "value": "#ca9ee0"
    },
    "dataVis.colors.magenta.a.40": {
      "type": "color",
      "value": "#c08ada"
    },
    "dataVis.colors.magenta.a.50": {
      "type": "color",
      "value": "#b577d4"
    },
    "dataVis.colors.magenta.a.60": {
      "type": "color",
      "value": "#ab64ce"
    },
    "dataVis.colors.magenta.a.70": {
      "type": "color",
      "value": "#a050c8"
    },
    "dataVis.colors.magenta.a.80": {
      "type": "color",
      "value": "#953dc2"
    },
    "dataVis.colors.magenta.a.90": {
      "type": "color",
      "value": "#8b29bc"
    },
    "dataVis.colors.magenta.a.100": {
      "type": "color",
      "value": "#791da7"
    },
    "dataVis.colors.magenta.b.10": {
      "type": "color",
      "value": "#e5c2ed"
    },
    "dataVis.colors.magenta.b.20": {
      "type": "color",
      "value": "#ddade7"
    },
    "dataVis.colors.magenta.b.30": {
      "type": "color",
      "value": "#d499e0"
    },
    "dataVis.colors.magenta.b.40": {
      "type": "color",
      "value": "#cc84da"
    },
    "dataVis.colors.magenta.b.50": {
      "type": "color",
      "value": "#c370d4"
    },
    "dataVis.colors.magenta.b.60": {
      "type": "color",
      "value": "#bb5bce"
    },
    "dataVis.colors.magenta.b.70": {
      "type": "color",
      "value": "#b247c8"
    },
    "dataVis.colors.magenta.b.80": {
      "type": "color",
      "value": "#aa32c2"
    },
    "dataVis.colors.magenta.b.90": {
      "type": "color",
      "value": "#9b23b3"
    },
    "dataVis.colors.magenta.b.100": {
      "type": "color",
      "value": "#801d94"
    },
    "dataVis.colors.magenta.c.10": {
      "type": "color",
      "value": "#edbeed"
    },
    "dataVis.colors.magenta.c.20": {
      "type": "color",
      "value": "#e7a8e7"
    },
    "dataVis.colors.magenta.c.30": {
      "type": "color",
      "value": "#e093e0"
    },
    "dataVis.colors.magenta.c.40": {
      "type": "color",
      "value": "#da7dda"
    },
    "dataVis.colors.magenta.c.50": {
      "type": "color",
      "value": "#d467d4"
    },
    "dataVis.colors.magenta.c.60": {
      "type": "color",
      "value": "#ce52ce"
    },
    "dataVis.colors.magenta.c.70": {
      "type": "color",
      "value": "#c83cc8"
    },
    "dataVis.colors.magenta.c.80": {
      "type": "color",
      "value": "#be29be"
    },
    "dataVis.colors.magenta.c.90": {
      "type": "color",
      "value": "#a223a2"
    },
    "dataVis.colors.magenta.c.100": {
      "type": "color",
      "value": "#851d85"
    },
    "dataVis.colors.rose.a.10": {
      "type": "color",
      "value": "#edbfe5"
    },
    "dataVis.colors.rose.a.20": {
      "type": "color",
      "value": "#e7aadc"
    },
    "dataVis.colors.rose.a.30": {
      "type": "color",
      "value": "#e095d4"
    },
    "dataVis.colors.rose.a.40": {
      "type": "color",
      "value": "#da80cb"
    },
    "dataVis.colors.rose.a.50": {
      "type": "color",
      "value": "#d46bc3"
    },
    "dataVis.colors.rose.a.60": {
      "type": "color",
      "value": "#ce55ba"
    },
    "dataVis.colors.rose.a.70": {
      "type": "color",
      "value": "#c840b1"
    },
    "dataVis.colors.rose.a.80": {
      "type": "color",
      "value": "#c22ba9"
    },
    "dataVis.colors.rose.a.90": {
      "type": "color",
      "value": "#a72391"
    },
    "dataVis.colors.rose.a.100": {
      "type": "color",
      "value": "#8a1d78"
    },
    "dataVis.colors.rose.b.10": {
      "type": "color",
      "value": "#edc1de"
    },
    "dataVis.colors.rose.b.20": {
      "type": "color",
      "value": "#e7acd3"
    },
    "dataVis.colors.rose.b.30": {
      "type": "color",
      "value": "#e097c8"
    },
    "dataVis.colors.rose.b.40": {
      "type": "color",
      "value": "#da82bd"
    },
    "dataVis.colors.rose.b.50": {
      "type": "color",
      "value": "#d46eb2"
    },
    "dataVis.colors.rose.b.60": {
      "type": "color",
      "value": "#ce59a7"
    },
    "dataVis.colors.rose.b.70": {
      "type": "color",
      "value": "#c8449c"
    },
    "dataVis.colors.rose.b.80": {
      "type": "color",
      "value": "#c22f91"
    },
    "dataVis.colors.rose.b.90": {
      "type": "color",
      "value": "#ae2380"
    },
    "dataVis.colors.rose.b.100": {
      "type": "color",
      "value": "#8f1d69"
    },
    "dataVis.colors.rose.c.10": {
      "type": "color",
      "value": "#edc2d7"
    },
    "dataVis.colors.rose.c.20": {
      "type": "color",
      "value": "#e7aeca"
    },
    "dataVis.colors.rose.c.30": {
      "type": "color",
      "value": "#e099bd"
    },
    "dataVis.colors.rose.c.40": {
      "type": "color",
      "value": "#da85b0"
    },
    "dataVis.colors.rose.c.50": {
      "type": "color",
      "value": "#d471a2"
    },
    "dataVis.colors.rose.c.60": {
      "type": "color",
      "value": "#ce5c95"
    },
    "dataVis.colors.rose.c.70": {
      "type": "color",
      "value": "#c84888"
    },
    "dataVis.colors.rose.c.80": {
      "type": "color",
      "value": "#c2337b"
    },
    "dataVis.colors.rose.c.90": {
      "type": "color",
      "value": "#b5236c"
    },
    "dataVis.colors.rose.c.100": {
      "type": "color",
      "value": "#951d59"
    },
    "dataVis.colors.rose.d.10": {
      "type": "color",
      "value": "#edc3d1"
    },
    "dataVis.colors.rose.d.20": {
      "type": "color",
      "value": "#e7afc2"
    },
    "dataVis.colors.rose.d.30": {
      "type": "color",
      "value": "#e09bb2"
    },
    "dataVis.colors.rose.d.40": {
      "type": "color",
      "value": "#da87a3"
    },
    "dataVis.colors.rose.d.50": {
      "type": "color",
      "value": "#d47394"
    },
    "dataVis.colors.rose.d.60": {
      "type": "color",
      "value": "#ce5f84"
    },
    "dataVis.colors.rose.d.70": {
      "type": "color",
      "value": "#c84b75"
    },
    "dataVis.colors.rose.d.80": {
      "type": "color",
      "value": "#c23766"
    },
    "dataVis.colors.rose.d.90": {
      "type": "color",
      "value": "#bc2356"
    },
    "dataVis.colors.rose.d.100": {
      "type": "color",
      "value": "#9c1d47"
    },
    "dataVis.colors.gray.a.10": {
      "type": "color",
      "value": "#e1e1dc"
    },
    "dataVis.colors.gray.a.20": {
      "type": "color",
      "value": "#d2d2cd"
    },
    "dataVis.colors.gray.a.30": {
      "type": "color",
      "value": "#c2c2be"
    },
    "dataVis.colors.gray.a.40": {
      "type": "color",
      "value": "#b3b3af"
    },
    "dataVis.colors.gray.a.50": {
      "type": "color",
      "value": "#a4a4a0"
    },
    "dataVis.colors.gray.a.60": {
      "type": "color",
      "value": "#949491"
    },
    "dataVis.colors.gray.a.70": {
      "type": "color",
      "value": "#858582"
    },
    "dataVis.colors.gray.a.80": {
      "type": "color",
      "value": "#767673"
    },
    "dataVis.colors.gray.a.90": {
      "type": "color",
      "value": "#666664"
    },
    "dataVis.colors.gray.a.100": {
      "type": "color",
      "value": "#575755"
    },
    "dataVis.colors.gray.b.10": {
      "type": "color",
      "value": "#e0e0e1"
    },
    "dataVis.colors.gray.b.20": {
      "type": "color",
      "value": "#d1d1d3"
    },
    "dataVis.colors.gray.b.30": {
      "type": "color",
      "value": "#c2c2c4"
    },
    "dataVis.colors.gray.b.40": {
      "type": "color",
      "value": "#b2b2b5"
    },
    "dataVis.colors.gray.b.50": {
      "type": "color",
      "value": "#a3a3a6"
    },
    "dataVis.colors.gray.b.60": {
      "type": "color",
      "value": "#939397"
    },
    "dataVis.colors.gray.b.70": {
      "type": "color",
      "value": "#848488"
    },
    "dataVis.colors.gray.b.80": {
      "type": "color",
      "value": "#75757a"
    },
    "dataVis.colors.gray.b.90": {
      "type": "color",
      "value": "#65656b"
    },
    "dataVis.colors.gray.b.100": {
      "type": "color",
      "value": "#56565c"
    },
    "dataVis.colors.gray.c.10": {
      "type": "color",
      "value": "#e0e0e0"
    },
    "dataVis.colors.gray.c.20": {
      "type": "color",
      "value": "#d1d1d1"
    },
    "dataVis.colors.gray.c.30": {
      "type": "color",
      "value": "#c2c2c2"
    },
    "dataVis.colors.gray.c.40": {
      "type": "color",
      "value": "#b2b2b2"
    },
    "dataVis.colors.gray.c.50": {
      "type": "color",
      "value": "#a3a3a3"
    },
    "dataVis.colors.gray.c.60": {
      "type": "color",
      "value": "#949494"
    },
    "dataVis.colors.gray.c.70": {
      "type": "color",
      "value": "#858585"
    },
    "dataVis.colors.gray.c.80": {
      "type": "color",
      "value": "#757575"
    },
    "dataVis.colors.gray.c.90": {
      "type": "color",
      "value": "#666666"
    },
    "dataVis.colors.gray.c.100": {
      "type": "color",
      "value": "#575757"
    },
    "datePicker.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "datePicker.container.paddingHorizontal": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.medium"
      }
    },
    "datePicker.container.paddingVertical": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.large"
      }
    },
    "datePicker.cell.minHeight": {
      "type": "length",
      "value": "36px"
    },
    "datePicker.cell.minWidth": {
      "type": "length",
      "value": "36px"
    },
    "datePicker.standardDate.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "datePicker.standardDate.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "datePicker.standardDate.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.regular"
      }
    },
    "datePicker.selectedDate.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.medium"
      }
    },
    "datePicker.selectedDate.fontColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      }
    },
    "datePicker.selectedDate.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "datePicker.notableDate.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.regular"
      }
    },
    "datePicker.notableDate.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.active"
      }
    },
    "datePicker.notableDate.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "datePicker.restrictedDate.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.regular"
      }
    },
    "datePicker.restrictedDate.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.placeholder"
      },
      "transform": {
        "alpha": 0.4
      }
    },
    "datePicker.restrictedDate.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "datePicker.day.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.regular"
      }
    },
    "datePicker.day.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "datePicker.day.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "datePicker.header.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.medium"
      }
    },
    "datePicker.header.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "datePicker.header.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.large"
      }
    },
    "datePicker.header.paddingBottom": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.large"
      }
    },
    "datePicker.cell.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level250"
      }
    },
    "datePicker.cell.borderWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.small"
      }
    },
    "datePicker.standardDateCell.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level100"
      }
    },
    "datePicker.standardDateCell.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level100To250.hover"
      }
    },
    "datePicker.standardDateCell.focus.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level100"
      }
    },
    "datePicker.standardDateCell.focus.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.accent"
      }
    },
    "datePicker.standardDateCell.focus.borderWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.small"
      }
    },
    "datePicker.standardDateCell.focus.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.halo.focus"
      }
    },
    "datePicker.standardDateCell.focus.haloWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.medium"
      }
    },
    "datePicker.standardDateCell.pressed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level100To250.pressed"
      }
    },
    "datePicker.selectedDateCell.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.500"
      }
    },
    "datePicker.selectedDateCell.focus.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.500"
      }
    },
    "datePicker.selectedDateCell.focus.haloColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.900"
      },
      "transform": {
        "alpha": 0.25
      }
    },
    "datePicker.selectedDateCell.focus.haloWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.medium"
      }
    },
    "datePicker.rangeDateCell.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.on.default"
      }
    },
    "datePicker.rangeDateCell.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.on.hover"
      }
    },
    "datePicker.rangeDateCell.focus.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.on.focus"
      }
    },
    "datePicker.rangeDateCell.focus.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.halo.focus"
      }
    },
    "datePicker.rangeDateCell.focus.haloWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.medium"
      }
    },
    "datePicker.rangeDateCell.pressed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level100To250.pressed"
      }
    },
    "datePicker.currentDateCell.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level100"
      }
    },
    "datePicker.currentDateCell.default.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.accent"
      }
    },
    "datePicker.currentDateCell.default.borderWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.small"
      }
    },
    "datePicker.currentDateCell.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level100To250.hover"
      }
    },
    "datePicker.currentDateCell.hover.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.accent"
      }
    },
    "datePicker.currentDateCell.hover.borderWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.small"
      }
    },
    "datePicker.currentDateCell.focus.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level100"
      }
    },
    "datePicker.currentDateCell.focus.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.accent"
      }
    },
    "datePicker.currentDateCell.focus.borderWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.small"
      }
    },
    "datePicker.currentDateCell.focus.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.halo.focus"
      }
    },
    "datePicker.currentDateCell.focus.haloWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.medium"
      }
    },
    "datePicker.currentDateCell.pressed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level100To250.pressed"
      }
    },
    "datePicker.currentDateCell.pressed.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.accent"
      }
    },
    "datePicker.currentDateCell.pressed.borderWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.small"
      }
    },
    "divider.borderWidth": {
      "type": "length",
      "value": "1px"
    },
    "divider.lightColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.divider.lightweight"
      }
    },
    "divider.heavyColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.divider.heavyweight"
      }
    },
    "divider.width": {
      "type": "length",
      "value": {
        "ref": "divider.borderWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "divider.borderWidth"
        }
      }
    },
    "flyout.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level100"
      }
    },
    "flyout.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "flyout.borderRadius": {
      "type": "borderRadius",
      "value": {
        "ref": "basics.borderRadii.large"
      }
    },
    "flyout.shadowBlur": {
      "type": "length",
      "value": {
        "ref": "basics.shadows.highBlur"
      }
    },
    "flyout.shadowColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.shadow.high"
      }
    },
    "flyout.nub.hypotenuseLength": {
      "type": "length",
      "value": "16px"
    },
    "formField.instructionalText.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "input.value.fontSize"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.value.fontSize"
        }
      }
    },
    "formField.instructionalText.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "input.value.fontWeight"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.value.fontWeight"
        }
      }
    },
    "formField.instructionalText.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "input.value.fontFamily"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.value.fontFamily"
        }
      }
    },
    "formField.instructionalText.fontColor": {
      "type": "color",
      "value": {
        "ref": "input.value.placeholderFontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.value.placeholderFontColor"
        }
      }
    },
    "formField.instructionalText.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "basics.lineHeights.medium"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "basics.lineHeights.medium"
        }
      }
    },
    "formField.icon.width": {
      "type": "length",
      "value": "24px",
      "metadata": {
        "deprecated": {
          "equivalent": "basics.spacings"
        }
      }
    },
    "formField.icon.paddingRight": {
      "type": "length",
      "value": {
        "ref": "density.spacings.small"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "density.spacings.small"
        }
      }
    },
    "formField.icon.color": {
      "type": "color",
      "value": {
        "ref": "input.indicator.default"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.indicator.default"
        }
      }
    },
    "illustration.colors.100": {
      "type": "color",
      "value": "#ffffff"
    },
    "illustration.colors.200": {
      "type": "color",
      "value": "#f5f8fa"
    },
    "illustration.colors.300": {
      "type": "color",
      "value": "#e6edf0"
    },
    "illustration.colors.400": {
      "type": "color",
      "value": "#dee7ec"
    },
    "illustration.colors.500": {
      "type": "color",
      "value": "#ccd9e0"
    },
    "illustration.colors.600": {
      "type": "color",
      "value": "#b0c4ce"
    },
    "illustration.colors.700": {
      "type": "color",
      "value": "#8ca9b8"
    },
    "illustration.colors.800": {
      "type": "color",
      "value": "#5a7d91"
    },
    "illustration.colors.outline": {
      "type": "color",
      "value": "#5a7d91"
    },
    "iconButton.borderRadius": {
      "type": "borderRadius",
      "value": {
        "ref": "button.borderRadius"
      }
    },
    "iconButton.borderWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderRadii.small"
      }
    },
    "iconButton.focus.haloColor": {
      "type": "color",
      "value": {
        "ref": "button.focus.haloColor"
      }
    },
    "iconButton.focus.haloWidth": {
      "type": "length",
      "value": {
        "ref": "button.haloWidth"
      }
    },
    "iconButton.dynamic.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "iconButton.dynamic.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "iconButton.dynamic.focus.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "iconButton.dynamic.default.iconColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.icon.default"
      }
    },
    "iconButton.dynamic.hover.iconColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.icon.hover"
      }
    },
    "iconButton.dynamic.focus.iconColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.icon.focus"
      }
    },
    "iconButton.dynamic.pressed.iconColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.icon.pressed"
      }
    },
    "iconButton.dynamic.on.default.iconColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.icon.on.default"
      }
    },
    "iconButton.dynamic.on.hover.iconColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.700"
      }
    },
    "iconButton.dynamic.on.focus.iconColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.icon.on.default"
      }
    },
    "iconButton.dynamic.on.pressed.iconColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.700"
      }
    },
    "iconButton.dynamic.pressed.100To250BackgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level100To250.pressed"
      }
    },
    "iconButton.dynamic.pressed.300To350BackgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level300To350.pressed"
      }
    },
    "iconButton.static.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "iconButton.static.focus.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "iconButton.static.default.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "iconButton.static.hover.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "iconButton.static.focus.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "iconButton.static.pressed.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "iconButton.static.on.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.on.hover"
      }
    },
    "iconButton.static.on.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.on.hover"
      }
    },
    "iconButton.static.on.focus.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.on.focus"
      }
    },
    "iconButton.static.on.pressed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.on.pressed"
      }
    },
    "iconButton.static.on.default.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.on"
      }
    },
    "iconButton.static.on.hover.borderColor": {
      "type": "color",
      "value": {
        "ref": "iconButton.static.on.borderColor"
      }
    },
    "iconButton.static.on.focus.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.accent"
      }
    },
    "iconButton.static.on.pressed.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.on"
      }
    },
    "iconButton.static.hover.100To250BackgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level100To250.hover"
      }
    },
    "iconButton.static.pressed.100To250BackgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level100To250.pressed"
      }
    },
    "iconButton.static.hover.300To350BackgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level300To350.hover"
      }
    },
    "iconButton.static.pressed.300To350BackgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level300To350.pressed"
      }
    },
    "iconButton.static.on.hover.100To250BackgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.accent"
      },
      "transform": {
        "alpha": 0.35
      }
    },
    "iconButton.static.on.hover.300To350BackgroundColor": {
      "type": "color",
      "value": {
        "ref": "iconButton.static.on.hover.100To250BackgroundColor"
      }
    },
    "iconButton.focus.halo.color": {
      "type": "color",
      "value": {
        "ref": "iconButton.focus.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "iconButton.focus.haloColor"
        }
      }
    },
    "iconButton.focus.halo.width": {
      "type": "length",
      "value": {
        "ref": "iconButton.focus.haloWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "iconButton.focus.haloWidth"
        }
      }
    },
    "iconButton.focus.iconColor": {
      "type": "color",
      "value": {
        "ref": "iconButton.dynamic.focus.iconColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "iconButton.dynamic.focus.iconColor"
        }
      }
    },
    "iconButton.focus.on.iconColor": {
      "type": "color",
      "value": {
        "ref": "iconButton.dynamic.on.focus.iconColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "iconButton.dynamic.on.focus.iconColor"
        }
      }
    },
    "iconButton.hover.iconColor": {
      "type": "color",
      "value": {
        "ref": "iconButton.dynamic.hover.iconColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "iconButton.dynamic.hover.iconColor"
        }
      }
    },
    "iconButton.hover.on.iconColor": {
      "type": "color",
      "value": {
        "ref": "iconButton.dynamic.on.hover.iconColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "iconButton.dynamic.on.hover.iconColor"
        }
      }
    },
    "iconButton.iconColor": {
      "type": "color",
      "value": {
        "ref": "iconButton.dynamic.default.iconColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "iconButton.dynamic.default.iconColor"
        }
      }
    },
    "iconButton.on.iconColor": {
      "type": "color",
      "value": {
        "ref": "iconButton.dynamic.on.default.iconColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "iconButton.dynamic.on.default.iconColor"
        }
      }
    },
    "iconButton.pressed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "iconButton.dynamic.pressed.100To250BackgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "iconButton.dynamic.pressed.100To250BackgroundColor"
        }
      }
    },
    "iconButton.pressed.iconColor": {
      "type": "color",
      "value": {
        "ref": "iconButton.dynamic.pressed.iconColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "iconButton.dynamic.pressed.iconColor"
        }
      }
    },
    "iconButton.pressed.level100To250.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "iconButton.dynamic.pressed.100To250BackgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "iconButton.dynamic.pressed.100To250BackgroundColor"
        }
      }
    },
    "iconButton.pressed.level300To350.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "iconButton.dynamic.pressed.300To350BackgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "iconButton.dynamic.pressed.300To350BackgroundColor"
        }
      }
    },
    "iconButton.pressed.on.iconColor": {
      "type": "color",
      "value": {
        "ref": "iconButton.dynamic.on.pressed.iconColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "iconButton.dynamic.on.pressed.iconColor"
        }
      }
    },
    "iconButton.static.hover.level100To250.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "iconButton.static.hover.100To250BackgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "iconButton.static.hover.100To250BackgroundColor"
        }
      }
    },
    "iconButton.static.hover.level300To350.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "iconButton.static.hover.300To350BackgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "iconButton.static.hover.300To350BackgroundColor"
        }
      }
    },
    "iconButton.static.on.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "iconButton.static.on.default.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "iconButton.static.on.default.backgroundColor"
        }
      }
    },
    "iconButton.static.on.borderColor": {
      "type": "color",
      "value": {
        "ref": "iconButton.static.on.default.borderColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "iconButton.static.on.default.borderColor"
        }
      }
    },
    "iconButton.static.on.hover.level100To250.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "iconButton.static.on.hover.100To250BackgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "iconButton.static.on.hover.100To250BackgroundColor"
        }
      }
    },
    "iconButton.static.on.hover.level300To350.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "iconButton.static.on.hover.300To350BackgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "iconButton.static.on.hover.300To350BackgroundColor"
        }
      }
    },
    "input.borderWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.small"
      }
    },
    "input.borderBottomWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.small"
      }
    },
    "input.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.2
      }
    },
    "input.borderRadius": {
      "type": "borderRadius",
      "value": {
        "ref": "basics.borderRadii.small"
      }
    },
    "input.haloWidth": {
      "type": "length",
      "value": {
        "ref": "basics.borderWidths.large"
      }
    },
    "input.minHeight": {
      "type": "length",
      "value": "36px"
    },
    "input.paddingVertical": {
      "type": "length",
      "value": "4px"
    },
    "input.gutterWidth": {
      "type": "length",
      "value": {
        "ref": "density.spacings.extraSmall"
      }
    },
    "input.disabled.opacity": {
      "type": "opacity",
      "value": {
        "ref": "colorScheme.opacity.disabled"
      }
    },
    "input.error.borderBottomColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.status.error"
      }
    },
    "input.hover.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.halo.hover"
      }
    },
    "input.focus.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.accent"
      },
      "transform": {
        "alpha": 0.25
      }
    },
    "input.pressed.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.halo.pressed"
      }
    },
    "input.value.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "input.value.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "input.value.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "input.value.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.medium"
      }
    },
    "input.value.highlightColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.accent"
      },
      "transform": {
        "alpha": 0.2
      }
    },
    "input.value.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "basics.lineHeights.medium"
      }
    },
    "input.value.placeholderFontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.placeholder"
      }
    },
    "input.indicator.default": {
      "type": "color",
      "value": {
        "ref": "colorScheme.indicator.default"
      }
    },
    "input.indicator.focus": {
      "type": "color",
      "value": {
        "ref": "colorScheme.indicator.focus"
      }
    },
    "input.indicator.hover": {
      "type": "color",
      "value": {
        "ref": "colorScheme.indicator.hover"
      }
    },
    "input.indicator.pressed": {
      "type": "color",
      "value": {
        "ref": "colorScheme.indicator.pressed"
      }
    },
    "input.line.paddingHorizontal": {
      "type": "length",
      "value": {
        "ref": "basics.spacings.none"
      }
    },
    "input.line.default.borderBottomColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.35
      }
    },
    "input.line.hover.borderBottomColor": {
      "type": "color",
      "value": {
        "ref": "input.box.hover.borderBottomColor"
      }
    },
    "input.line.focus.borderBottomColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.accent"
      }
    },
    "input.line.pressed.borderBottomColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.85
      }
    },
    "input.box.paddingHorizontal": {
      "type": "length",
      "value": "12px"
    },
    "input.box.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      }
    },
    "input.box.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      }
    },
    "input.box.focus.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      }
    },
    "input.box.pressed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      }
    },
    "input.box.default.borderColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.600"
      },
      "transform": {
        "alpha": 0.2
      }
    },
    "input.box.hover.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.2
      }
    },
    "input.box.focus.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.2
      }
    },
    "input.box.pressed.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.2
      }
    },
    "input.box.default.borderBottomColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      },
      "transform": {
        "alpha": 0.2
      }
    },
    "input.box.hover.borderBottomColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      }
    },
    "input.box.focus.borderBottomColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.accent"
      }
    },
    "input.box.pressed.borderBottomColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.85
      }
    },
    "input.textArea.line.borderColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.600"
      },
      "transform": {
        "alpha": 0.2
      }
    },
    "input.active.halo.color": {
      "type": "color",
      "value": {
        "ref": "input.focus.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.focus.haloColor"
        }
      }
    },
    "input.borderBottomColor": {
      "type": "color",
      "value": {
        "ref": "input.line.default.borderBottomColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.line.default.borderBottomColor"
        }
      }
    },
    "input.active.halo.width": {
      "type": "length",
      "value": {
        "ref": "input.haloWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.haloWidth"
        }
      }
    },
    "input.box.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "input.box.default.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.box.default.backgroundColor"
        }
      }
    },
    "input.box.borderBottomColor": {
      "type": "color",
      "value": {
        "ref": "input.box.default.borderBottomColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.box.default.borderBottomColor"
        }
      }
    },
    "input.boxType.horizontalPadding": {
      "type": "length",
      "value": {
        "ref": "input.box.paddingHorizontal"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.box.paddingHorizontal"
        }
      }
    },
    "input.focus.borderBottomColor": {
      "type": "color",
      "value": {
        "ref": "input.line.focus.borderBottomColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.line.focus.borderBottomColor"
        }
      }
    },
    "input.focus.halo.color": {
      "type": "color",
      "value": {
        "ref": "input.focus.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.focus.haloColor"
        }
      }
    },
    "input.focus.halo.width": {
      "type": "length",
      "value": {
        "ref": "input.haloWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.haloWidth"
        }
      }
    },
    "input.fontColor": {
      "type": "color",
      "value": {
        "ref": "input.value.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.value.fontColor"
        }
      }
    },
    "input.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "input.value.fontFamily"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.value.fontFamily"
        }
      }
    },
    "input.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "input.value.fontSize"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.value.fontSize"
        }
      }
    },
    "input.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "input.value.fontWeight"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.value.fontWeight"
        }
      }
    },
    "input.halo.color": {
      "type": "color",
      "value": {
        "ref": "input.hover.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.hover.haloColor"
        }
      }
    },
    "input.halo.width": {
      "type": "length",
      "value": {
        "ref": "input.haloWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.haloWidth"
        }
      }
    },
    "input.height": {
      "type": "length",
      "value": {
        "ref": "input.minHeight"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.minHeight"
        }
      }
    },
    "input.highlightColor": {
      "type": "color",
      "value": {
        "ref": "input.value.highlightColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.value.highlightColor"
        }
      }
    },
    "input.horizontalPadding": {
      "type": "length",
      "value": {
        "ref": "input.line.paddingHorizontal"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.line.paddingHorizontal"
        }
      }
    },
    "input.hover.borderBottomColor": {
      "type": "color",
      "value": {
        "ref": "input.box.hover.borderBottomColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.box.hover.borderBottomColor"
        }
      }
    },
    "input.hover.halo.width": {
      "type": "length",
      "value": {
        "ref": "input.haloWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.haloWidth"
        }
      }
    },
    "input.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "input.value.lineHeight"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.value.lineHeight"
        }
      }
    },
    "input.placeholder.fontColor": {
      "type": "color",
      "value": {
        "ref": "input.value.placeholderFontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.value.placeholderFontColor"
        }
      }
    },
    "input.verticalPadding": {
      "type": "length",
      "value": {
        "ref": "input.paddingVertical"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "input.paddingVertical"
        }
      }
    },
    "label.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "label.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "label.fontColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.charcoal900"
      },
      "transform": {
        "alpha": 0.9
      }
    },
    "label.hover.fontColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.charcoal900"
      },
      "transform": {
        "alpha": 0.9
      }
    },
    "label.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.regular"
      }
    },
    "label.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "basics.lineHeights.medium"
      }
    },
    "label.top.fontSize": {
      "type": "fontSize",
      "value": "12px"
    },
    "menu.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level100"
      }
    },
    "menu.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "menu.borderRadius": {
      "type": "borderRadius",
      "value": {
        "ref": "basics.borderRadii.none"
      }
    },
    "menu.topFlushBorderTopRadius": {
      "type": "borderRadius",
      "value": {
        "ref": "basics.borderRadii.none"
      }
    },
    "menu.container.paddingVertical": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.extraSmall"
      }
    },
    "menu.divider.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.divider.lightweight"
      }
    },
    "menu.divider.paddingVertical": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.small"
      }
    },
    "menu.header.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.small"
      }
    },
    "menu.header.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.bold"
      }
    },
    "menu.header.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "menu.header.marginBottom": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.small"
      }
    },
    "menu.label.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "menu.label.default.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.regular"
      }
    },
    "menu.label.selected.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.bold"
      }
    },
    "menu.label.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "menu.shortcut.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "basics.fontSizes.mediumSmall"
      }
    },
    "menu.shortcut.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.regular"
      }
    },
    "menu.shortcut.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.dim"
      }
    },
    "menu.item.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "menu.item.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level100To250.hover"
      }
    },
    "menu.item.focus.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "menu.item.hover.backgroundColor"
      }
    },
    "menu.item.pressed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level100To250.pressed"
      }
    },
    "menu.item.pressed.active.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "menu.item.pressed.backgroundColor"
      }
    },
    "menu.item.paddingHorizontal": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.small"
      }
    },
    "menu.item.paddingVertical": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.extraSmall"
      }
    },
    "menu.item.minHeight": {
      "type": "length",
      "value": "18px"
    },
    "menu.item.gutterWidth": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.small"
      }
    },
    "menu.item.checkmark.hover.iconColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.indicator.default"
      }
    },
    "menu.item.checkmark.active.iconColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.indicator.on"
      }
    },
    "menu.item.indicatorColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.indicator.default"
      }
    },
    "menu.item.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "menu.item.default.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "menu.item.default.backgroundColor"
        }
      }
    },
    "menu.item.active.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "menu.item.pressed.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "menu.item.pressed.backgroundColor"
        }
      }
    },
    "menu.item.horizontalPadding": {
      "type": "spacing",
      "value": {
        "ref": "menu.item.paddingHorizontal"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "menu.item.paddingHorizontal"
        }
      }
    },
    "menu.item.verticalPadding": {
      "type": "spacing",
      "value": {
        "ref": "menu.item.paddingVertical"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "menu.item.paddingVertical"
        }
      }
    },
    "modal.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "modal.paddingHorizontal": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.large"
      }
    },
    "modal.overlayColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.black"
      },
      "transform": {
        "alpha": "0.5"
      }
    },
    "modal.header.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level100"
      }
    },
    "modal.header.borderBottomColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.divider.heavyweight"
      }
    },
    "modal.header.minHeight": {
      "type": "length",
      "value": "60px"
    },
    "modal.body.minHeight": {
      "type": "length",
      "value": "152px"
    },
    "modal.shell.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level100"
      }
    },
    "modal.shell.borderRadius": {
      "type": "borderRadius",
      "value": {
        "ref": "basics.borderRadii.large"
      }
    },
    "modal.shell.minHeight": {
      "type": "length",
      "value": "300px"
    },
    "modal.shell.minWidth": {
      "type": "length",
      "value": "400px"
    },
    "modal.shell.shadowColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.shadow.high"
      }
    },
    "modal.overlay.color": {
      "type": "color",
      "value": {
        "ref": "modal.overlayColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "modal.overlayColor"
        }
      }
    },
    "modal.textColor": {
      "type": "color",
      "value": {
        "ref": "modal.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "modal.fontColor"
        }
      }
    },
    "modal.body.height": {
      "type": "length",
      "value": {
        "ref": "modal.body.minHeight"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "modal.body.minHeight"
        }
      }
    },
    "modal.horizontalPadding": {
      "type": "spacing",
      "value": {
        "ref": "modal.paddingHorizontal"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "modal.paddingHorizontal"
        }
      }
    },
    "modal.header.borderColor": {
      "type": "color",
      "value": {
        "ref": "modal.header.borderBottomColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "modal.header.borderBottomColor"
        }
      }
    },
    "modal.header.height": {
      "type": "length",
      "value": {
        "ref": "modal.header.minHeight"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "modal.header.minHeight"
        }
      }
    },
    "modal.window.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "modal.shell.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "modal.shell.backgroundColor"
        }
      }
    },
    "modal.window.borderRadius": {
      "type": "borderRadius",
      "value": {
        "ref": "modal.shell.borderRadius"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "modal.shell.borderRadius"
        }
      }
    },
    "modal.window.height": {
      "type": "length",
      "value": {
        "ref": "modal.shell.minHeight"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "modal.shell.minHeight"
        }
      }
    },
    "modal.window.width": {
      "type": "length",
      "value": {
        "ref": "modal.shell.minWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "modal.shell.minWidth"
        }
      }
    },
    "modal.window.shadowColor": {
      "type": "color",
      "value": {
        "ref": "modal.shell.shadowColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "modal.shell.shadowColor"
        }
      }
    },
    "notifications.borderRadius": {
      "type": "borderRadius",
      "value": {
        "ref": "basics.borderRadii.large"
      }
    },
    "notifications.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "notifications.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "notifications.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "notifications.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level100To250.hover"
      }
    },
    "notifications.container.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level100"
      }
    },
    "notifications.container.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "notifications.container.shadowBlur": {
      "type": "shadow",
      "value": {
        "ref": "basics.shadows.lowBlur"
      }
    },
    "notifications.container.shadowColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.shadow.low"
      }
    },
    "notifications.statusIndicator.width": {
      "type": "length",
      "value": "3px"
    },
    "notifications.header.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "notifications.header.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.bold"
      }
    },
    "notifications.header.lineHeight": {
      "type": "lineHeight",
      "value": "20px"
    },
    "notifications.toast.object.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.small"
      }
    },
    "notifications.toast.object.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.bold"
      }
    },
    "notifications.toast.object.lineHeight": {
      "type": "lineHeight",
      "value": "16px"
    },
    "notifications.toast.description.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.small"
      }
    },
    "notifications.toast.description.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.regular"
      }
    },
    "notifications.toast.description.lineHeight": {
      "type": "lineHeight",
      "value": "16px"
    },
    "panel.container.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level100"
      }
    },
    "panel.container.padding": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.small"
      }
    },
    "panel.header.actions.padding": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.extraSmall"
      }
    },
    "panel.header.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level300"
      }
    },
    "panel.header.labelIcon.marginRight": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.small"
      }
    },
    "panel.header.minHeight": {
      "type": "length",
      "value": "40px"
    },
    "panel.header.paddingHorizontal": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.extraSmall"
      }
    },
    "panel.header.paddingVertical": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.extraExtraSmall"
      }
    },
    "panel.label.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "panel.label.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "panel.label.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "panel.label.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.regular"
      }
    },
    "panel.resize.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level300"
      }
    },
    "panel.resize.grip.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.icon.default"
      }
    },
    "progress.bar.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.black"
      },
      "transform": {
        "alpha": "0.05"
      }
    },
    "progress.bar.highlightColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.autodeskBlue400"
      }
    },
    "progress.bar.borderRadius": {
      "type": "borderRadius",
      "value": {
        "ref": "basics.borderRadii.medium"
      }
    },
    "progress.bar.minHeight": {
      "type": "length",
      "value": "4px"
    },
    "progressBar.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "progress.bar.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "progress.bar.backgroundColor"
        }
      }
    },
    "progressBar.highlightColor": {
      "type": "color",
      "value": {
        "ref": "progress.bar.highlightColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "progress.bar.highlightColor"
        }
      }
    },
    "progressBar.borderRadius": {
      "type": "borderRadius",
      "value": {
        "ref": "progress.bar.borderRadius"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "progress.bar.borderRadius"
        }
      }
    },
    "progressBar.height": {
      "type": "length",
      "value": {
        "ref": "progress.bar.minHeight"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "progress.bar.minHeight"
        }
      }
    },
    "progress.ring.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.black"
      },
      "transform": {
        "alpha": "0.05"
      }
    },
    "progress.ring.highlightColor1": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.600"
      }
    },
    "progress.ring.highlightColor2": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.400"
      }
    },
    "progressRing.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "progress.ring.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "progress.ring.backgroundColor"
        }
      }
    },
    "progressRing.highlightColor1": {
      "type": "color",
      "value": {
        "ref": "progress.ring.highlightColor1"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "progress.ring.highlightColor1"
        }
      }
    },
    "progressRing.highlightColor2": {
      "type": "color",
      "value": {
        "ref": "progress.ring.highlightColor2"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "progress.ring.highlightColor2"
        }
      }
    },
    "scrollbar.radii": {
      "type": "borderRadius",
      "value": {
        "ref": "basics.borderRadii.pill"
      }
    },
    "scrollbar.height": {
      "type": "length",
      "value": "5px"
    },
    "scrollbar.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.2
      }
    },
    "scrollbar.pressed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.5
      }
    },
    "segmentedButton.borderRadius": {
      "value": {
        "ref": "button.borderRadius"
      },
      "type": "borderRadius"
    },
    "segmentedButton.borderWidth": {
      "value": {
        "ref": "button.borderWidth"
      },
      "type": "borderWidth"
    },
    "segmentedButton.gutterWidth": {
      "value": {
        "ref": "button.gutterWidth"
      },
      "type": "length"
    },
    "segmentedButton.minWidth": {
      "value": {
        "ref": "button.minWidth"
      },
      "type": "length"
    },
    "segmentedButton.paddingHorizontal": {
      "value": {
        "ref": "button.paddingHorizontal"
      },
      "type": "spacing"
    },
    "segmentedButton.paddingVertical": {
      "value": {
        "ref": "button.paddingVertical"
      },
      "type": "spacing"
    },
    "segmentedButton.default.backgroundColor": {
      "value": {
        "ref": "button.outline.default.backgroundColor"
      },
      "type": "color"
    },
    "segmentedButton.hover.backgroundColor": {
      "value": {
        "ref": "button.outline.hover.backgroundColor"
      },
      "type": "color"
    },
    "segmentedButton.focus.backgroundColor": {
      "value": {
        "ref": "button.outline.focus.backgroundColor"
      },
      "type": "color"
    },
    "segmentedButton.pressed.backgroundColor": {
      "value": {
        "ref": "button.outline.pressed.backgroundColor"
      },
      "type": "color"
    },
    "segmentedButton.default.borderColor": {
      "value": {
        "ref": "button.outline.default.borderColor"
      },
      "type": "color"
    },
    "segmentedButton.hover.borderColor": {
      "value": {
        "ref": "button.outline.hover.borderColor"
      },
      "type": "color"
    },
    "segmentedButton.focus.borderColor": {
      "value": {
        "ref": "button.outline.focus.borderColor"
      },
      "type": "color"
    },
    "segmentedButton.pressed.borderColor": {
      "value": {
        "ref": "button.outline.pressed.borderColor"
      },
      "type": "color"
    },
    "segmentedButton.hover.haloWidth": {
      "value": {
        "ref": "button.hover.haloWidth"
      },
      "type": "borderWidth"
    },
    "segmentedButton.focus.haloWidth": {
      "value": {
        "ref": "button.haloWidth"
      },
      "type": "borderWidth"
    },
    "segmentedButton.pressed.haloWidth": {
      "value": {
        "ref": "button.pressed.haloWidth"
      },
      "type": "borderWidth"
    },
    "segmentedButton.hover.haloColor": {
      "value": {
        "ref": "button.hover.haloColor"
      },
      "type": "color"
    },
    "segmentedButton.focus.haloColor": {
      "value": {
        "ref": "button.focus.haloColor"
      },
      "type": "color"
    },
    "segmentedButton.pressed.haloColor": {
      "value": {
        "ref": "button.pressed.haloColor"
      },
      "type": "color"
    },
    "segmentedButton.default.iconColor": {
      "value": {
        "ref": "button.outline.iconColor"
      },
      "type": "color"
    },
    "segmentedButton.active.iconColor": {
      "value": {
        "ref": "colorScheme.surface.level250"
      },
      "type": "color"
    },
    "segmentedButton.active.backgroundColor": {
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "type": "color"
    },
    "segmentedButton.label.fontSize": {
      "value": {
        "ref": "button.label.fontSize"
      },
      "type": "fontSize"
    },
    "segmentedButton.label.default.fontColor": {
      "value": {
        "ref": "button.outline.label.fontColor"
      },
      "type": "color"
    },
    "segmentedButton.label.default.fontWeight": {
      "value": {
        "ref": "button.label.fontWeight"
      },
      "type": "fontWeight"
    },
    "segmentedButton.label.active.fontColor": {
      "value": {
        "ref": "basics.colors.text.againstDark"
      },
      "type": "color"
    },
    "segmentedButton.label.active.fontWeight": {
      "value": {
        "ref": "basics.fontWeights.bold"
      },
      "type": "fontWeight"
    },
    "sideNav.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "sideNav.container.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level100"
      }
    },
    "sideNav.account.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "sideNav.account.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.small"
      }
    },
    "sideNav.account.fontWeight": {
      "type": "fontWeight",
      "value": 500
    },
    "sideNav.account.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "basics.lineHeights.mediumExtraLarge"
      }
    },
    "sideNav.project.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "sideNav.project.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "sideNav.project.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.bold"
      }
    },
    "sideNav.project.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "basics.lineHeights.mediumExtraLarge"
      }
    },
    "sideNav.module.default.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "sideNav.module.default.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "sideNav.module.default.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.bold"
      }
    },
    "sideNav.module.default.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "basics.lineHeights.mediumExtraLarge"
      }
    },
    "sideNav.module.active.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.active"
      }
    },
    "sideNav.module.active.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "sideNav.module.active.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.bold"
      }
    },
    "sideNav.module.active.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "basics.lineHeights.mediumExtraLarge"
      }
    },
    "sideNav.subModule.default.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "sideNav.subModule.default.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "sideNav.subModule.default.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.regular"
      }
    },
    "sideNav.subModule.default.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "basics.lineHeights.mediumExtraLarge"
      }
    },
    "sideNav.subModule.active.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.active"
      }
    },
    "sideNav.subModule.active.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "sideNav.subModule.active.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.regular"
      }
    },
    "sideNav.subModule.active.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "basics.lineHeights.mediumExtraLarge"
      }
    },
    "sideNav.legal.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "sideNav.legal.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.small"
      }
    },
    "sideNav.legal.fontWeight": {
      "type": "fontWeight",
      "value": 500
    },
    "sideNav.legal.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "basics.lineHeights.mediumExtraExtraLarge"
      }
    },
    "sideNav.icon.defaultColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.text.againstLight"
      }
    },
    "sideNav.icon.activeColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.500"
      }
    },
    "sideNav.activeIndicator.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.accent"
      }
    },
    "skeletonItem.borderRadius": {
      "type": "borderRadius",
      "value": {
        "ref": "basics.borderRadii.medium"
      }
    },
    "skeletonItem.minHeight": {
      "type": "length",
      "value": {
        "ref": "density.spacings.medium"
      }
    },
    "skeletonItem.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.black"
      },
      "transform": {
        "alpha": 0.06
      }
    },
    "skeletonItem.highlightColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      },
      "transform": {
        "alpha": 0.3
      }
    },
    "skeletonItem.defaultHeight": {
      "type": "length",
      "value": {
        "ref": "skeletonItem.minHeight"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "skeletonItem.minHeight"
        }
      }
    },
    "slider.hover.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.halo.hover"
      }
    },
    "slider.focus.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.halo.focus"
      }
    },
    "slider.pressed.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.halo.pressed"
      }
    },
    "slider.hover.haloWidth": {
      "type": "length",
      "value": "2px"
    },
    "slider.focus.haloWidth": {
      "type": "length",
      "value": "2px"
    },
    "slider.pressed.haloWidth": {
      "type": "length",
      "value": "4px"
    },
    "slider.thumb.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.600"
      }
    },
    "slider.thumb.minWidth": {
      "type": "length",
      "value": "6px"
    },
    "slider.thumb.minHeight": {
      "type": "length",
      "value": "20px"
    },
    "slider.track.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.600"
      },
      "transform": {
        "alpha": 0.2
      }
    },
    "slider.track.minHeight": {
      "type": "length",
      "value": "2px"
    },
    "slider.value.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.600"
      }
    },
    "slider.inputOverlay.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.2
      }
    },
    "slider.halo.width": {
      "type": "length",
      "value": 0,
      "metadata": {
        "deprecated": {
          "equivalent": "slider.hover.haloWidth"
        }
      }
    },
    "slider.halo.color": {
      "type": "color",
      "value": {
        "ref": "slider.hover.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "slider.hover.haloColor"
        }
      }
    },
    "slider.thumb.width": {
      "type": "length",
      "value": {
        "ref": "slider.thumb.minWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "slider.thumb.minWidth"
        }
      }
    },
    "slider.focused.halo.color": {
      "type": "color",
      "value": {
        "ref": "slider.focus.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "slider.focus.haloColor"
        }
      }
    },
    "slider.focused.halo.width": {
      "type": "length",
      "value": {
        "ref": "slider.focus.haloWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "slider.focus.haloWidth"
        }
      }
    },
    "slider.focused.thumb.color": {
      "type": "color",
      "value": {
        "ref": "slider.thumb.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "slider.thumb.backgroundColor"
        }
      }
    },
    "slider.hover.halo.color": {
      "type": "color",
      "value": {
        "ref": "slider.hover.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "slider.hover.haloColor"
        }
      }
    },
    "slider.hover.halo.width": {
      "type": "length",
      "value": {
        "ref": "slider.hover.haloWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "slider.hover.haloWidth"
        }
      }
    },
    "slider.hover.thumb.color": {
      "type": "color",
      "value": {
        "ref": "slider.thumb.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "slider.thumb.backgroundColor"
        }
      }
    },
    "slider.pressed.halo.color": {
      "type": "color",
      "value": {
        "ref": "slider.pressed.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "slider.pressed.haloColor"
        }
      }
    },
    "slider.pressed.halo.width": {
      "type": "length",
      "value": {
        "ref": "slider.pressed.haloWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "slider.pressed.haloWidth"
        }
      }
    },
    "slider.pressed.thumb.color": {
      "type": "color",
      "value": {
        "ref": "slider.thumb.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "slider.thumb.backgroundColor"
        }
      }
    },
    "slider.track.color": {
      "type": "color",
      "value": {
        "ref": "slider.track.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "slider.track.backgroundColor"
        }
      }
    },
    "slider.track.width": {
      "type": "length",
      "value": {
        "ref": "slider.track.minHeight"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "slider.track.minHeight"
        }
      }
    },
    "slider.value.color": {
      "type": "color",
      "value": {
        "ref": "slider.value.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "slider.value.backgroundColor"
        }
      }
    },
    "stepIndicator.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "stepIndicator.borderWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.medium"
      }
    },
    "stepIndicator.minDiameter": {
      "type": "length",
      "value": "22px"
    },
    "stepIndicator.hover.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.halo.hover"
      }
    },
    "stepIndicator.focus.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.halo.focus"
      }
    },
    "stepIndicator.pressed.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.halo.pressed"
      }
    },
    "stepIndicator.hover.haloWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.medium"
      }
    },
    "stepIndicator.focus.haloWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.medium"
      }
    },
    "stepIndicator.pressed.haloWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.large"
      }
    },
    "stepIndicator.incomplete.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "stepIndicator.incomplete.borderColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.200"
      }
    },
    "stepIndicator.inProgress.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "stepIndicator.inProgress.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.accent"
      }
    },
    "stepIndicator.completed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.500"
      }
    },
    "stepIndicator.completed.iconColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      }
    },
    "stepIndicator.accordion.paddingHorizontal": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.medium"
      }
    },
    "stepIndicator.accordion.paddingVertical": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.large"
      }
    },
    "stepIndicator.connector.minWidth": {
      "type": "length",
      "value": "2px"
    },
    "stepIndicator.connector.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.200"
      }
    },
    "stepIndicator.connector.active.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.500"
      }
    },
    "stepIndicator.label.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "stepIndicator.label.default.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.regular"
      }
    },
    "stepIndicator.label.horizontal.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.spacings.small"
      }
    },
    "stepIndicator.label.horizontal.marginBottom": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.small"
      }
    },
    "stepIndicator.label.horizontal.marginTop": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.small"
      }
    },
    "stepIndicator.label.vertical.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "stepIndicator.label.vertical.marginLeft": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.small"
      }
    },
    "stepIndicator.label.inProgress.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.bold"
      }
    },
    "stepIndicator.number.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "stepIndicator.number.inProgress.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.active"
      }
    },
    "stepIndicator.number.inProgress.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.bold"
      }
    },
    "stepIndicator.number.incomplete.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      },
      "transform": {
        "alpha": 0.4
      }
    },
    "stepIndicator.number.incomplete.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.medium"
      }
    },
    "table.borderWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.small"
      }
    },
    "table.background.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level100"
      },
      "transform": {
        "alpha": 0.8
      }
    },
    "table.borderRightColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.divider.lightweight"
      }
    },
    "table.focus.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.halo.focus"
      }
    },
    "table.focus.haloWidth": {
      "type": "length",
      "value": {
        "ref": "basics.borderWidths.medium"
      }
    },
    "table.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "table.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "table.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "table.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "basics.lineHeights.mediumExtraLarge"
      }
    },
    "table.cell.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.regular"
      }
    },
    "table.cell.action.marginLeft": {
      "type": "length",
      "value": {
        "ref": "density.spacings.small"
      }
    },
    "table.cell.gutter": {
      "type": "length",
      "value": {
        "ref": "density.spacings.small"
      }
    },
    "table.cell.iconColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.icon.default"
      }
    },
    "table.cell.paddingHorizontal": {
      "type": "length",
      "value": {
        "ref": "density.spacings.medium"
      }
    },
    "table.cell.paddingVertical": {
      "type": "length",
      "value": {
        "ref": "density.spacings.extraExtraSmall"
      }
    },
    "table.cell.minHeight": {
      "type": "length",
      "value": "32px"
    },
    "table.frozenColumn.shadowBlur": {
      "type": "shadow",
      "value": {
        "ref": "basics.shadows.lowBlur"
      }
    },
    "table.frozenColumn.shadowColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.shadow.high"
      }
    },
    "table.cell.multiSelect.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.on.default"
      }
    },
    "table.cell.multiSelect.default.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.transparent"
      }
    },
    "table.cell.multiSelect.focus.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.on.focus"
      }
    },
    "table.cell.multiSelect.focus.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.accent"
      }
    },
    "table.cell.multiSelect.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.on.hover"
      }
    },
    "table.cell.multiSelect.hover.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.transparent"
      }
    },
    "table.cell.multiSelect.pressed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.on.pressed"
      }
    },
    "table.cell.multiSelect.pressed.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.transparent"
      }
    },
    "table.cell.null.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level300"
      }
    },
    "table.cell.selected.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "table.cell.selected.default.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.on"
      }
    },
    "table.cell.selected.focus.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "table.cell.selected.focus.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.accent"
      }
    },
    "table.cell.selected.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "table.cell.selected.hover.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.transparent"
      }
    },
    "table.cell.selected.pressed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "table.cell.selected.pressed.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.transparent"
      }
    },
    "table.cell.unselected.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "table.cell.unselected.default.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.transparent"
      }
    },
    "table.cell.unselected.focus.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "table.cell.unselected.focus.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.accent"
      }
    },
    "table.cell.unselected.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level100To250.hover"
      }
    },
    "table.cell.unselected.hover.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.transparent"
      }
    },
    "table.cell.unselected.pressed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level100To250.pressed"
      }
    },
    "table.cell.unselected.pressed.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.transparent"
      }
    },
    "table.header.minHeight": {
      "type": "length",
      "value": "40px"
    },
    "table.header.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level350"
      }
    },
    "table.header.iconColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.icon.default"
      }
    },
    "table.header.indicatorColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.indicator.default"
      }
    },
    "table.header.selected.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level100To250.pressed"
      }
    },
    "table.header.selected.default.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.transparent"
      }
    },
    "table.header.selected.focus.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level100To250.pressed"
      }
    },
    "table.header.selected.focus.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.accent"
      }
    },
    "table.header.unselected.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "table.header.unselected.default.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.transparent"
      }
    },
    "table.header.unselected.focus.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "table.header.unselected.focus.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.accent"
      }
    },
    "table.header.unselected.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level100To250.hover"
      }
    },
    "table.header.unselected.hover.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.transparent"
      }
    },
    "table.header.unselected.pressed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level100To250.pressed"
      }
    },
    "table.header.unselected.pressed.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.transparent"
      }
    },
    "table.header.default.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.regular"
      }
    },
    "table.header.selected.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.bold"
      }
    },
    "table.resize.hover.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.divider.heavyweight"
      }
    },
    "table.resize.pressed.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.accent"
      }
    },
    "table.row.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "table.row.checkbox.padding": {
      "type": "length",
      "value": {
        "ref": "density.spacings.extraSmall"
      }
    },
    "table.row.unselected.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "table.row.unselected.default.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.divider.lightweight"
      }
    },
    "table.row.unselected.focus.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "table.row.unselected.focus.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.accent"
      }
    },
    "table.row.unselected.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level100To250.hover"
      }
    },
    "table.row.unselected.hover.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.divider.lightweight"
      }
    },
    "table.row.unselected.pressed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level100To250.pressed"
      }
    },
    "table.row.unselected.pressed.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.divider.lightweight"
      }
    },
    "table.row.selected.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.on.default"
      }
    },
    "table.row.selected.default.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.on"
      }
    },
    "table.row.selected.focus.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.on.focus"
      }
    },
    "table.row.selected.focus.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.accent"
      }
    },
    "table.row.selected.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.on.hover"
      }
    },
    "table.row.selected.hover.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.on"
      }
    },
    "table.row.selected.pressed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.on.pressed"
      }
    },
    "table.row.selected.pressed.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.on"
      }
    },
    "table.row.drag.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level100"
      }
    },
    "table.row.drag.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.bold"
      }
    },
    "table.row.drag.iconColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.icon.default"
      }
    },
    "table.row.drag.gutter": {
      "type": "length",
      "value": {
        "ref": "density.spacings.medium"
      }
    },
    "table.row.drag.paddingLeft": {
      "type": "length",
      "value": {
        "ref": "density.spacings.extraExtraSmall"
      }
    },
    "table.row.drag.paddingRight": {
      "type": "length",
      "value": {
        "ref": "density.spacings.medium"
      }
    },
    "table.row.drag.paddingVertical": {
      "type": "length",
      "value": {
        "ref": "density.spacings.extraExtraSmall"
      }
    },
    "table.row.drag.shadowBlur": {
      "type": "shadow",
      "value": {
        "ref": "basics.shadows.lowBlur"
      }
    },
    "table.row.drag.shadowColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.shadow.low"
      }
    },
    "table.zebraStripe.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level350"
      },
      "transform": {
        "alpha": 0.2
      }
    },
    "table.item.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "table.cell.fontWeight"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "table.cell.fontWeight"
        }
      }
    },
    "table.row.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "table.row.unselected.hover.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "table.row.unselected.hover.backgroundColor"
        }
      }
    },
    "table.row.pressed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "table.row.unselected.pressed.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "table.row.unselected.pressed.backgroundColor"
        }
      }
    },
    "table.row.selected.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "table.row.selected.default.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "table.row.selected.default.backgroundColor"
        }
      }
    },
    "table.header.borderTopColor": {
      "type": "color",
      "value": {
        "ref": "table.row.unselected.default.borderColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "table.row.unselected.default.borderColor"
        }
      }
    },
    "table.header.borderBottomColor": {
      "type": "color",
      "value": {
        "ref": "table.row.unselected.default.borderColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "table.row.unselected.default.borderColor"
        }
      }
    },
    "tabs.focus.haloWidth": {
      "type": "length",
      "value": {
        "ref": "basics.borderWidths.medium"
      }
    },
    "tabs.focus.haloColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.500"
      },
      "transform": {
        "alpha": 0.5
      }
    },
    "tabs.label.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "tabs.label.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "tabs.label.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "typography.body.fontSize"
      }
    },
    "tabs.label.inactive.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.regular"
      }
    },
    "tabs.label.active.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.bold"
      }
    },
    "tabs.label.active.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "typography.body.lineHeight"
      }
    },
    "tabs.iconSize": {
      "type": "length",
      "value": {
        "ref": "density.spacings.large"
      }
    },
    "tabs.iconColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.icon.default"
      }
    },
    "tabs.iconGutter": {
      "type": "length",
      "value": {
        "ref": "density.spacings.small"
      }
    },
    "tabs.closeButton.minSize": {
      "type": "length",
      "value": {
        "ref": "basics.spacings.lowSmall"
      }
    },
    "tabs.closeButton.gutter": {
      "type": "length",
      "value": {
        "ref": "density.spacings.small"
      }
    },
    "tabs.closeButton.default.iconColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.icon.default"
      }
    },
    "tabs.closeButton.hover.iconColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.icon.hover"
      }
    },
    "tabs.closeButton.pressed.iconColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.icon.pressed"
      }
    },
    "tabs.underline.wrapper.borderBottomColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.35
      }
    },
    "tabs.underline.wrapper.borderBottomWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.small"
      }
    },
    "tabs.underline.tab.gutter": {
      "type": "length",
      "value": {
        "ref": "density.spacings.large"
      }
    },
    "tabs.underline.tab.paddingBottom": {
      "type": "length",
      "value": {
        "ref": "density.spacings.extraExtraSmall"
      }
    },
    "tabs.underline.hover.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.85
      }
    },
    "tabs.underline.active.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.accent"
      }
    },
    "tabs.box.wrapper.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "tabs.box.tab.paddingHorizontal": {
      "type": "length",
      "value": {
        "ref": "density.spacings.small"
      }
    },
    "tabs.box.tab.paddingVertical": {
      "type": "length",
      "value": {
        "ref": "density.spacings.extraSmall"
      }
    },
    "tabs.box.tab.active.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level100"
      }
    },
    "tabs.box.tab.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level100"
      },
      "transform": {
        "alpha": 0.5
      }
    },
    "tabs.box.divider.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.divider.heavyweight"
      }
    },
    "tabs.box.dividerWidth": {
      "type": "length",
      "value": {
        "ref": "divider.borderWidth"
      }
    },
    "tabs.box.dividerHeight": {
      "type": "length",
      "value": "18px"
    },
    "tabs.canvas.wrapper.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "tabs.canvas.tab.paddingHorizontal": {
      "type": "length",
      "value": {
        "ref": "density.spacings.medium"
      }
    },
    "tabs.canvas.tab.paddingVertical": {
      "type": "length",
      "value": {
        "ref": "density.spacings.extraSmall"
      }
    },
    "tabs.canvas.tab.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level200"
      },
      "transform": {
        "alpha": 0.5
      }
    },
    "tabs.canvas.tab.active.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level200"
      }
    },
    "tabs.canvas.divider.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.divider.heavyweight"
      }
    },
    "tabs.canvas.dividerWidth": {
      "type": "length",
      "value": {
        "ref": "divider.borderWidth"
      }
    },
    "tabs.canvas.dividerHeight": {
      "type": "length",
      "value": "18px"
    },
    "tabs.general.tab.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "tabs.label.fontFamily"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.label.fontFamily"
        }
      }
    },
    "tabs.general.tab.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "tabs.label.fontSize"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.label.fontSize"
        }
      }
    },
    "tabs.general.tab.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "tabs.label.inactive.fontWeight"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.label.inactive.fontWeight"
        }
      }
    },
    "tabs.general.tab.active.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "tabs.label.active.fontWeight"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.label.active.fontWeight"
        }
      }
    },
    "tabs.general.tab.color": {
      "type": "color",
      "value": {
        "ref": "tabs.label.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.label.fontColor"
        }
      }
    },
    "tabs.general.tab.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "tabs.label.active.lineHeight"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.label.active.lineHeight"
        }
      }
    },
    "tabs.general.halo.size": {
      "type": "length",
      "value": {
        "ref": "tabs.focus.haloWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.focus.haloWidth"
        }
      }
    },
    "tabs.general.halo.color": {
      "type": "color",
      "value": {
        "ref": "tabs.focus.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.focus.haloColor"
        }
      }
    },
    "tabs.general.icon.size": {
      "type": "length",
      "value": {
        "ref": "tabs.iconSize"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.iconSize"
        }
      }
    },
    "tabs.general.icon.color": {
      "type": "color",
      "value": {
        "ref": "tabs.iconColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.iconColor"
        }
      }
    },
    "tabs.general.icon.gutter": {
      "type": "length",
      "value": {
        "ref": "tabs.iconGutter"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.iconGutter"
        }
      }
    },
    "tabs.general.closeButton.size": {
      "type": "length",
      "value": {
        "ref": "tabs.closeButton.minSize"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.closeButton.minSize"
        }
      }
    },
    "tabs.general.closeButton.gutter": {
      "type": "length",
      "value": {
        "ref": "tabs.closeButton.gutter"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.closeButton.gutter"
        }
      }
    },
    "tabs.general.closeButton.color": {
      "type": "color",
      "value": {
        "ref": "tabs.closeButton.default.iconColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.closeButton.default.iconColor"
        }
      }
    },
    "tabs.general.closeButton.hover.color": {
      "type": "color",
      "value": {
        "ref": "tabs.closeButton.hover.iconColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.closeButton.hover.iconColor"
        }
      }
    },
    "tabs.general.closeButton.pressed.color": {
      "type": "color",
      "value": {
        "ref": "tabs.closeButton.pressed.iconColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.closeButton.pressed.iconColor"
        }
      }
    },
    "tabs.underline.halo.hover.color": {
      "type": "color",
      "value": {
        "ref": "tabs.underline.hover.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.underline.hover.haloColor"
        }
      }
    },
    "tabs.underline.halo.active.color": {
      "type": "color",
      "value": {
        "ref": "tabs.underline.active.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.underline.active.haloColor"
        }
      }
    },
    "tabs.box.tab.horizontalPadding": {
      "type": "length",
      "value": {
        "ref": "tabs.box.tab.paddingHorizontal"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.box.tab.paddingHorizontal"
        }
      }
    },
    "tabs.box.tab.verticalPadding": {
      "type": "length",
      "value": {
        "ref": "tabs.box.tab.paddingVertical"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.box.tab.paddingVertical"
        }
      }
    },
    "tabs.box.divider.color": {
      "type": "color",
      "value": {
        "ref": "tabs.box.divider.borderColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.box.divider.borderColor"
        }
      }
    },
    "tabs.box.divider.width": {
      "type": "length",
      "value": {
        "ref": "tabs.box.dividerWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.box.dividerWidth"
        }
      }
    },
    "tabs.box.divider.height": {
      "type": "length",
      "value": {
        "ref": "tabs.box.dividerHeight"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.box.dividerHeight"
        }
      }
    },
    "tabs.canvas.tab.horizontalPadding": {
      "type": "length",
      "value": {
        "ref": "tabs.canvas.tab.paddingHorizontal"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.canvas.tab.paddingHorizontal"
        }
      }
    },
    "tabs.canvas.tab.verticalPadding": {
      "type": "length",
      "value": {
        "ref": "tabs.canvas.tab.paddingVertical"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.canvas.tab.paddingVertical"
        }
      }
    },
    "tabs.canvas.divider.color": {
      "type": "color",
      "value": {
        "ref": "tabs.canvas.divider.borderColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.canvas.divider.borderColor"
        }
      }
    },
    "tabs.canvas.divider.width": {
      "type": "length",
      "value": {
        "ref": "tabs.canvas.dividerWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.canvas.dividerWidth"
        }
      }
    },
    "tabs.canvas.divider.height": {
      "type": "length",
      "value": {
        "ref": "tabs.canvas.dividerHeight"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tabs.canvas.dividerHeight"
        }
      }
    },
    "tag.borderWidth": {
      "type": "length",
      "value": {
        "ref": "basics.borderWidths.small"
      }
    },
    "tag.borderRadii": {
      "type": "borderRadius",
      "value": {
        "ref": "basics.borderRadii.pill"
      }
    },
    "tag.hover.haloWidth": {
      "type": "length",
      "value": {
        "ref": "basics.borderWidths.medium"
      }
    },
    "tag.focus.haloWidth": {
      "type": "length",
      "value": {
        "ref": "basics.borderWidths.large"
      }
    },
    "tag.paddingLeft": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.small"
      }
    },
    "tag.paddingRight": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.extraSmall"
      }
    },
    "tag.paddingVertical": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.extraSmall"
      }
    },
    "tag.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.15
      }
    },
    "tag.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.25
      }
    },
    "tag.focus.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.15
      }
    },
    "tag.pressed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.35
      }
    },
    "tag.default.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "tag.hover.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "tag.focus.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "tag.pressed.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "tag.focus.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.halo.focus"
      }
    },
    "tag.on.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.on.default"
      }
    },
    "tag.on.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level100To250.hover"
      }
    },
    "tag.on.focus.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.on.focus"
      }
    },
    "tag.on.pressed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level100To250.pressed"
      },
      "transform": {
        "alpha": 0.7
      }
    },
    "tag.on.default.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.on"
      }
    },
    "tag.on.hover.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.on"
      }
    },
    "tag.on.focus.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.accent"
      }
    },
    "tag.on.pressed.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.on"
      }
    },
    "tag.on.focus.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.halo.focus"
      }
    },
    "tag.label.marginRight": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.extraSmall"
      }
    },
    "tag.label.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "tag.label.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "tag.label.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "tag.label.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.medium"
      }
    },
    "tag.closeButton.iconColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      }
    },
    "textArea.minHeight": {
      "type": "length",
      "value": "250px"
    },
    "textArea.borderColor": {
      "type": "color",
      "value": {
        "ref": "input.borderColor"
      }
    },
    "textLink.focus.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.halo.focus"
      }
    },
    "textLink.focus.haloWidth": {
      "type": "length",
      "value": "2px"
    },
    "textLink.primary.default.fontColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.textLink.primary.againstLight"
      }
    },
    "textLink.primary.hover.fontColor": {
      "type": "color",
      "value": {
        "ref": "textLink.primary.default.fontColor"
      }
    },
    "textLink.primary.focus.fontColor": {
      "type": "color",
      "value": {
        "ref": "textLink.primary.default.fontColor"
      }
    },
    "textLink.primary.hover.underlineColor": {
      "type": "color",
      "value": {
        "ref": "textLink.primary.default.fontColor"
      }
    },
    "textLink.secondary.default.fontColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.textLink.secondary.againstLight"
      }
    },
    "textLink.secondary.hover.fontColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.textLink.secondary.againstLight"
      }
    },
    "textLink.secondary.focus.fontColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.textLink.secondary.againstLight"
      }
    },
    "textLink.secondary.hover.underlineColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.textLink.secondary.againstLight"
      }
    },
    "textLink.textColor": {
      "type": "color",
      "value": {
        "ref": "textLink.primary.default.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "textLink.primary.default.fontColor"
        }
      }
    },
    "textLink.hover.textColor": {
      "type": "color",
      "value": {
        "ref": "textLink.primary.hover.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "textLink.primary.hover.fontColor"
        }
      }
    },
    "textLink.focus.textColor": {
      "type": "color",
      "value": {
        "ref": "textLink.primary.focus.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "textLink.primary.focus.fontColor"
        }
      }
    },
    "textLink.hover.underline.color": {
      "type": "color",
      "value": {
        "ref": "textLink.primary.hover.underlineColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "textLink.primary.hover.underlineColor"
        }
      }
    },
    "textLink.focus.halo.color": {
      "type": "color",
      "value": {
        "ref": "textLink.focus.haloColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "textLink.focus.haloColor"
        }
      }
    },
    "textLink.focus.halo.width": {
      "type": "length",
      "value": {
        "ref": "textLink.focus.haloWidth"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "textLink.focus.haloWidth"
        }
      }
    },
    "tile.borderRadii": {
      "type": "borderRadius",
      "value": {
        "ref": "basics.borderRadii.none"
      }
    },
    "tile.borderWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.small"
      }
    },
    "tile.haloWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.large"
      }
    },
    "tile.padding": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.small"
      }
    },
    "tile.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "tile.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "tile.focus.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.halo.focus"
      }
    },
    "tile.thumbnail.marginRight": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.small"
      }
    },
    "tile.title.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "tile.title.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.medium"
      }
    },
    "tile.title.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "basics.lineHeights.highExtraLarge"
      }
    },
    "tile.title.marginBottom": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.extraSmall"
      }
    },
    "tile.subTitle.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.small"
      }
    },
    "tile.subTitle.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.regular"
      }
    },
    "tile.subTitle.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "basics.lineHeights.highMedium"
      }
    },
    "tile.default.level300To350BackgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      },
      "transform": {
        "alpha": 0.5
      }
    },
    "tile.hover.level300To350BackgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      },
      "transform": {
        "alpha": 0.7
      }
    },
    "tile.focus.level300To350BackgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      },
      "transform": {
        "alpha": 0.5
      }
    },
    "tile.pressed.level300To350BackgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      },
      "transform": {
        "alpha": 0.9
      }
    },
    "tile.selected.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.on.default"
      }
    },
    "tile.selected.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.on.hover"
      }
    },
    "tile.selected.focus.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.on.focus"
      }
    },
    "tile.selected.pressed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level100To250.pressed"
      }
    },
    "tile.selected.default.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.on"
      }
    },
    "tile.selected.hover.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.on"
      }
    },
    "tile.selected.focus.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.accent"
      }
    },
    "tile.selected.pressed.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.on"
      }
    },
    "tile.filled.default.level100To250.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.filled.level100To250.default"
      }
    },
    "tile.filled.hover.level100To250.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.filled.level100To250.hover"
      }
    },
    "tile.filled.focus.level100To250.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.filled.level100To250.focus"
      }
    },
    "tile.filled.pressed.level100To250.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.filled.level100To250.pressed"
      }
    },
    "tile.filled.default.level100To250.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "tile.filled.hover.level100To250.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "tile.filled.focus.level100To250.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "tile.filled.pressed.level100To250.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "tile.filled.default.level300To350.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.filled.level300To350.default"
      }
    },
    "tile.filled.hover.level300To350.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.filled.level300To350.hover"
      }
    },
    "tile.filled.focus.level300To350.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.filled.level300To350.focus"
      }
    },
    "tile.filled.pressed.level300To350.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.filled.level300To350.pressed"
      }
    },
    "tile.filled.default.level300To350.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "tile.filled.hover.level300To350.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "tile.filled.focus.level300To350.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "tile.filled.pressed.level300To350.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "tile.empty.default.level100To250.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "tile.empty.hover.level100To250.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level100To250.hover"
      }
    },
    "tile.empty.focus.level100To250.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "tile.empty.pressed.level100To250.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level100To250.pressed"
      }
    },
    "tile.empty.default.level100To250.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "tile.empty.hover.level100To250.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "tile.empty.focus.level100To250.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "tile.empty.pressed.level100To250.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "tile.empty.default.level300To350.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "tile.empty.hover.level300To350.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level300To350.hover"
      }
    },
    "tile.empty.focus.level300To350.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "tile.empty.pressed.level300To350.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level300To350.pressed"
      }
    },
    "tile.empty.default.level300To350.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "tile.empty.hover.level300To350.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level300To350.hover"
      }
    },
    "tile.empty.focus.level300To350.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "tile.empty.pressed.level300To350.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.empty.level300To350.pressed"
      }
    },
    "timestamp.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.dim"
      }
    },
    "timestamp.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "timestamp.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.small"
      }
    },
    "timestamp.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.regular"
      }
    },
    "timestamp.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "basics.fontSizes.highExtraLarge"
      }
    },
    "thumbnail.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.100"
      }
    },
    "thumbnail.borderColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.charcoal.600"
      },
      "transform": {
        "alpha": 0.5
      }
    },
    "toggle.borderRadii": {
      "type": "borderRadius",
      "value": {
        "ref": "basics.borderRadii.pill"
      }
    },
    "toggle.borderWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.small"
      }
    },
    "toggle.minHeight": {
      "type": "length",
      "value": "20px"
    },
    "toggle.minWidth": {
      "type": "length",
      "value": "37px"
    },
    "toggle.padding": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.extraExtraSmall"
      }
    },
    "toggle.hover.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.halo.hover"
      }
    },
    "toggle.focus.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.halo.focus"
      }
    },
    "toggle.pressed.haloColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.halo.pressed"
      }
    },
    "toggle.hover.haloWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.medium"
      }
    },
    "toggle.focus.haloWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.medium"
      }
    },
    "toggle.pressed.haloWidth": {
      "type": "borderWidth",
      "value": {
        "ref": "basics.borderWidths.large"
      }
    },
    "toggle.off.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "toggle.off.default.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.base"
      }
    },
    "toggle.off.hover.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "toggle.off.focus.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "toggle.off.pressed.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.background.transparent"
      }
    },
    "toggle.off.hover.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.base"
      }
    },
    "toggle.off.focus.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.accent"
      }
    },
    "toggle.off.pressed.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.border.base"
      }
    },
    "toggle.on.default.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.500"
      }
    },
    "toggle.on.default.borderColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.autodeskBlue.500"
      }
    },
    "toggle.thumb.borderRadii": {
      "type": "borderRadius",
      "value": {
        "ref": "basics.borderRadii.ellipse"
      }
    },
    "toggle.thumb.minDiameter": {
      "type": "length",
      "value": "12px"
    },
    "toggle.thumb.on.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      }
    },
    "toggle.thumb.off.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      }
    },
    "token.borderRadii": {
      "value": {
        "ref": "basics.borderRadii.none"
      },
      "type": "borderRadius"
    },
    "token.paddingLeft": {
      "value": {
        "ref": "density.spacings.extraSmall"
      },
      "type": "spacing"
    },
    "token.paddingRight": {
      "value": {
        "ref": "density.spacings.extraExtraSmall"
      },
      "type": "spacing"
    },
    "token.paddingVertical": {
      "value": {
        "ref": "density.spacings.extraExtraSmall"
      },
      "type": "spacing"
    },
    "token.default.backgroundColor": {
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.15
      },
      "type": "color"
    },
    "token.hover.backgroundColor": {
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.25
      },
      "type": "color"
    },
    "token.pressed.backgroundColor": {
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.35
      },
      "type": "color"
    },
    "token.default.borderColor": {
      "value": {
        "ref": "colorScheme.background.transparent"
      },
      "type": "color"
    },
    "token.hover.borderColor": {
      "value": {
        "ref": "colorScheme.background.transparent"
      },
      "type": "color"
    },
    "token.pressed.borderColor": {
      "value": {
        "ref": "colorScheme.background.transparent"
      },
      "type": "color"
    },
    "token.selected.default.backgroundColor": {
      "value": {
        "ref": "colorScheme.background.on.default"
      },
      "type": "color"
    },
    "token.selected.hover.backgroundColor": {
      "value": {
        "ref": "colorScheme.background.on.hover"
      },
      "type": "color"
    },
    "token.selected.pressed.backgroundColor": {
      "value": {
        "ref": "colorScheme.background.empty.level100To250.pressed"
      },
      "type": "color"
    },
    "token.selected.default.borderColor": {
      "value": {
        "ref": "colorScheme.border.on"
      },
      "type": "color"
    },
    "token.selected.hover.borderColor": {
      "value": {
        "ref": "colorScheme.border.on"
      },
      "type": "color"
    },
    "token.selected.pressed.borderColor": {
      "value": {
        "ref": "colorScheme.border.on"
      },
      "type": "color"
    },
    "token.warning.default.backgroundColor": {
      "value": {
        "ref": "colorScheme.status.warning"
      },
      "transform": {
        "alpha": 0.15
      },
      "type": "color"
    },
    "token.warning.hover.backgroundColor": {
      "value": {
        "ref": "colorScheme.status.warning"
      },
      "transform": {
        "alpha": 0.3
      },
      "type": "color"
    },
    "token.warning.iconColor": {
      "value": {
        "ref": "colorScheme.status.warning"
      },
      "type": "color"
    },
    "token.icon.marginRight": {
      "value": {
        "ref": "density.spacings.extraSmall"
      },
      "type": "spacing"
    },
    "token.label.fontColor": {
      "value": {
        "ref": "colorScheme.text.default"
      },
      "type": "color"
    },
    "token.label.fontFamily": {
      "value": {
        "ref": "basics.fontFamilies.main"
      },
      "type": "fontFamily"
    },
    "token.label.fontSize": {
      "value": {
        "ref": "density.fontSizes.medium"
      },
      "type": "fontSize"
    },
    "token.label.fontWeight": {
      "value": {
        "ref": "basics.fontWeights.medium"
      },
      "type": "fontWeight"
    },
    "token.label.marginRight": {
      "value": {
        "ref": "density.spacings.extraExtraSmall"
      },
      "type": "spacing"
    },
    "token.closeButton.iconColor": {
      "value": {
        "ref": "basics.colors.icon.lightGray"
      },
      "type": "color"
    },
    "tooltip.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.surface.darkGray.100"
      }
    },
    "tooltip.borderRadius": {
      "type": "borderRadius",
      "value": {
        "ref": "basics.borderRadii.medium"
      }
    },
    "tooltip.shadowBlur": {
      "type": "length",
      "value": {
        "ref": "basics.shadows.highBlur"
      }
    },
    "tooltip.shadowColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.shadow.high"
      }
    },
    "tooltip.title.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level200"
      }
    },
    "tooltip.title.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "tooltip.title.fontSize": {
      "type": "fontSize",
      "value": "12px"
    },
    "tooltip.title.fontWeight": {
      "type": "fontWeight",
      "value": 700
    },
    "tooltip.title.lineHeight": {
      "type": "lineHeight",
      "value": 1.333333333
    },
    "tooltip.nub.hypotenuseLength": {
      "type": "length",
      "value": "16px"
    },
    "tooltip.description.fontColor": {
      "type": "color",
      "value": "#F5F5F5"
    },
    "tooltip.description.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "tooltip.description.fontSize": {
      "type": "fontSize",
      "value": "12px"
    },
    "tooltip.description.fontWeight": {
      "type": "fontWeight",
      "value": 400
    },
    "tooltip.description.lineHeight": {
      "type": "lineHeight",
      "value": 1.333333333
    },
    "tooltip.divider.borderBottomColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.white"
      },
      "transform": {
        "alpha": 0.1
      }
    },
    "tooltip.textColor": {
      "type": "color",
      "value": {
        "ref": "tooltip.title.fontColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tooltip.title.fontColor"
        }
      }
    },
    "tooltip.borderColor": {
      "type": "color",
      "value": {
        "ref": "tooltip.backgroundColor"
      },
      "metadata": {
        "deprecated": {
          "equivalent": "tooltip.backgroundColor"
        }
      }
    },
    "topNav.padding": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.small"
      }
    },
    "topNav.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.surface.level100"
      }
    },
    "topNav.borderColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.divider.lightweight"
      }
    },
    "topNav.productLockupColor": {
      "type": "color",
      "value": {
        "ref": "basics.colors.primary.black"
      }
    },
    "topNav.hamburgetIcon.margin": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.extraSmall"
      }
    },
    "treeView.fontColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "treeView.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "treeView.indicatorColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.icon.hover"
      }
    },
    "treeView.icon.marginRight": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.extraSmall"
      }
    },
    "treeView.row.height": {
      "type": "length",
      "value": "40px"
    },
    "treeView.row.paddingHorizontal": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.small"
      }
    },
    "treeView.row.paddingVertical": {
      "type": "spacing",
      "value": {
        "ref": "density.spacings.extraSmall"
      }
    },
    "treeView.title.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "treeView.title.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.medium"
      }
    },
    "treeView.title.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "basics.lineHeights.mediumExtraLarge"
      }
    },
    "treeView.item.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "treeView.item.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.medium"
      }
    },
    "treeView.item.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "basics.lineHeights.mediumExtraLarge"
      }
    },
    "treeView.guideLine.backgroundColor": {
      "type": "color",
      "value": {
        "ref": "colorScheme.reference.base"
      },
      "transform": {
        "alpha": 0.5
      }
    },
    "typography.body.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "typography.body.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.regular"
      }
    },
    "typography.body.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.medium"
      }
    },
    "typography.body.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "basics.lineHeights.mediumExtraLarge"
      }
    },
    "typography.body.color": {
      "type": "lineHeight",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "typography.caption.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "typography.caption.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.regular"
      }
    },
    "typography.caption.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.small"
      }
    },
    "typography.caption.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "basics.lineHeights.mediumExtraExtraLarge"
      }
    },
    "typography.caption.color": {
      "type": "lineHeight",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "typography.h1.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "typography.h1.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.regular"
      }
    },
    "typography.h1.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.extraExtraLarge"
      }
    },
    "typography.h1.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "basics.lineHeights.mediumMedium"
      }
    },
    "typography.h1.color": {
      "type": "lineHeight",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "typography.h2.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "typography.h2.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.regular"
      }
    },
    "typography.h2.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.extraLarge"
      }
    },
    "typography.h2.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "basics.lineHeights.mediumSmall"
      }
    },
    "typography.h2.color": {
      "type": "lineHeight",
      "value": {
        "ref": "colorScheme.text.default"
      }
    },
    "typography.h3.fontFamily": {
      "type": "fontFamily",
      "value": {
        "ref": "basics.fontFamilies.main"
      }
    },
    "typography.h3.fontWeight": {
      "type": "fontWeight",
      "value": {
        "ref": "basics.fontWeights.medium"
      }
    },
    "typography.h3.fontSize": {
      "type": "fontSize",
      "value": {
        "ref": "density.fontSizes.large"
      }
    },
    "typography.h3.lineHeight": {
      "type": "lineHeight",
      "value": {
        "ref": "basics.lineHeights.mediumLarge"
      }
    },
    "typography.h3.color": {
      "type": "lineHeight",
      "value": {
        "ref": "colorScheme.text.default"
      }
    }
  }
};
const { metadata, resolvedRoles, unresolvedRoles } = themeData;
export { metadata, resolvedRoles, unresolvedRoles };
export default themeData;
